/**
 * This file is automatically generated from en.json by running 'bun run translate' and is
 * designed to prevent the use of misspelled or missing translation keys.
 *
 * If you need a string added here, add it to en.json, then run 'bun run translate' again
 * and the string will appear automatically.
 *
 * Questions?  Reach out to the Web Apps team.
 */

export const translations = {
  '*Required': '*Required',
  '404Header': 'Page not found.',
  '404Text':
    'The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.',
  about: 'About',
  About: 'About',
  abTestsAdmin: 'A/B Tests',
  abusiveContent: 'Abusive Content',
  academicHonestyDescription: 'Uphold the highest honesty and integrity in your academic endeavors.',
  academicHonestyPolicy: 'Academic Honesty Policy',
  academicHonestyTitle: 'Academic Honesty',
  acceptInvitation: 'Accept Invitation',
  access: 'Access',
  Account: 'Account',
  'Account is locked': 'Account is locked',
  accountCreationError: 'There was an error creating your account',
  accountDelete: 'Delete Account',
  accountDeleteConfirmationBody: 'You can cancel the deletion process by logging back in within 30 days',
  accountDeleteConfirmationHeader: 'Your account will be deleted in 30 days',
  accountDeletedEmail_bodyCopy: 'Thanks again for using Notability.',
  accountDeletedEmail_ctaButton: 'Take the survey',
  accountDeletedEmail_ctaLink: 'https://form.typeform.com/to/tM0CfUSQ',
  accountDeletedEmail_heroBody:
    'We’d love to know why you’re leaving. Feel free to share any thoughts or reflections you have about your Notability experience below -- we’re always looking for feedback!',
  accountDeletedEmail_heroHeading: 'Your account is scheduled for deletion',
  accountDeletedEmail_heroSubheading:
    'We’ve received your request to delete your Notability account. Your account, and all notes and data associated with it, will be permanently deleted in 30 days. You can cancel the deletion any time before then by signing back in, which restores your account and all of your data.',
  accountDeletedEmail_subject: 'Your account is scheduled for deletion',
  accountDeletedEmail_teamName: '— The Notability Team',
  accountDeleteModalBody: "This will un-share all notes you've shared.",
  accountDeleteModalHeader: 'Are you sure you want to delete your Notability account?',
  accountIsBlockedLoginError: 'Your account has been blocked. Please contact support.',
  accountIsLockedLoginError:
    'Your account has been locked. Please wait 15 minutes and try again, or reset your password to continue.',
  accountLockedEmailMessage:
    'Your Notability account has been locked after several unsuccessful login attempts.<br /><br />Please try <a href="%s">resetting your password</a> if you have forgotten it.',
  accountLockedEmailSubject: 'Your account has been locked',
  accountManagement: 'Manage Account',
  accountSignInOrCreate: "If you don't have an account, we'll create one for you.",
  actionItems: 'Action items',
  actions: 'Actions',
  activeAdmins: 'Active admins',
  activeMembers: 'Active members',
  activeUsersCount_one: '{{count, number}} active user',
  activeUsersCount_other: '{{count, number}} active users',
  addAComment: 'Add a comment',
  addAPhoto: 'Add a photo',
  addCaption: 'Add a caption...',
  addDivider: 'Add Divider',
  addDocumentsToNewNoteInstead: 'To work with these {{count}} documents, add them to a new note instead.',
  addDocumentToNewNoteInstead: 'To work with “{{fileName}}”, add it to a new note instead.',
  additionalContentRequired: 'Additional content required.',
  addPaymentMethod: 'Add payment method',
  addSubject: 'Add Subject',
  addText: 'Add text',
  addToNewNote: 'Add to new note',
  addToNote: 'Add to note',
  admin: 'Admin',
  adminBlockUser: 'Block User',
  adminChangeEmail: 'Change Email',
  adminChangeFlag: 'Flag/Unflag Note',
  adminChangeScreenname: 'Change Screenname',
  adminCommentConfirmReject: 'Reject Comment',
  adminCommentHistory: 'Comment History ({{numComments}})',
  adminCommentRejectionReasonTooLong: 'Comment rejection reasons must be under 500 characters long',
  adminCommentRejectReasonPlaceholder: 'Describe why this comment is being rejected',
  adminCommentTriagePageTitle: 'Comment Triage',
  adminCommentWhyReject: 'Why hide this comment from public view?',
  adminDemoteAdmin: 'Remove Admin Status',
  adminDisableAllDevices: 'Disable all devices for subscription',
  adminDisableAllDevicesConfirmationTitle:
    'Are you sure you want to disable all devices for transaction id: {{transactionId}} ',
  adminEditCurrentValue: 'Current',
  adminEditNewValue: 'New',
  adminEventViewFlaggedReason: 'Flagged for: {{reason}}',
  adminExperimentHeader: 'Experiment Groups',
  adminExperimentNone: 'None',
  adminGreeting: 'Hello {{user}}',
  adminHiddenCommentHistory: 'Banned Comments ({{numComments}})',
  adminHistory: 'Admin History',
  adminManagement: 'Admin Management',
  adminPageView: 'View as Admin',
  adminPortalOption: 'Admin Portal',
  adminProfileActiveFlags: 'Unreviewed Flags',
  adminProfileFlagHistory: 'Flagging Review History',
  adminProfileHeader: 'Admin Info',
  adminProfileRequestNewReview: 'Ready to Re-Review',
  adminProfileSetStatusClear: 'Clear Flagging Status',
  adminProfileSetStatusClearConfirmation:
    "This will return <1>{screenname}</1>'s hidden profile to public view.  Are you sure?",
  adminProfileStatus: 'Flagging/Review Status',
  adminProfileStatusBlocked: 'Blocked from Notability Web Services',
  adminProfileStatusClear: 'All Clear',
  adminProfileStatusFlagged: 'Flagged for review',
  adminProfileStatusHidden: 'Hidden from public view',
  adminPromoteAdmin: 'Make Administrator',
  adminPromoteNonEmployeeError: 'Only employees with verified emails can be promoted to admin.',
  adminReviewHiddenProfiles: 'Review Hidden Profiles',
  adminTools: 'Admin Tools',
  adminTriageNotes: 'Triage Notes',
  adminTriageProfiles: 'Triage Flagged Profiles',
  adminUnblockUser: 'Unblock User',
  adminUnhideUser: 'Unhide User',
  adminUpdateSuccessful: 'Update Successful',
  adminViewAsUser: 'View as User',
  agreeToTermsToContinue: 'You must agree to the Terms of Service in order to continue.',
  ai: 'AI',
  aiAppsSectionFooter:
    "Use your notes in Claude, ChatGPT, and other AI apps. They can search and read your notes, but can't change them.",
  aiAppsSectionHeader: 'AI apps',
  aiCustomization: 'AI Customization',
  aiDisabled: 'The User has disabled AI features on this account',
  aiUsage: 'AI usage',
  aiUsageAllowanceIncluded: 'Includes a basic AI allowance for quizzes, flashcards, transcription, and more.',
  aiUsageAllowanceMonthly: 'Includes a basic monthly AI allowance for quizzes, flashcards, transcription, and more.',
  aiUsageContactAdmin: 'Contact your admin to upgrade your plan.',
  aiUsageLimitDoesNotReset: 'This limit doesn’t reset.',
  aiUsageLimitLifetime: 'You’ve used all the AI usage included with your plan.',
  aiUsageLimitMonthly: 'You’ve reached your monthly AI usage limit. It resets on <0>{{date}}</0>.',
  aiUsageLimitUnknown: 'You’ve reached your AI usage limit.',
  aiUsageLimitUpgradeToPro: 'You’ve reached your AI usage limit. Upgrade to Pro.',
  aiUsagePercentUsed: '<0>{{percent}}%</0> used',
  aiUsageUpgradeToPlan: 'Upgrade to {{plan}}.',
  aiUsageUpsellLifetime:
    'You’ve used all the AI usage included with your plan. Upgrade to {{plan}} for unlimited AI usage.',
  aiUsageUpsellLifetimeContactAdmin:
    'You’ve used all the AI usage included with your plan. Contact your admin to upgrade your plan for unlimited AI usage.',
  aiUsageUpsellMonthly:
    'You’ve reached your monthly AI usage limit. It resets on {{date}}. Upgrade to {{plan}} for unlimited AI usage.',
  aiUsageUpsellMonthlyContactAdmin:
    'You’ve reached your monthly AI usage limit. It resets on {{date}}. Contact your admin to upgrade your plan for unlimited AI usage.',
  aiUsageUpsellUnknown: 'You’ve reached your AI usage limit. Upgrade to {{plan}} for unlimited AI usage.',
  aiUsageUpsellUnknownContactAdmin:
    'You’ve reached your AI usage limit. Contact your admin to upgrade your plan for unlimited AI usage.',
  align: 'Align',
  alignment: 'Alignment',
  All: 'All',
  'All Topics': 'All Topics',
  allCount: 'All {{count}}',
  allLanguages: 'All Languages',
  allMembersOfOrganizationNameAccessSharedLibrary:
    'All members of {{organizationName}} will be able to access this shared library.',
  allMembersOfWorkspaceNameWillLoseAccessToNoteName:
    'All members of {{workspaceName}} will lose access to "{{noteTitle}}".',
  allMembersOfWorkspaceNameWillLoseAccessToSubjectTitle:
    'All members of {{workspaceName}} will lose access to "{{subjectTitle}}" and all its contents.',
  allRemixes: 'All Remixes',
  'Already have an account': 'Already have an account?',
  alreadySignedUp: 'Already signed up?',
  amountOfHours: 'Amount of hours',
  analyticsNoticeApp:
    'Notability uses data from your user experience to improve experience for all users. We do not share this data with any third party. You may opt out at any time via Settings.',
  analyzingTranscripts: 'Analyzing Transcripts',
  analyzingYourNoteForKeyIdeas: 'Analyzing your note for key ideas...',
  android: 'Android',
  androidFormError: 'Something went wrong. Please try again.',
  androidHeroSubtitle: 'Take notes, record audio, and study with Notability on Android devices today.',
  androidPageTitle: 'Notability on Android',
  aNewInvitationEmailWillBeSentTo: 'A new invitation email will be sent to {{email}}.',
  aNoteHasBeenSharedWithYou: 'A note has been shared with you. Open it to take a look.',
  anyoneWithAccessToNotesWithinSubjectWillLoseAccess:
    'Anyone with access to notes within "{{subjectTitle}}" will lose access.',
  anyoneWithAccessToNoteWillLoseAccess: 'Anyone with access to "{{noteTitle}}" will lose access.',
  anyoneWithAccessToWorkspaceWillBeAbleToAccessNoteTitle:
    'Anyone with access to {{workspaceName}} will be able to access "{{noteTitle}}"',
  anyoneWithAccessToWorkspaceWillBeAbleToAccessSubjectTitle:
    'Anyone with access to {{workspaceName}} will be able to access "{{subjectTitle}}" and all its contents',
  anyoneWithTheLinkCanEdit: 'Anyone with the link can edit.',
  anyoneWithTheLinkCanView: 'Anyone with the link can view.',
  appleSubscriptionExplainer: 'Subscription managed by Apple, visit your Apple Account for more details.',
  applyImageEdits: 'Apply edits',
  appPageTitleSub: '{{pageTitle}} | Notability',
  appPerformance: 'App Performance',
  appReleases: 'Releases',
  approve: 'Approve',
  appsHeaderLink: 'Apps',
  appsPageTitle: 'Apps',
  Art: 'Art',
  asANonPaidUser: 'As a {{tierName}} user you get limited access to Pro features.',
  asrJobAlreadyProcessed: 'This transcription has already been processed.',
  asrJobAlreadyProcessing: 'This transcription is already being processed.',
  asrJobNoRequesterError: 'No requester was provided with the request.',
  asrJobNotFound: 'This transcription was not found. Please submit it to the creation API.',
  asrJobQuotaExceeded: "This transcription request exceeds the subscriber's quota limit.",
  attachImage: 'Attach image',
  attachmentTooLarge: 'This attachment must be smaller than {{sizeInMb}} MB.',
  attemptedEmailInDifferentBusiness:
    'The email you attempted to add to the workspace belongs to a user in a different business.',
  audio: 'Audio',
  audioRecording: 'Audio recording',
  audioRecordings: 'Audio recordings',
  audioRecordingsDescription: 'Record a lecture, podcast or video.',
  auditLogEmailModalBody: 'We will email your export to {{email}} when it is complete.',
  auditLogEmailModalTitle: 'Exporting audit log',
  auditLogExportCsv: 'Export as CSV',
  auditLogExportError: "We couldn't start your export. Please try again.",
  auditLogExporting: 'Exporting',
  auditLogRangeCaption: 'A record of activity across your organization for the last 90 days',
  auditLogSectionTitle: 'Audit log',
  authorAttribution: 'by',
  authTokenGenerationInvalidUserError: 'Cannot generate an auth token for an invalid user',
  auto: 'Auto',
  autoFlagBadword: 'Bad Word',
  autoFlagCopyright: 'Copyright',
  autoFlagEmailAddr: 'Email Address',
  autoFlagPhoneNumber: 'Phone Number',
  autoFlagRedFlagPhrase: 'Red Flag Phrase',
  autoFlagSSN: 'Social Security Number',
  autoFlagURL: 'URL',
  automaticSignInRefusedError: 'Automatic sign-in is only available for active accounts.',
  avatarClickToFind: 'Click to find',
  avatarPreviewHeader: 'Your avatar preview',
  avatarPreviewModalHeader: 'Avatar Preview',
  avatarSizeLimitError: 'Avatar images cannot be larger than {{sizeLimitMegabytes}} megabytes.',
  awaitingTriageTitle: 'Notes Awaiting Triage',
  awesome: 'Awesome!!',
  b2bBluebeamCompareAudioLabel: 'Record audio alongside your markup',
  b2bBluebeamCompareAudioThem: 'No native audio recording',
  b2bBluebeamCompareAudioUs: 'Capture the walkthrough as you draw',
  b2bBluebeamCompareCell: '{{verdict}} - {{detail}}',
  b2bBluebeamCompareCoEditLabel: 'Real-time co-editing of the same markup',
  b2bBluebeamCompareCoEditThem: 'Author-locked in Studio Sessions',
  b2bBluebeamCompareCoEditUs: 'Anyone with Edit access',
  b2bBluebeamCompareColBluebeam: 'Bluebeam Revu',
  b2bBluebeamCompareColCapability: 'Capability',
  b2bBluebeamCompareColNotability: 'Notability for Business',
  b2bBluebeamCompareDisclaimer:
    'Bluebeam is a trademark of its respective owner. Notability is not affiliated with, sponsored by, or endorsed by Bluebeam, Inc.',
  b2bBluebeamCompareInkLabel: 'Move, resize & rotate handwriting after you draw',
  b2bBluebeamCompareInkUs: 'Ink behaves like an object',
  b2bBluebeamCompareIntegrationsLabel: 'CAD & PDF engineering integrations',
  b2bBluebeamCompareIntegrationsThem: 'Extensive',
  b2bBluebeamCompareIntegrationsUs: 'Not the focus',
  b2bBluebeamCompareLimited: 'Limited',
  b2bBluebeamCompareMarkupLabel: 'Freehand pen & highlighter markup',
  b2bBluebeamCompareMarkupThem: 'Pen, Highlighter, Ruler, Select',
  b2bBluebeamCompareMarkupUs: 'Pen, Highlighter, Ruler, Select',
  b2bBluebeamCompareMeasureLabel: 'Measurement & takeoff depth',
  b2bBluebeamCompareMeasureThem: 'Deep measurement tools',
  b2bBluebeamCompareMeasureUs: 'Markup, not takeoff',
  b2bBluebeamCompareNo: 'No',
  b2bBluebeamComparePriceLabel: 'Price per user, per year',
  b2bBluebeamComparePriceThem: 'Starts at $260',
  b2bBluebeamComparePriceUs: 'Starts at $60',
  b2bBluebeamCompareTitle: 'Where we win, and where Bluebeam leads.',
  b2bBluebeamCompareYes: 'Yes',
  b2bBluebeamDifferenceCoEditDesc:
    'In a Shared Library, anyone with Edit access works in the same note in real time. In a Bluebeam Studio Session, each markup stays locked to its author, so a teammate cannot move or edit it.',
  b2bBluebeamDifferenceCoEditTitle: 'Live co-editing, not author-locked',
  b2bBluebeamDifferenceInkDesc:
    'Draw with Apple Pencil, then move, resize, rotate and regroup any markup after the fact. Your ink is an object you can rearrange, not a stroke you are stuck with.',
  b2bBluebeamDifferenceInkTitle: 'Handwriting that moves like paper',
  b2bBluebeamDifferencesSub:
    'Bluebeam has a real pen. Where Notability pulls ahead is what happens after you draw, and who can work on the drawing with you.',
  b2bBluebeamDifferencesTitle: 'Bluebeam makes two things hard — we make them easy.',
  b2bBluebeamFAQCostAnswer:
    'Notability for Business is $60 per user, per year. Business Pro is $180. Bluebeam Revu runs about $260 to $590 per user, per year, so Notability is roughly 4 to 10 times less. Every plan starts with a 30-day free trial.',
  b2bBluebeamFAQCostQuestion: 'How much does it cost compared to Bluebeam?',
  b2bBluebeamFAQDifferentAnswer:
    'Notability is an iPad-native markup tool. Two things it does that Bluebeam makes harder: handwriting you can move, resize and rotate after you draw it, and real-time co-editing where anyone with Edit access works in the same note. In a Bluebeam Studio Session, markups stay locked to their author. Bluebeam still leads on measurement, takeoff and CAD depth, so treat Notability as a plan-markup tool, not a full replacement.',
  b2bBluebeamFAQDifferentQuestion: 'How is this different from Bluebeam?',
  b2bBluebeamFAQOfflineAnswer:
    'Notability is native on iPad, iPhone, Mac and web, and Apple Pencil is a first-class input. Mark up on site and your work syncs when you are back online.',
  b2bBluebeamFAQOfflineQuestion: 'Does it work on iPad, and offline?',
  b2bBluebeamFAQStorageAnswer:
    'Your notes live in Notability Cloud, and you can back up and sync to OneDrive, Google Drive, Dropbox and Box. Import and export keep your files where your team already works.',
  b2bBluebeamFAQStorageQuestion: 'Where are my files stored?',
  b2bBluebeamFAQTeamEditAnswer:
    'Yes. Add a note to a Shared Library and anyone with Edit access can work on it in real time. You grant View or Edit on any library or note, and Owner, Admin and Member roles handle team administration.',
  b2bBluebeamFAQTeamEditQuestion: 'Can my whole team edit the same markup?',
  b2bBluebeamFAQTrialAnswer:
    'Yes, 30 days, no card to start. It is the fastest way to see whether Notability fits how your team marks up plans.',
  b2bBluebeamFAQTrialQuestion: 'Is there a free trial?',
  b2bBluebeamFeatureAuditLogDesc: "See who changed what across your team's content.",
  b2bBluebeamFeatureAuditLogTitle: 'Audit Log',
  b2bBluebeamFeatureComingSoon: 'Coming soon',
  b2bBluebeamFeatureDocumentsDesc:
    'Import floor plans, site maps, change-order sketches, PDFs, DOCs and slides. Annotate on the spot with Pen, Highlighter, Ruler and Select.',
  b2bBluebeamFeatureDocumentsTitle: 'Markup on any document',
  b2bBluebeamFeatureHandwritingDesc:
    'Move, resize, rotate and regroup handwritten markups after you draw them. Reorganize a busy sheet in seconds.',
  b2bBluebeamFeatureHandwritingTitle: 'Handwriting that moves',
  b2bBluebeamFeatureLibrariesDesc:
    'Teammates work in the same note in real time. Grant View or Edit access on any library or note.',
  b2bBluebeamFeatureLibrariesTitle: 'Shared Libraries',
  b2bBluebeamFeatureMeasurementDesc: 'Easily measure and record length and area directly on your notes.',
  b2bBluebeamFeatureMeasurementTitle: 'Scale of Measurement',
  b2bBluebeamFeaturePermissionsDesc:
    'Flexible View/Edit permissions on every library and note, plus Owner, Admin and Member roles for team administration.',
  b2bBluebeamFeaturePermissionsTitle: 'Permissions & roles',
  b2bBluebeamFeaturesTitle: 'Everything you need to mark up plans on site.',
  b2bBluebeamHeroCTAPrimary: 'Start free trial',
  b2bBluebeamHeroSub:
    'Handwriting that moves like paper. Live co-editing your whole crew can join. Native on iPad, iPhone, Mac and web.',
  b2bBluebeamHeroTitle: 'Mark up your plans on iPad. Skip the Bluebeam price tag.',
  b2bBluebeamPageTitle: 'Bluebeam Alternative for iPad Plan Markup',
  b2bBluebeamPricingTitle: 'Start marking up plans the iPad way.',
  b2bBluebeamUpdatesPlaceholder: 'you@company.com',
  b2bBluebeamUpdatesSubmit: 'Sign up',
  b2bBluebeamUpdatesTitle: 'Get product updates as we ship.',
  b2bBluebeamWorkflowImportDesc: 'Pull the latest PDF from email or cloud storage straight into a note.',
  b2bBluebeamWorkflowImportTitle: 'Import the plan set',
  b2bBluebeamWorkflowMarkupDesc: 'Redline with Apple Pencil, drop a revision cloud, measure with the Ruler.',
  b2bBluebeamWorkflowMarkupTitle: 'Mark it up on site',
  b2bBluebeamWorkflowRearrangeDesc: 'Move, resize and regroup markups as scope shifts. No erasing and redrawing.',
  b2bBluebeamWorkflowRearrangeTitle: 'Rearrange as it changes',
  b2bBluebeamWorkflowShareDesc: 'Add the note to a Shared Library so the team co-edits the same markup live.',
  b2bBluebeamWorkflowShareTitle: 'Share with the crew',
  b2bBluebeamWorkflowTitle: 'How a field lead runs plan markup.',
  b2bConstructionBigQuoteAttr: 'Daniel Johnson - VULCAN MATERIALS CO',
  b2bConstructionBigQuoteText:
    'A no-brainer for any business wanting to digitally transform fieldwork and streamline operations.',
  b2bConstructionFeaturesTitle: 'Built for how field crews <Highlight>work.</Highlight>',
  b2bConstructionHeroSub:
    'Be confident from sales to build. Notability for Business lets construction teams capture site notes, annotate plans, and sync field documentation instantly. Office staff can see updates and respond in real time.',
  b2bConstructionHeroTitle: 'Work together from the field and the office in real time',
  b2bConstructionQuoteLearnMore: 'Learn more',
  b2bConstructionUCDailylogDesc:
    "Keep plans, change orders, inspection photos, and client sign-offs in Shared Libraries your whole team can access from any device. Your office admin sees what the crew captured the moment it's saved.",
  b2bConstructionUCDailylogTitle: 'Everything for the job, in one place',
  b2bConstructionUCMeasureDesc:
    'Calibrate the scale from any known dimension, then measure lengths and areas directly on your drawings. Switch between feet, inches, meters, and more, and copy any result with a tap.',
  b2bConstructionUCMeasureTitle: 'Measure right on the plan',
  b2bConstructionUCPlansDesc:
    'Import your floor plans, site maps, or change order sketches directly into Notability and annotate with your Apple Pencil on the spot. Circle conflicts, add dimensions, and share your markups with the GC or homeowner before you leave the site. No scanning, no back-and-forth emails.',
  b2bConstructionUCPlansTitle: 'Capture site details as you work',
  b2bConstructionUCRfisDesc:
    'Document issues exactly where they occur by circling conflicts, measuring gaps, and attaching photos. Draft your RFI before leaving the site and share it instantly with the architect, owner, or general contractor.',
  b2bConstructionUCRfisTitle: 'Resolve issues on the spot',
  b2bConstructionUCSafetyDesc:
    'Record and auto-transcribe OAC meetings, subcontractor walkthroughs, and coordination calls. Notability AI generates summaries and action items so nothing falls through the cracks between the field and the office.',
  b2bConstructionUCSafetyTitle: 'Reports that hold up when it matters',
  b2bFAQHelpCenter: 'Visit our Help Center',
  b2bFAQMoreQuestions: 'Have more questions?',
  b2bFAQNewFeaturesAnswer:
    'Notability for Business is for teams looking to collaborate together. It includes the features you know and love like unlimited note edits, audio recording, and new features like Shared Libraries to easily share and collaborate on notes with your team. In addition, it includes an admin panel to manage billing, users, and settings for your organization.',
  b2bFAQNewFeaturesAnswerV2:
    'Notability for Business is built upon the core Notability experience, including the same features you know and love like handwriting, document mark up, and audio recording. It also introduces centralized user management and billing, Shared Libraries for easy sharing and collaboration, and AI tools for professionals.',
  b2bFAQNewFeaturesQuestion: 'What features are included in Notability for Business?',
  b2bFAQNewGetStartedAnswer:
    'To get started, create a Notability account and select either the Business or Business Pro plan.',
  b2bFAQNewGetStartedAnswerV2:
    "To get started, click Unlock below your choice of <businessPlans>business plans</businessPlans>. You'll be prompted to sign in or create an account, then create your business. For any questions, contact <email>sales@notability.com</email>",
  b2bFAQNewGetStartedQuestion: 'How do I get started?',
  b2bFAQNewMDMAnswer:
    "Yes! Notability for Business does not require an MDM and is not tied to individual devices. If you're interested in using an MDM solution with Notability, please reach out to us at <email>sales@notability.com</email> or <submitLink>submit a request</submitLink>.",
  b2bFAQNewMDMQuestion: 'Can I deploy Notability for Business without using a Mobile Device Management (MDM) solution?',
  b2bFAQNewPaymentAnswer:
    'Yes. You can pay with other payment types. Contact <email>sales@notability.com</email> to learn more about payment options.',
  b2bFAQNewPaymentAnswerV2:
    'In addition to credit card and bank linking, Notability for Business supports other payment methods, including invoicing, bank transfers, wire transfers, and more. Contact <email>sales@notability.com</email> to learn more about payment options.',
  b2bFAQNewPaymentQuestion: 'Can I pay for the subscription other than using a credit card?',
  b2bFAQNewPaymentQuestionV2: 'What payment methods are available for Notability for Business?',
  b2bFAQNewSecureAnswer:
    "Yes. We take the protection of our customers' data very seriously, and that's why we are proud to be SOC 2 certified. If you want to learn more about our security, you can visit our <trustLink>trust center</trustLink>.",
  b2bFAQNewSecureQuestion: 'Is Notability for Business secure?',
  b2bFAQTitle: 'FAQ',
  b2bFeatureAIDesc:
    'Get more from your notes with AI-powered summaries, search, and chat. Uncover deeper insights and instantly surface important topics, action items, and key takeaways, right when you need them.',
  b2bFeatureAITitle: 'Enhance your work with AI',
  b2bFeatureAudioDesc:
    'Get more out of every meeting. Take notes while Notability records, transcribes, and delivers real-time summaries and key action items, so decisions are clear and next steps are captured instantly.',
  b2bFeatureAudioTitle: 'Instant meeting notes',
  b2bFeatureHandwritingDesc:
    "From quick sketches to detailed diagrams, brainstorm freely with handwriting that feels natural. Capture concepts that typing can't, and turn raw ideas into something real.",
  b2bFeatureHandwritingTitle: 'The power of handwriting',
  b2bFeatureOrganizedDesc:
    'Share notes and folders with your team. Write, sketch, and build ideas together in real time, wherever work happens.',
  b2bFeatureOrganizedTitle: 'Work together in real time',
  b2bFeaturesTitle: 'Built for <Highlight>business</Highlight>',
  b2bFeatureWorksYourWayDesc:
    'One tool to help teams move faster. Import and annotate documents, record audio with transcripts, and instantly generate summaries and action items. Combine typed notes, handwriting, sketches, and highlights in one place, then share everything seamlessly with your team.',
  b2bFeatureWorksYourWayTitle: 'Notability works the way you do',
  b2bGoToTestimonial: 'Go to testimonial {{index}}',
  b2bHeroCTAPrimary: 'Try Notability for Business',
  b2bHeroCTASecondary: 'Talk to a team member',
  b2bHeroCTASeparator: 'or',
  b2bHeroDescription:
    'Notability is a modern note-taking system for teams. Capture notes, mark up documents, record and transcribe meetings, collaborate in real time and sign contracts while staying organized across teams and devices.',
  b2bHeroTitle: "Turn your team's notes into <Highlight>clarity,</Highlight> captured in real time",
  b2bLawBigQuoteAttr: 'Sarah, Executive Assistant — Notability for Business User',
  b2bLawBigQuoteText: 'I can quickly mark up documents and leave clear comments.',
  b2bLawFeaturesTitle: 'Built for the way law firms <Highlight>work</Highlight>',
  b2bLawHeroSub:
    'Attorneys already use Notability. Now their firm can too with shared document libraries, meeting transcripts, and AI tools built for the pace of legal work.',
  b2bLawHeroTitle: 'One digital record for every intake, handoff and agreement',
  b2bLawUCAgreementsDesc:
    'Simplify the entire signing process with a single tool. From securing signatures in person to instantly delivering copies to clients, you can finalize and distribute agreements seamlessly within the same app.',
  b2bLawUCAgreementsTitle: 'Client and Attorney agreements',
  b2bLawUCDepositionDesc:
    'Testimony, your analysis, and the evidence captured together on one page, in the moment. Never lose what was actually said. Replay any moment side by side with your notes.',
  b2bLawUCDepositionTitle: 'Deposition Ready',
  b2bLawUCHandoffDesc:
    'Shared Libraries give your teams the latest version of every document, note, and update without you having to send a single email. The attorney captures and the team accesses everything in real time with zero forwarding from the iPad on the go to the desktop in the office.',
  b2bLawUCHandoffTitle: 'Attorney-to-staff handoff',
  b2bLawUCIntakeDesc:
    'Be fully present with your client while Notability captures everything. Record the consultation, take handwritten notes alongside the audio, and walk out with a searchable, AI-summarized record of every commitment made and every detail shared.',
  b2bLawUCIntakeTitle: 'Client intakes and consultations',
  b2bLicenseKeyReminderEmailMessage:
    'We noticed that you currently have no active licenses. To get started, you can log in to your Admin Panel below and follow the instructions to set up your app configuration for license key distribution. If you have any questions, feel free to reach out to businesssupport@gingerlabs.com.',
  b2bLicenseKeyReminderEmailSubject: 'License Key Deployment',
  b2bLogosAriaLabel: 'Companies that use Notability',
  b2bLogosLabel: 'Business thrives on Notability',
  b2bOrgApprovedEmailSubject: 'Welcome to Notability for Business',
  b2bOrgRejectedEmailMessage:
    'Your request to enroll for {{orgName}} was not approved. {{rejectionReason}} Please contact businesssupport@gingerlabs.com for more details.',
  b2bPricingSeeAllPlans: 'See all plans',
  b2bPricingTitle: 'Get started with Notability for Business',
  b2bQuote1: 'A no-brainer for any business wanting to digitally transform fieldwork and streamline operations.',
  b2bQuote1Subtitle: 'VULCAN MATERIALS CO',
  b2bQuote2: 'I can quickly mark up documents and leave clear comments.',
  b2bQuote2Subtitle: 'SARAH, EXECUTIVE ASSISTANT',
  b2bQuote3: 'A game changer for handwritten notes, teaching, and professional work.',
  b2bQuote3Subtitle: 'CONNOR, NOTABILITY BUSINESS USER',
  b2bReceiptLinkEmailActionButton: 'Download Receipt',
  b2bReceiptLinkEmailMessage:
    'Your subscription has been updated. View and download your receipt and invoice using this <a href="%s">link</a>.',
  b2bSecurityAdminControlsDesc: 'No LLM training on customer data',
  b2bSecurityAdminControlsTitle: 'AI Safety Controls',
  b2bSecurityBadgeGdprAlt: 'GDPR Compliant',
  b2bSecurityBadgeSoc2Alt: 'SOC 2 Certified',
  b2bSecurityDedicatedSupportDesc: 'Professional deployment and scaling support',
  b2bSecurityDedicatedSupportTitle: 'Dedicated Support',
  b2bSecurityGlobalComplianceDesc: 'GDPR and SOC2 certified',
  b2bSecurityGlobalComplianceTitle: 'Global Compliance',
  b2bSecurityReadMore: 'Read more at trust.notability.com',
  b2bSecuritySecurityDesc: 'Industry standard data privacy and security',
  b2bSecuritySecurityTitle: 'Security',
  b2bSecurityTitle: 'Built for <Highlight>security</Highlight>',
  b2bShareModalUpsellBody:
    'Notability for Business gives you Shared Libraries, admin controls, and team collaboration.',
  b2bShareModalUpsellLearnMore: 'Learn more',
  b2bShareModalUpsellTitle: 'Working with a team?',
  b2bSportsBigQuoteAttr: "Coach Christopher Hamblin, Harvard Women's Soccer",
  b2bSportsBigQuoteText:
    '“It saves time and steps. It helps us be intentional about athlete development, which has streamlined our process immensely.”',
  b2bSportsFeaturesTitle: 'Every tool modern coaching staffs <Highlight>need.</Highlight>',
  b2bSportsHeroSub:
    'Notability for Business gives coaching staff one workspace to fill out recruitment forms, sketch plays, annotate film stills, and share game plans instantly with athletes—so every team member, from the booth to the sideline, is working from the same call sheet.',
  b2bSportsHeroTitle: 'The digital whiteboard that fits in your bag',
  b2bSportsQuoteVideoTitle: "Harvard Women's Soccer case study",
  b2bSportsSecurityDesc:
    'Your formations and game plans are proprietary. Notability is SOC 2 Type II certified. Your data is never trained by any AI models, so your competitive strategy stays in-house, not in a training dataset.',
  b2bSportsSecurityTitle: 'Your playbook stays yours',
  b2bSportsUCAdjustDesc:
    'Sketch halftime adjustments on the sideline and share them to the press box or coordinator before the team comes off the field. Your iPad is the fastest whiteboard in the building and it fits in a jacket pocket.',
  b2bSportsUCAdjustTitle: 'Real time adjustments',
  b2bSportsUCAnnotateDesc:
    'Import screenshots from film and draw player paths, coverage gaps, and blocking assignments directly on the image. Record a voice explanation synced to the diagram. Your annotated breakdown is ready to share with the position group before the session ends.',
  b2bSportsUCAnnotateTitle: 'Annotate footage directly',
  b2bSportsUCDrawDesc:
    'Sketch routes, formations, and adjustments on a blank canvas or on top of imported field templates. Shape detection snaps circles and arrows into clean diagrams. Color-code by position group. Iterate in seconds, not minutes. Your handdrawn play becomes a shareable asset instantly.',
  b2bSportsUCDrawTitle: 'Draw as you see it',
  b2bSportsUCPrepDesc:
    'Send individualized prep notes containing route trees, defensive tendencies, scouting reports directly to each player through Shared Libraries. Athletes can add their own notes, questions, and observations back. The preparation loop closes before game day.',
  b2bSportsUCPrepTitle: 'Personalized athlete prep',
  b2bTestimonialNavigation: 'Testimonial navigation',
  b2bWealthManagementFeaturesTitle: 'Built for how advisors <Highlight>actually</Highlight> work.',
  b2bWealthManagementHeroSub:
    "Notability for Business gives advisors one workspace to run discovery meetings, mark up statements and plans, and capture decisions as they're made on the same note.",
  b2bWealthManagementHeroTitle: "Your client's plan, built in front of them, not after",
  b2bWealthManagementUCFirstMeetingDesc:
    'Import your discovery questionnaire and type notes as the client talks through goals, family, retirement, and legacy. Annotate documents as you record to ensure no details are missed.',
  b2bWealthManagementUCFirstMeetingTitle: 'Be present in the first meeting',
  b2bWealthManagementUCMarkupDesc:
    "Walk clients through the plan and highlight decisions as you make them. Highlight the action items and add the next steps in front of them, so they leave with clarity. Decisions captured the moment they're made.",
  b2bWealthManagementUCMarkupTitle: 'Mark up the plan together',
  b2bWealthManagementUCPlanDesc:
    "Pull statements, portfolio reports, and an allocation chart into a single note. Highlight the figures that matter using our AI smart notes, draw a call-out on the decision, and keep your thinking next to the numbers it's based on.",
  b2bWealthManagementUCPlanTitle: 'Build the plan on one page',
  b2bWealthManagementUCSyncDesc:
    "Keep every client's plan, statement, and meeting note in a Shared Library. The moment one advisor saves an update, the rest of the team has it. No forwarding, no resending last week's notes to stay aligned.",
  b2bWealthManagementUCSyncTitle: 'Keep every advisor in sync',
  Back: 'Back',
  backgroundColor: 'Background',
  backToNotability: 'Back to Notability',
  badJWT: 'You have been logged out.',
  badRequest: 'Malformed request',
  bannerBrowseTag: 'Browse all new <1>{{tag}}</1> notes.',
  beAwesomeDescription: 'Everyone should feel welcome to participate without fear of harassment or bullying.',
  beAwesomeTitle: 'Be Awesome',
  beginTest: 'Begin test',
  beta: 'Beta',
  billing: 'Billing',
  bio: 'Bio',
  bioEditHint: 'Add a blurb to introduce yourself!',
  bioTooLongError: 'Bio must be fewer than {{maxLength}} characters long.',
  blockedAccountLoginError: 'This account has been locked',
  blockedUserFlagError:
    'Your account is under review, during which you cannot flag Gallery content.  Contact Notability customer service.',
  blockedUserFlagNoteError: 'Blocked user cannot flag notes',
  blockedUserLikeNoteError: 'Blocked user cannot like notes',
  blockedUserPublishError: 'Blocked user cannot publish notes',
  blockedUserUnlikeNoteError: 'Blocked user cannot unlike notes',
  blockedUserUploadError: 'Blocked user cannot upload notes',
  blockQuote: 'Block quote',
  blockquotePlaceholder: 'Quote',
  blogFooterAlt: 'Notability Blog link',
  body: 'Body',
  bold: 'Bold',
  brainBreakCompleteBody:
    "You've completed today's Daily Brain Break. Check back tomorrow for a brand new puzzle with a harder difficulty.",
  brainBreakCompleteCtaContinueBody: 'Pick up where you left off in “{{noteName}}”.',
  brainBreakCompleteCtaContinueMemorize: 'Keep memorizing',
  brainBreakCompleteCtaContinueMemorizeTitle: 'Ready to keep memorizing?',
  brainBreakCompleteCtaContinuePractice: 'Keep practicing',
  brainBreakCompleteCtaContinuePracticeTitle: 'Ready to keep practicing?',
  brainBreakCompleteCtaContinueQuiz: 'Continue quiz',
  brainBreakCompleteCtaContinueQuizBody: 'Continue studying “{{noteName}}” now.',
  brainBreakCompleteCtaContinueQuizTitle: 'Ready to keep going?',
  brainBreakCompleteCtaCreateFirstNote: 'Create note',
  brainBreakCompleteCtaCreateFirstNoteBody: 'Your library’s empty — let’s fix that.',
  brainBreakCompleteCtaCreateFirstNoteTitle: 'Time to make your first note',
  brainBreakCompleteCtaStartLearning: 'Start learning',
  brainBreakCompleteCtaStartLearningBody: 'Start studying “{{noteName}}” now.',
  brainBreakCompleteCtaStartLearningTitle: 'Ready to start learning?',
  brainBreakCompleteCtaTakeNotesBody: 'Take notes in “{{noteName}}” now.',
  brainBreakCompleteCtaTakeNotesTitle: 'Ready to get back into it?',
  brainBreakCompleteCtaTakeQuiz: 'Take quiz',
  brainBreakCompleteCtaTakeQuizBody: 'Study “{{noteName}}” now.',
  brainBreakCompleteCtaTakeQuizTitle: 'Ready for another challenge?',
  brainBreakCompleteCtaTakeTest: 'Take a test',
  brainBreakCompleteCtaTakeTestBody: 'Test yourself on “{{noteName}}” now.',
  brainBreakCompleteCtaTakeTestTitle: 'Ready to test yourself?',
  brainBreakCompletedTag: 'COMPLETE',
  brainBreakCompleteFinalBody1: "You've completed all 5 puzzles in this week's Daily Brain Break.",
  brainBreakCompleteFinalBody2:
    'Thanks for playing — we hope you enjoyed them, and look forward to bringing you more in the future.',
  brainBreakCompleteFinalTitle: 'AMAZING.',
  brainBreakCompleteRetry: 'Retry puzzle',
  brainBreakCompleteTitle: 'Nice job.',
  brainBreakDailyHomeCardTitle: 'Daily Brain Break',
  brainBreakDay: 'Day {{day}}',
  brainBreakGameInstruction: 'Drag to slide the blue tile through the exit.',
  brainBreakIntroDayOfTotal: 'Day {{day}} of {{total}}',
  brainBreakIntroDescription:
    'Jumpstart your brain with a quick puzzle. Taking periodic breaks from studying improves learning and aids memory retention.',
  brainBreakIntroStartCta: "Start today's puzzle",
  brainBreakIntroWeekLabel: 'Week 1',
  brainBreakModalTitle: 'Brain Break',
  brainBreakNewTag: 'NEW',
  brainBreakPuzzleName: 'Sliding Puzzle',
  brainBreakTutorialCompleteCta: "Continue to Today's Puzzle",
  brainBreakTutorialCompleteDescription: "You're ready to take on today's daily puzzle.",
  brainBreakTutorialCompleteTitle: 'Tutorial Complete',
  bringForward: 'Bring Forward',
  bringInStudyMaterial: 'Bring in your study material',
  bringInStudyMaterialDescription: 'Drop in a PDF, slides, or your syllabus to study from.',
  bringToFront: 'Bring to Front',
  browserSteeringBannerCTA: 'For the best experience, switch to Chrome or Edge.',
  brushStyle: 'Brush style',
  bulletedList: 'Bulleted List',
  business: 'Business',
  businessCheckoutDisclaimer:
    'To create your business, you are being charged for one user.<br />You will be able to add additional team members after completing your purchase.',
  businessCheckoutTrialDisclaimer:
    'Once your trial is over, you will be charged for the number of active users in your organization.',
  businessDeleteRequiresEmptyBusiness: 'You must remove all the users from your business to delete your account.',
  businessDomainAlreadyExistsError: 'This domain has already been added to your business.',
  businessDomainApprovedEmailMessage1: 'Your domain request was approved!',
  businessDomainApprovedEmailMessage2: 'You can enable user discovery for your team members to join %s.',
  businessDomainApprovedEmailSubject: 'Your domain request has been approved',
  businessDomainInvalidError: 'Please enter a valid domain, like example.com.',
  businessDomainPublicError: "This is a public email domain and can't be claimed for a business.",
  businessDomainRejectedEmailMessage1: 'Your domain request for %s was not approved.',
  businessDomainRejectedEmailMessage2: 'If this was a mistake, contact us at',
  businessDomainRejectedEmailSubject: "Your domain request wasn't approved",
  businessDomainRequestAlreadyReviewed: 'This domain request has already been reviewed.',
  businessDomainRequestApproveConfirmMessage: 'Approve the domain %s for %s?',
  businessDomainRequestApproveDoneMessage: 'Domain %s approved. The owner has been notified.',
  businessDomainRequestDenyConfirmMessage: 'Reject the domain %s for %s?',
  businessDomainRequestDenyDoneMessage: 'Domain %s rejected. The owner has been notified.',
  businessDomainRequestPageTitle: 'Domain Request',
  businessDomainReviewEmailActionButton: 'Open Notability',
  businessForConstructionLink: 'For Construction',
  businessForLawLink: 'For Law',
  businessForSportsLink: 'For Sports',
  businessForWealthManagementLink: 'For Wealth Management',
  businessHeaderLink: 'Business',
  businessInvitationAcceptedEmailMessage:
    "You've joined the {{businessName}} team. You now have access to everything Notability has to offer. <br><br>  Collaborate with your team using shared libaries, enhance your notes with our powerful AI features, and access your notes everywhere you go! <br><br> Make sure to cancel any personal subscription you may have through the App Store. Your access to Notability is now provided through {{businessName}}.",
  businessInvitationAcceptedEmailSubject: 'Welcome to your team!',
  businessInvitationEmailMessage:
    '{{businessName}} has invited you to collaborate in Notability. Notability is an all-in-one note taking platform. Accept the invite below to get started. Your existing Notability library will become part of {{businessName}}.',
  businessInvitationEmailSubject: 'Join your team!',
  businessInvitationEmailTermsOfUseAndPrivacyPolicy:
    'By accepting, you agree to our <a href="https://notability.com/terms">Terms of Use</a> and <a href="https://notability.com/privacy">Privacy Policy.</a>',
  businessInvitationHeading: "You've been invited to join {{businessName}} on Notability.",
  businessInvitationNameLabel: 'Your name',
  businessInvitationNamePlaceholder: 'Full name',
  businessInvitationNameRequired: 'Please enter your full name',
  businessInvitationPageTitle: 'Join Notability for Business',
  businessInvitationReminderEmailMessage:
    'You have a pending invitation to join {{businessName}} on Notability. Accept the invitation to collaborate with your team and access your organization’s shared workspace.',
  businessInvitationReminderEmailSubject: 'Reminder: Join {{businessName}} on Notability',
  businessInvitationSSORequired:
    "You've joined the team! Your organization requires sign in with {{provider}}. Please continue to sign in.",
  businessJoinDeniedEmailDisclaimer: 'If this was a mistake, contact your team.',
  businessJoinDeniedEmailMessage:
    'You can still join Notability as an individual user to access our all-in-one note taking platform.',
  businessJoinDeniedEmailSubject: 'Your request to join %s has been denied',
  businessJoinRequestActionError: 'Something went wrong. Please try again, or manage your team in Notability.',
  businessJoinRequestDenyConfirmMessage:
    "Deny %s's request to join %s? We will notify them that their request has been denied.",
  businessJoinRequestDenyDoneMessage: "Request denied. We've notified %s.",
  businessJoinRequestEmailMessage:
    'Send %s an invitation to join %s? If you decline the request, we will notify them that their request has been denied.',
  businessJoinRequestEmailSubject: '%s is requesting to join %s',
  businessJoinRequestInviteConfirmMessage: 'Invite %s to join %s?',
  businessJoinRequestInviteDoneMessage: '%s has been invited to the team.',
  businessJoinRequestLinkExpired: 'This link is no longer active. You can manage your team in Notability.',
  businessJoinRequestPageTitle: 'Join Request',
  businessJoinRequestSignInRequired: 'Sign in to Notability as the team owner, then open this link again.',
  businessLicenseRequestPageTitle: 'Notability for Business License Request',
  businessMemberTrialLimit:
    'Cannot add user(s). You will exceed the user limit for your trial. Contact sales@notability.com for questions.',
  businessOnboardingAIPanelBody:
    'Capture ideas and review notes with real-time summaries. Chat with your note to instantly get insights and answers.',
  businessOnboardingAIPanelTitle: 'Notability AI Panel',
  businessOnboardingAudioRecordingBody: 'Capture content and automatically generate transcripts and summaries.',
  businessOnboardingAudioRecordingTitle: 'Audio Recording',
  businessOnboardingCreateNotesBody: 'Create a new note by importing content, recording audio, or starting to write.',
  businessOnboardingCreateNotesTitle: 'Create Notes',
  businessOnboardingCreateSharedLibraryBody:
    'Create a Shared Library and invite members to get started. Drag and drop existing notes to share them with your team immediately!',
  businessOnboardingCreateSharedLibraryTitle: 'Create Shared Library',
  businessOnboardingOrgSettingsBody: 'Manage billing and invite your team to collaborate.',
  businessOnboardingOrgSettingsTitle: 'Your Organization Settings',
  businessOnboardingYourLibrariesBody:
    'Organize notes around how you work. Use My Library for private notes and Shared Libraries to collaborate with your team in real time.',
  businessOnboardingYourLibrariesTitle: 'Your Libraries',
  businessOwnerCannotDeleteAccount: 'To delete your account, please contact businesssupport@gingerlabs.com.',
  businessPageDescription1New:
    '<Strong>Notability for Business</Strong> offers a secure and scalable note-taking solution specifically designed for the modern workplace.',
  businessPageDescription2:
    "Maximize your iPad investment and turn your iPads into powerful productivity tools with Notability's robust note-taking, annotating, and organization features.",
  businessPageDescriptionLegacy:
    "Notability for Business offers a secure and scalable note-taking solution specifically designed for the modern workplace. Maximize your iPad investment and turn your iPads into powerful productivity tools with Notability's robust note-taking, annotating, and organization features.",
  businessPageTitleLegacy: 'Empower Your Workforce With Notability for Business',
  businessPageTitleNew: 'Success for the <BusinessHighlight>workplace</BusinessHighlight>',
  businessPlans: 'Business Plans',
  businessSubscriptionMissing: 'The given business does not have an associated subscription.',
  businessSubscriptionRestrictedAddMembers: 'Cannot add members. The business subscription is canceled or unpaid.',
  businessSubscriptionRestrictedJoin: 'Cannot join this business. The subscription is canceled or unpaid.',
  businessTemplateAlreadyExistsError:
    'A Template with this name already exists for this note. Rename it, or delete the existing Template first.',
  businessTemplateContentUnavailableError: "We couldn't save this Template's content. Please try again.",
  businessTemplateCreateInProgressError: 'This Template is already being created. Please wait a moment and try again.',
  businessTemplateLimitReachedError: 'You have reached the {{limit}}-Template limit for your business.',
  businessTrialBillingStarts_one: "You're all set. Billing starts in {{count}} day.",
  businessTrialBillingStarts_other: "You're all set. Billing starts in {{count}} days.",
  businessTrialBillingStartsTomorrow: "You're all set. Billing starts tomorrow.",
  businessTrialBillingSubtitle_one:
    '{{count}} day of free trial remaining. Your payment method will be billed in {{count}} day.',
  businessTrialBillingSubtitle_other:
    '{{count}} days of free trial remaining. Your payment method will be billed in {{count}} days.',
  businessTrialBillingSubtitleToday: "Free trial ends today. You're all set. Billing starts tomorrow.",
  businessTrialBody:
    'After your 30-day free trial, you will be charged for the number of users in your organization.\n\nContinue to create your organization and invite team members.',
  businessTrialContactOwner: 'Contact your organization owner to upgrade',
  businessTrialDaysRemaining_one: '{{count}} day of free trial remaining',
  businessTrialDaysRemaining_other: '{{count}} days of free trial remaining',
  businessTrialEmailFeature1: '✓ Shared Libraries',
  businessTrialEmailFeature2: '✓ Real-time collaboration',
  businessTrialEmailFeature3: '✓ Handwriting search and conversion',
  businessTrialEmailFeature4: '✓ AI-powered summaries and transcripts',
  businessTrialEmailHeader: 'Your Notability Business trial ends %s',
  businessTrialEmailMessage: 'Add a payment method to keep access to:',
  businessTrialEmailSubject: 'Your Notability Business trial ends %s!',
  businessTrialEmailUpgradeActionButton: 'Go to Billing',
  businessTrialEnded: 'Trial has ended',
  businessTrialEndedEmailHeader: 'Your Notability for Business trial has ended',
  businessTrialEndedEmailMessage: 'Add a payment method to regain access to:',
  businessTrialEndedEmailSubject: 'Your Notability Business trial has ended',
  businessTrialFollowUpEmailActionButton: 'Talk to a team member',
  businessTrialFollowUpEmailBodyCopy: 'Thanks again for trying Notability for Business!',
  businessTrialFollowUpEmailHeroBody1: '1. What did you or your team find most useful during the trial?',
  businessTrialFollowUpEmailHeroBody2:
    '2. What would need to be different for Notability for Business to be the right fit for your team?',
  businessTrialFollowUpEmailHeroBody3: 'You can reply directly to this email or you can book a call to chat',
  businessTrialFollowUpEmailHeroHeading: 'Thanks for trying Notability for Business.',
  businessTrialFollowUpEmailHeroSubheading:
    "Before you go, we'd love to hear how it went. Your feedback will directly shape what we build next.",
  businessTrialFollowUpEmailTeamName: '— The Notability Team',
  businessTrialFreeTrialEndsToday: 'Free trial ends today',
  businessTrialHalfwayEmailSubject: 'Your Notability Business trial is halfway over!',
  businessTrials: 'Business Trials',
  businessTrialUpgradeForFullAccess: 'Upgrade for full access',
  businessTrialWelcomeBusiness: 'Welcome to Notability for Business',
  businessTrialWelcomeBusinessPro: 'Welcome to Notability for Business Pro',
  businessUserAlreadyInvited: 'User already invited',
  calendarAddedByYouTag: 'added by you',
  calendarAddEvent: 'Add',
  calendarAddEventHint: 'Enter a name, choose a time, and pick a date or repeat days to add the event.',
  calendarAddEventsButton: 'Add events',
  calendarAddEventsProfessionalBody:
    'Have a weekly recurring meeting or an upcoming deadline that you need to prepare for? Add them and we can set up the calendar to get you started.',
  calendarAddEventsProfessionalTitle: 'No calendar? We’ll set one up for you',
  calendarAddEventsStudentBody: 'You can manually add events to get started.',
  calendarAddEventsStudentSyllabusBody:
    'Upload your class syllabus and we’ll set everything up or you can manually add events to get started.',
  calendarAddEventsStudentTitle: 'No calendar? No problem',
  calendarAddEventTitle: 'Add custom event',
  calendarAddMyOwnButton: 'Add my own',
  calendarComingUpToday: 'Coming up today',
  calendarConnectBody: "We'll create folders and notes automatically to save you time. Read-only · disconnect anytime.",
  calendarConnectButton: 'Connect calendar',
  calendarConnectedAs: 'Connected to {{service}} as {{email}}',
  calendarConnectNewCalendar: 'Connect new calendar',
  calendarConnectPickerBody:
    'Record events in a single click then get automatic notes on everything captured so you can stay engaged in the moment.',
  calendarConnectPickerTitle: 'Connect a calendar',
  calendarConnectPopupBlocked: 'Your browser blocked the sign-in window. Allow pop-ups for this site, then try again.',
  calendarConnectStub: "Calendar connect isn't wired up yet",
  calendarConnectTitle: 'Connect your calendar to set up your classes',
  calendarCreatedFolders: 'Created folders with starter notes',
  calendarDisconnectFailed: "Couldn't disconnect your calendar. Please try again.",
  calendarEmptyStateProfessionalBody:
    'Connect your calendar so for every meeting, it’s one tap to create a note, get them organized and generate summaries and action items.',
  calendarEmptyStateProfessionalTitle: 'Set up Notability in one step',
  calendarEmptyStateStudentBody:
    'Connect your calendar so for every class, it’s one tap to create a note, get them organized and generate study materials so you can be prepared before that exam.',
  calendarEmptyStateStudentTitle: 'Set up your classes in one step',
  calendarEventDate: 'Date',
  calendarEventDays: 'Days',
  calendarEventNameLabel: 'Event name',
  calendarEventNamePlaceholder: 'Event name',
  calendarEventsFound_one: '{{count}} event found',
  calendarEventsFound_other: '{{count}} events found',
  calendarEventTime: 'Time',
  calendarExamTag: 'exam',
  calendarFrequencyDaily: 'Daily',
  calendarFrequencyWeekdays: 'Weekdays',
  calendarFrequencyWeekends: 'Weekends',
  calendarGateAddEventQuestionClass: "What's one class you have regularly?",
  calendarGateAddEventQuestionMeeting: "What's one meeting you have regularly?",
  calendarGateConnectFailedAccountMismatchBody:
    'Your browser is signed in to a different Notability account. Switch accounts there, then <connectAnother>try connecting again</connectAnother>.',
  calendarGateConnectFailedBody:
    'The selected calendar could not be connected. <connectAnother>Try connecting a different calendar</connectAnother> or adding events manually.',
  calendarGateEventsAdded_one: '{{count}} event added',
  calendarGateEventsAdded_other: '{{count}} events added',
  calendarGateNoCalendarProfessionalBody:
    'Try adding a recurring meeting or event and we’ll help you get set up. Have a calendar after all? <connectAnother>Connect it</connectAnother>.',
  calendarGateNoCalendarStudentBody:
    'Try adding a recurring class or event and we’ll help you get set up. Have a calendar after all? <connectAnother>Connect it</connectAnother>.',
  calendarGateNoCalendarStudentSyllabusBody:
    'Try uploading your course syllabus or add your own event. Have a calendar after all? <connectAnother>Connect it</connectAnother>.',
  calendarGateNoCalendarTitle: 'No calendar, no problem',
  calendarGateNoEventsBody:
    'The connected calendar has no events. <connectAnother>Try connecting a different calendar</connectAnother> or adding events manually.',
  calendarGateNoEventsTitle: 'No events found',
  calendarGatePopupBlockedBody:
    'Your browser blocked the sign-in window. Allow pop-ups for this site, then <connectAnother>try connecting again</connectAnother> or add events manually.',
  calendarGateTryAnotherWay: 'Try another way',
  calendarHappeningNow: 'Happening now',
  calendarJoinMeetingPrompt: 'Also join meeting?',
  calendarJoinNow: 'Join now',
  calendarLinkCaption: 'Canvas, Blackboard, and more',
  calendarLinkConnectedTo: 'Connected to {{host}}',
  calendarLinkConnectFailed: 'Something went wrong. Please try again.',
  calendarLinkDialogMessage:
    'Connect your calendar from apps like Canvas and Blackboard. To find the URL (.ics link), look for “Calendar Feed” or “Subscribed” in your app portal.',
  calendarLinkDialogPlaceholder: 'Add .ics link',
  calendarLinkDialogTitle: 'Add calendar URL',
  calendarLinkDialogUrlLabel: 'URL',
  calendarLinkDisconnectConfirm: 'Disconnect this calendar? Its events will stop appearing on Home.',
  calendarLinkInvalidUrl: 'Invalid URL',
  calendarLinkLabel: 'Calendar Link',
  calendarLinkNotACalendar: 'This link opens a page, not a calendar feed. Paste the .ics link instead.',
  calendarLinkOnboardingLabel: 'Add calendar URL (ICS)',
  calendarLoadFailedRetryBody: 'Something went wrong loading your events. Please try again.',
  calendarLoadFailedTitle: "Couldn't load your calendar",
  calendarLoadingEvents: 'Loading events',
  calendarManageEvents: 'Manage events',
  calendarManageTitle: 'Manage calendar events',
  calendarMicrosoftRevokeHintConnected:
    "Disconnecting removes the calendar from Notability. To also remove Notability's access from your Microsoft account, visit <personal>account.microsoft.com</personal> for a personal account or <work>myaccount.microsoft.com</work> for a work or school account.",
  calendarMicrosoftRevokeHintDisconnected:
    "The calendar was removed from Notability. To also remove Notability's access from your Microsoft account, visit <personal>account.microsoft.com</personal> for a personal account or <work>myaccount.microsoft.com</work> for a work or school account.",
  calendarMoreOptions: 'More options',
  calendarNoCalendarProfessionalLink: 'Try another way',
  calendarNoCalendarStudentLink: 'I don’t use a calendar',
  calendarNoEventAccessBody:
    "Your {{provider}} account is connected, but calendar permission wasn't granted. Try again, and check the calendar box on {{provider}}'s screen.",
  calendarNoEventAccessReconnect: 'Reconnect calendar',
  calendarNoEventAccessRetry: 'Retry calendar connection',
  calendarNoEventAccessTitle: "Notability can't see your calendar",
  calendarNoEventsBody:
    'Connect a calendar that has your class schedules, or try changing the <settings>calendar settings</settings> to make sure you’re viewing the right one.',
  calendarNoEventsProfessionalBody:
    'Connect a calendar that has your schedule, or try changing the <settings>calendar settings</settings> to make sure you’re viewing the right one.',
  calendarNoEventsTitle: 'Your calendar has no events',
  calendarNoMoreEventsToday: 'No more events today',
  calendarNotifyToggle: 'Notify me when this meeting is about to start',
  calendarOpenCalendar: 'Open calendar',
  calendarProviderConnecting: 'Connecting...',
  calendarReconnect: 'Reconnect',
  calendarReconnectBody: 'Reconnect your calendar to see your events.',
  calendarReconnectTitle: 'Reconnect your calendar',
  calendarReconsentBody: 'Reconnect your {{provider}} calendar to sync events from all your calendars.',
  calendarReconsentTitle: 'Notability can only see your primary calendar',
  calendarRecordCueCardGeneralBody:
    'When events are about to start just click “Record” in the calendar to join, record and transcribe so you never miss a thing.',
  calendarRecordCueCardRecordBody: 'Join, record, and transcribe your calls, click here to get started.',
  calendarRecordCueCardTitle: 'Capture notes in a single click',
  calendarRemoveEvent: 'Remove event',
  calendarRepeats: 'Repeats weekly',
  calendarRetry: 'Retry',
  calendarSaveButton: 'Save changes',
  calendarSectionClasses: 'Classes',
  calendarSectionExams: 'Exams',
  calendarSectionOther: 'Other events',
  calendarSeeUpcoming_one: 'See {{count}} upcoming',
  calendarSeeUpcoming_other: 'See {{count}} upcoming',
  calendarServiceLabel: 'Google Calendar',
  calendarServiceLabelAny: 'Calendar',
  calendarServiceLabelMicrosoft: 'Outlook Calendar',
  calendarSettingsCalendarsHeader: 'Calendars',
  calendarSettingsMenuItem: 'Calendar settings',
  calendarSettingsNotSeeingEvents: 'Not seeing the right events?',
  calendarSettingsTitle: 'Calendar',
  calendarSetupEventCount: '{{recurringEvents}} recurring and {{nonRecurringEvents}} non-recurring events found',
  calendarShowLess: 'Show less',
  calendarStartingSoon: 'Starting soon',
  calendarStartNote: 'Start note',
  calendarStartNoteForEvent: 'Start note for {{eventTitle}}',
  calendarStartRecording: 'Start recording',
  calendarStartRecordingForEvent: 'Start recording for {{eventTitle}}',
  calendarSyncCalendar: 'Sync calendar',
  calendarSyncComplete: 'Calendar sync complete',
  calendarSyncFailed: "Couldn't sync your calendar",
  calendarSyncingCalendar: 'Syncing calendar',
  calendarTakeNotesStub: "Note creation isn't wired up yet",
  calendarToday: 'Today',
  calendarToggleEvent: 'Toggle event',
  calendarTomorrow: 'Tomorrow',
  calendarTurnOffEventNotification: 'Turn off event notification',
  calendarTurnOnEventNotification: 'Turn on event notification',
  calendarUpcomingEventsPlaceholder: 'Upcoming events will be shown here',
  calendarUpdateEventsTitle: 'Update calendar events',
  cancel: 'Cancel',
  cancelAppStoreSubOnClassicPurchaseEmailFeedbackHeader: 'Questions?',
  cancelAppStoreSubOnClassicPurchaseEmailFeedbackMessage:
    'If you have any questions regarding your subscription or cancelling please reach out to support@notability.com.',
  cancelAppStoreSubOnClassicPurchaseEmailSubject: "We've detected a subscription!",
  cancelAppStoreSubOnClassicPurchaseEmailWelcomeMessage:
    "We've detected that you have an active subscription in addition to your Classic purchase.<br> <br> Since you recently purchased Classic, we recommend cancelling your subscription. <br> <br>How to cancel:<br>- If you subscribed through the Apple App Store: You'll need to cancel directly through the App Store.<br>- If you subscribed through our web app: You can cancel subscription within the <a href=\"%s\">Notability app</a>.<br><br>Once cancelled, you'll continue to have Classic access to Notability with no interruption. If you subscribe later and cancel, you will retain your Classic access",
  cancelConsumerSubEmailFeedbackHeader: 'Questions?',
  cancelConsumerSubEmailFeedbackMessage:
    'If you have any questions regarding your subscription or cancelling please reach out to businesssupport@notability.com.',
  cancelConsumerSubEmailSubject: "We've detected an additional subscription!",
  cancelConsumerSubEmailWelcomeMessage:
    "We've detected that you have an active personal subscription in addition to your Notability for Business account.<br> <br> Since your organization now covers your Notability subscription, you should cancel your personal subscription to avoid additional charges. <br> <br><b>How to cancel:</b><br> Your current subscription is managed through the Apple App Store: You'll need to cancel directly through the App Store.<br><br><br>Once cancelled, you'll continue to have full access to Notability through your Business account with no interruption.",
  cancelConsumerSubEmailWelcomeMessageStripe:
    'We\'ve detected that you have an active personal subscription in addition to your Notability for Business account.<br> <br> Since your organization now covers your Notability subscription, you should cancel your personal subscription to avoid additional charges. <br> <br><b>How to cancel:</b><br> Use this <a href="%s">link</a> to cancel your subscription.<br><br>Once cancelled, you\'ll continue to have full access to Notability through your Business account with no interruption.',
  cancelConsumerSubPortalButton: 'Cancel my personal subscription',
  cancelConsumerSubPortalError:
    'Something went wrong. Please try again, or contact businesssupport@notability.com for help.',
  cancelConsumerSubPortalExpired:
    'This link has expired. Please contact businesssupport@notability.com for help cancelling your subscription.',
  cancelConsumerSubPortalHeading: 'Cancel your personal subscription',
  cancelConsumerSubPortalMessage:
    'Your organization now covers your Notability subscription. Cancel your personal subscription to avoid additional charges.',
  cancelConsumerSubPortalPageTitle: 'Cancel Personal Subscription',
  cancelFinishNotes: 'Cancel finishing notes',
  cancelImageEdits: 'Cancel edits',
  cancelSubscription: 'Cancel subscription',
  cancelSubscriptionModalDescription:
    'Your subscription will end at the end of your billing cycle. Existing users will be downgraded to view-only mode.',
  cancelYourSubscription: 'Cancel your subscription?',
  canComment: 'Can comment',
  canEdit: 'Can edit',
  cannotBeAdminOfSeveralOrgs: 'User cannot be admin of multiple Organizations',
  cannotBeElevatedRoleOfSeveralOrgs: 'User cannot be an admin or owner of multiple organizations',
  cannotBeInMultipleBusinesses: 'User cannot be part of multiple Businesses',
  cannotBeInMultipleOrgs: 'User cannot be part of multiple Organizations',
  cannotChangeOwnerRoleError: 'Cannot change the role of the business owner',
  cannotChangeOwnPermission: 'You cannot change your own permission',
  cannotChangeVerifiedEmail: 'Admins cannot change a verified email address.',
  cannotDeleteNoteWhileRecording: "You can't delete a note while it has a recording in progress.",
  cannotInviteBusinessOwner: 'Cannot invite user to business with OWNER role',
  cannotPerformBusinessAction: 'You cannot perform this action without being linked to business',
  cannotPerformBusinessActionOnOwner: 'You cannot perform this action on the business owner',
  cannotPerformWorkspaceAction: 'You cannot perform the action for this workspace',
  cannotPromoteToOwnerError: 'Cannot promote user to owner role',
  cannotRemoveSelfFromOrg: 'You cannot remove yourself from an organization',
  cannotReviewIfNotNeededError: 'Cannot review a profile that does not need a review.',
  canView: 'Can view',
  captchaVerificationFailedError: "We couldn't confirm you're not a robot. Please try again.",
  captchaVerificationWaitingMessage: 'Hang tight, logging you in...',
  caption: 'Caption',
  categoryFieldResolverNotFoundError: 'A category with the given id does not exist',
  categoryPlaceholderUpdateClient: 'Please update Notability',
  centerAlign: 'Center align',
  'Change Password': 'Change Password',
  changeSubscription: 'Change subscription',
  changeTemplate: 'Change template',
  charsRemaining: '{{chars}} characters remaining',
  chat: 'Chat',
  chatAcrossNotesUpsellBody: 'Find key takeaways, action items, or learn more about a specific topic with Chat',
  chatAcrossNotesUpsellTeaser: 'Ask questions, explore topics, and study with every note in your library.',
  chatAcrossYourNotes: 'Chat across your notes',
  chatbotThreadNotFoundError: 'This chat was not found.',
  chatCloseFullscreenAriaLabel: 'Close chat',
  chatComposerPlaceholder: 'Ask anything about your notes.',
  chatDeleteThreadConfirmBody: 'This action cannot be undone.',
  chatDeleteThreadConfirmButton: 'Delete thread',
  chatDeleteThreadConfirmTitle: 'Delete this thread?',
  chatDeleteThreadFailed: "Couldn't delete chat",
  chatHideThreadsAriaLabel: 'Hide threads',
  chatHistoryLoadFailedTitle: "Chat history couldn't load",
  chatLearnCardBody: 'Find key takeaways, action items, or learn more about a specific topic with Chat',
  chatLearnCardFullTitle: 'Chat with your notes',
  chatLearnCardPlaceholder: 'Write a message',
  chatLoadFailedBody: 'Something went wrong.',
  chatLoadingAriaLabel: 'Loading',
  chatLookingIntoYourLibrary: 'Looking into your library...',
  chatLookingIntoYourNotes: 'Looking into your notes...',
  chatNewThread: 'New thread',
  chatNewThreadAriaLabel: 'New thread',
  chatRename: 'Rename',
  chatRenameThreadAriaLabel: 'Rename thread',
  chatReplyAccurateTooltip: 'Accurate response',
  chatReplyCopyTooltip: 'Copy message',
  chatReplyInaccurateTooltip: 'Inaccurate response',
  chatRetryAriaLabel: 'Retry message',
  chatShowThreadsAriaLabel: 'Show threads',
  chatThreadAriaLabel: 'Thread: {{title}}',
  chatThreadOptionsAriaLabel: 'Thread options',
  chatThreadsLoadFailedTitle: "Chat couldn't load",
  chatThreadsLoadMoreFailedTitle: "Couldn't load more chats",
  chatThreadsSection: 'Threads',
  chatToolAllow: 'Allow',
  chatToolDeny: 'Deny',
  chatToolGenericApproved: 'Done.',
  chatToolGenericDenied: 'Request denied.',
  chatToolGenericError: "That action couldn't be completed.",
  chatToolGenericPrompt: 'Allow Chat to run this action?',
  chatToolGenericUnanswered: 'Not answered.',
  chatToolImportOpenApproved: 'Opened the file picker.',
  chatToolImportOpenDenied: 'Import denied.',
  chatToolImportOpenPrompt: 'Allow Chat to import a file?',
  chatToolLearnOpenApproved: 'Opened Learn.',
  chatToolLearnOpenDenied: 'Learn denied.',
  chatToolLearnOpenPrompt: 'Allow Chat to open the Learn panel?',
  chatToolNoteCreateApproved: 'Created a new note.',
  chatToolNoteCreateDenied: 'Note creation denied.',
  chatToolNoteCreatePrompt: 'Allow Chat to create a new note?',
  chatToolNoteOpenApproved: 'Opened the note.',
  chatToolNoteOpenDenied: 'Opening the note denied.',
  chatToolNoteOpenPrompt: 'Allow Chat to open a note?',
  chatToolNoteOpenTitledApproved: 'Opened “{{noteTitle}}”.',
  chatToolNoteOpenTitledDenied: 'Opening “{{noteTitle}}” denied.',
  chatToolNoteOpenTitledPrompt: 'Allow Chat to open “{{noteTitle}}”?',
  chatToolNoteReadApproved: 'Read the note.',
  chatToolNoteReadCurrentPrompt: 'Allow Chat to read this note?',
  chatToolNoteReadDenied: 'Reading the note denied.',
  chatToolRecordingStartApproved: 'Recording started.',
  chatToolRecordingStartDenied: 'Recording denied.',
  chatToolRecordingStartPrompt: 'Allow Chat to start recording?',
  chatTryAgain: 'Try again',
  chatTurnErrorAiDisabled: 'AI features are turned off for this account.',
  chatTurnErrorConflict: 'This chat changed somewhere else. Try again.',
  chatTurnErrorHttp: 'Message failed to send. Check your connection and try again.',
  chatTurnErrorNotSubscribed: 'Chat with your notes is a Pro feature.',
  chatTurnErrorServer: 'Message failed to send. Try again.',
  chatTurnErrorStreamInterrupted: 'The response was interrupted. Try again.',
  checkAnswer: 'Check answer',
  checklist: 'Checklist',
  checkout: 'Checkout',
  checkTheLinkAndTryAgain: 'Check the link and try again',
  checkYourConnectionAndTryAgain: 'Check your internet connection and try again',
  'Choose a new password': 'Choose a new password',
  'Choose Your Username!': 'Choose Your Username!',
  chooseAPlan: 'Choose a plan',
  chooseContentTypeTitle: 'Type',
  'Class Notes': 'Class Notes',
  clear: 'Clear',
  clearSearch: 'Clear search',
  clickHereToSignIn: 'Click here to sign in.',
  clientIdMismatchError: 'Client ID mismatch',
  clientOutdatedBody:
    'This version of Notability can no longer sync. Your notes on this device are safe, but nothing new will be saved until you update.',
  clientOutdatedCheckAgain: 'Check again',
  clientOutdatedDownloadingUpdate: 'Downloading update',
  clientOutdatedGetUpdate: 'Get the update',
  clientOutdatedHeading: 'Update required',
  clientOutdatedInstallFailed: "The update downloaded but wouldn't install. Get it from the download page instead.",
  clientOutdatedNoUpdateYet: 'No update is available to download yet. Notability will keep checking.',
  clientOutdatedOpenedBrowser: 'Opened the download page in your browser. Install it there, then reopen Notability.',
  clientOutdatedRefreshAndUpdate: 'Refresh and update',
  clientOutdatedRestartAfterDownload: 'Restart to update after downloading, any active recordings will be saved.',
  clientOutdatedRestartAndUpdate: 'Restart and update',
  clientOutdatedRestartNow: 'Restart now to update, any active recordings will be saved.',
  clientOutdatedUpdateDownloaded: 'Update downloaded',
  clientOutOfDateEnrollmentError:
    'This version of Notability is out of date. Please install the latest version to create an account.',
  closeAi: 'Close AI',
  closeComment: 'Close comment',
  closeCueCard: 'Close card',
  closeLearnTooltip: 'Close Learn',
  closeModal: 'Close',
  closeStudyPanel: 'Close study mode',
  codeBlock: 'Code block',
  codeBlockCopyButton: 'Copy code',
  codeBlockCopySuccess: 'Copied!',
  codeBlockLanguageSelector: 'Select language',
  codeBlockPlaceholder: 'Code',
  collabConflictError: 'The mutation could not be accepted due to a conflict',
  collabFileNotFound: 'The requested resource was not found.',
  collabFileParseFailed: 'The server failed to parse the file',
  collabLinkVisitError: 'Unable to open shared note',
  collabMinimumFileDimensionsError: 'The provided thumbnail is too small',
  collaborateLive: 'Collaborate live with handwriting on any device',
  collabThumbnailAnimatedError: 'The provided thumbnail must not be animated',
  collabThumbnailSizeError: 'The provided thumbnail is too large',
  collabUnknownError: 'The mutation could not be accepted due to an unknown error',
  collapse: 'Collapse',
  collectionAddModalTitle: 'Add To Collection',
  collectionAddNew: 'Add to a new collection',
  collectionAddNoteButton: 'Add To Collection',
  collectionAddUsed: 'Collections with this note',
  collectionDeleteConfirm: 'Are you sure you want to delete the collection "{{collectionName}}"?',
  collectionDeleteTitle: 'Delete Collection',
  collectionIdCollisionError: "Collection with ID '{{id}}' already exists.",
  collectionIdFormatError: "Official collection ID must be alphanumeric and '-' characters.",
  collectionNameLengthError: 'Collection names must be between {{min}} and {{max}} characters long.',
  collectionNoneAvailable: 'No collections available.  <1>Click here</1> to create one.',
  collectionNotFoundError: 'Collection not found.',
  collectionOfficialListTitle: 'Official Ginger Labs Collections',
  collectionPersonalListTitle: 'My Collections',
  collectionRemoveButton: 'Remove',
  collectionRemoveConfirm: 'Are you sure you want to remove {{noteName}} from {{collectionName}}?',
  collectionRemoveTitle: 'Remove Note from Collection',
  color: 'Color',
  colorSchemeAuto: 'Auto',
  colorSchemeBotanicalDay: 'Botanical (Day)',
  colorSchemeBotanicalNight: 'Botanical (Night)',
  colorSchemeCustom: 'Custom',
  colorSchemeCustomEnable: 'Select Custom Theme',
  colorSchemeDark: 'Dark',
  colorSchemeDarkBlue: 'Dark Blue',
  colorSchemeFall: 'Fall',
  colorSchemeGrape: 'Grape',
  colorSchemeHalloween: 'Halloween',
  colorSchemeJetBlack: 'Jet Black',
  colorSchemeJetBlackSpooky: 'Jet Black Spooky',
  colorSchemeLight: 'Light',
  colorSchemeMint: 'Mint',
  colorSchemeSpring: 'Spring',
  colorSchemeStrawberry: 'Strawberry',
  colorSchemeSummer: 'Summer',
  colorSchemeWinter: 'Winter',
  comeBackLater: 'Come back later',
  comment: 'Comment',
  commentAlreadyHiddenError: 'This comment is already hidden.',
  commentAnonymousAuthor: 'Anonymous {{number}}',
  commentBadUserPostingCommentError: 'This account is unable to post comments. Please contact support for assistance.',
  commentCannotReportHidden: 'Comment is already hidden, cannot report',
  commentDeletionError: 'There was an error deleting your comment: {{error}}',
  commentDeletionUserMismatch: 'Comments can only be deleted by their author.',
  commentDisabledOnNote: 'Comments are disabled on this note.',
  commenter: 'Commenter',
  commentingDisabled: 'Disabled',
  commentingEnabled: 'Enabled',
  commentModalHeader: 'Responses',
  commentNoAccess: 'This user does not have access to comments.',
  commentNotAllowedError: 'This comment contains banned content.',
  commentNotFoundError: 'The requested comment was not found.',
  commentOutsidePageBoundsNotice: 'Switch to Pageless mode to work outside the page bounds.',
  commentOverCharacterLimit: 'Comments must be at most 256 characters long.',
  commentOverDailyLimit: 'You have exceeded the limit of comments per day.',
  commentOverHourlyLimit: 'You have exceeded the limit of comments per hour.',
  commentPin: 'Comment pin',
  commentReportButton: 'Report',
  commentReportButtonBack: 'Back',
  commentReportButtonExit: 'Exit',
  commentReportButtonNext: 'Next',
  commentReportButtonSubmit: 'Submit',
  commentReportChooseReasonHeader: 'Report this comment?',
  commentReportChooseReasonSubtitle: 'Choose the reason why you are reporting this comment below:',
  commentReportErrorHeader: 'Error:',
  commentReportSuccessHeader: 'Report successfully submitted',
  commentReportSuccessSubtitle: 'The comment will be reviewed by our moderation team',
  commentReportSummaryCommentTextHeader: 'Comment Text:',
  commentReportSummaryReportReasonHeader: 'Report Reason:',
  comments: 'Comments',
  commentsAll: 'All Comments',
  commentsCueCardBody: 'Leave notes and feedback right on the page. Try it from the toolbox.',
  commentsNeedingReview: 'Comments Needing Review',
  commentsRejectedAfterReview: 'Comments Rejected After Review',
  commentsTrayEmptyBody: 'Comments on this note will show up here.',
  commentsTrayEmptyTitle: 'No comments yet',
  commentThread: 'Comment thread',
  commentTooFast: "You're posting multiple comments too rapidly. Please try again in a moment.",
  commentUnderCharacterRequirement: 'Comments must be at least three characters long.',
  communityGuidelinesDescription:
    "We want everyone to feel welcome on the Gallery! Let's build a strong community together with these guidelines in mind.",
  communityGuidelinesTitle: 'Community Guidelines',
  comparePlansBack: 'Back',
  comparePlansTitle: 'Compare plans',
  completed: 'Completed',
  complexIdeasExplainedClearly: 'Complex ideas, explained clearly',
  comprehensiveAssessment: 'Comprehensive assessment',
  confirm: 'Confirm',
  'Confirm Password': 'Confirm Password',
  confirmChangeScreenname: 'Change Screenname',
  confirmFlagButton: 'Report',
  confirmFlagMessage: 'Are you sure you want to report this note for {{reason}}?',
  confirmNFTReportMessage:
    'Are you sure you want to flag all {{nftCardinality}} relatives of {{noteName}} as {{reason}}?',
  confirmUntriageMessage:
    'Are you sure you want to remove {{noteName}} from quarantine? It will be publicly viewable again.',
  connect: 'Connect',
  connectedServices: 'Connected services',
  consumerCurrentPlan: 'Current plan',
  consumerFeatureAudioTranscription: 'Audio transcription',
  consumerFeatureChatWithNotes: 'Chat with your notes',
  consumerFeatureEverythingInPlus: 'Everything in PLUS and...',
  consumerFeatureEverythingInStarter: 'Everything in STARTER and...',
  consumerFeatureLearnQuizzes: 'AI generated quizzes and summaries',
  consumerFeatureLearnSummary: 'Comprehensive note summaries',
  consumerFeatureLiveTranscription: 'Live transcription',
  consumerFeatureNoteSummaries: 'Note summaries',
  consumerFeaturePdfAnnotation: 'PDF annotation',
  consumerFeatureQuizzesFlashcardsLimited: 'Quizzes & flashcards (Limited monthly)',
  consumerFeatureQuizzesFlashcardsUnlimited: 'Quizzes & flashcards (Unlimited)',
  consumerFeatureRealTimeSmartNotes: 'Real-time Smart Notes',
  consumerFeatureRecordAudio: 'Audio recording',
  consumerFeatureTranscription: 'Automatic audio transcription',
  consumerFeatureUnlimitedNotes: 'Unlimited notes',
  consumerFreeHeader: 'Take smarter notes, free users get...',
  consumerFreeTitle: 'STARTER',
  consumerHelpContact: 'Have questions or need support?',
  consumerHelpEmail: 'Contact {{email}}',
  consumerMostPopular: 'Most Popular',
  consumerNetworkError: 'There was an error communicating with the payment system.',
  consumerPlanSelectionCTA: 'Unlock',
  consumerPlusHeader: 'Unlock our most powerful features',
  consumerPlusLimitations: '<0>{{productName}}</0> (Monthly Limit)',
  consumerPlusUpgradeCTA: 'Upgrade to Plus',
  consumerPlusUpgradeCTAHeader: 'Upgrade to Notability Plus today',
  consumerPlusUpgradeCTAHeaderV2:
    '<Primary>Upgrade to Notability Plus</Primary><Sub>and unlock the power of Notability today!</Sub>',
  consumerPlusUpgradeHeaderV3:
    '<Primary>Unleash the power of Notability</Primary><Sub>Unlock powerful features that maximize the potential of Notability, and you.</Sub>',
  consumerProLimitations: '<0>{{productName}}</0> (Unlimited)',
  consumerUnlockPlan: 'Unlock {{tier}}',
  consumerUpsellSubhead: 'Plus users have access to powerful AI tools to take your learning to the next level.',
  contactSales: 'Contact Sales',
  contactSupport: 'Contact Support',
  contactTheOwnerOfYourOrganization: 'Contact the owner of your organization to reactivate your subscription.',
  contactUs: 'Contact Us',
  contactUsSentenceCase: 'Contact us',
  contentTypeNote: 'Note',
  contentTypeTemplate: 'Template',
  Continue: 'Continue',
  continueDiscussion: 'Continue discussion',
  continueOnTheWeb: 'Continue on the web',
  continueRecording: 'Continue recording',
  continueToPaged: 'Continue to paged',
  continueToPageless: 'Continue to pageless',
  continueToQuiz: 'Continue to quiz',
  continueWithApple: 'Continue with Apple',
  continueWithGoogle: 'Continue with Google',
  continueWithMicrosoft: 'Continue with Microsoft',
  continuingAgreesToPolicies: 'By continuing, you agree to our <1>Terms and Conditions</1> and <3>Privacy Policy</3>.',
  conversionComplete: 'Conversion Complete',
  conversionError: 'Error Converting Content',
  converting: 'Converting',
  convertingHeicImageBody:
    'Converting HEIC image so it can be added to your note. This can take a moment for a large photo.',
  convertingHeicImagesBody:
    'Converting HEIC images so they can be added to your notes. This can take a moment for large photos.',
  convertingHeicImagesTitle: 'Preparing images…',
  convertingHeicImageTitle: 'Preparing image…',
  cookieNotice:
    'This site uses cookies to help us improve the Notability Gallery experience. Information is anonymous and we do not share any data with advertisers.',
  cookieOptIn: 'I Agree',
  cookieOptOut: 'Opt Out',
  cookieOptSetting: 'Share My Experience',
  cookieSettings: 'Cookie settings',
  copiedToClipboard: 'Copied to clipboard',
  copy: 'Copy',
  copyActionItems: 'Copy action items',
  copyLinkButton: 'Copy link',
  copyLinkHint: 'Link Copied!',
  copyLinkURL: 'Copy link URL',
  copyright: 'Copyright © 2026 Ginger Labs, Inc.',
  copyShareLink: 'Copy share link',
  copySmartNotes: 'Copy Smart Notes',
  copySummary: 'Copy summary',
  copyTranscripts: 'Copy transcripts',
  Correct: 'Correct',
  countDaysLeft_one: '1 day left',
  countDaysLeft_other: '{{count}} days left',
  counterIdentity: '{{count}}',
  counterIdentityShort: '{{count}}',
  counterMillions: '{{count}}M',
  counterMillionsShort: '{{count}}M',
  counterThousands: '{{count}}k',
  counterThousandsShort: '{{count}}k',
  countNotesSelected_one: '1 note selected',
  countNotesSelected_other: '{{count}} notes selected',
  countSharedLibrariesSelected_one: '1 shared library selected',
  countSharedLibrariesSelected_other: '{{count}} shared libraries selected',
  create: 'Create',
  'Create password instead': 'Create password instead',
  createAFolder: 'Create a folder',
  createANote: 'Create a note',
  createANoteDescription: 'Start from a blank note.',
  createASubject: 'Create subject',
  createBusinessLegalConsent:
    'I have read, understand, and agree to be bound by the <subscriptionAgreement>Online Enterprise Subscription Agreement</subscriptionAgreement> and the <dataAgreement>Data Processing Agreement</dataAgreement><asterix>*</asterix>',
  createCollectionButton: 'Create Collection',
  createDividerServiceError: 'Creating divider failed',
  createFlashcardDeck: 'Create flashcard deck',
  createNew: 'Create new',
  createNewNote: 'Create new note',
  createNewTest: 'Create new test',
  createNote: 'Create note',
  createPassword: 'Create password',
  createProfileConfirm: 'Create username',
  createProfileErrorAlreadySet: 'Your account already has a username ({{username}}) which cannot be changed once set.',
  createProfileErrorLoggedOut: 'You must be logged in to set your username.  Please log in and try again.',
  createProfileHeader1: 'Welcome to the',
  createProfileHeader2: 'Notability Gallery',
  createProfileInstruction: 'Choose a username to continue.',
  createProfilePageTitle: 'Create Username',
  createSharedLibrary: 'Create shared library',
  createSharedLibraryModalTitle: 'Create a new shared library',
  createSubjectServiceError: 'Creating subject failed',
  createYourOrganization: 'Create Your Organization',
  createYourOwnQuiz: 'Create your own quiz',
  creatingStudyMaterials: 'Creating study materials...',
  creatives: 'creatives.',
  cropButton: 'Crop',
  currentPlan: 'Current plan',
  custom: 'Custom',
  customerName: 'Customer Name',
  cut: 'Cut',
  dashed: 'Dashed',
  dataDetection: 'Data Detection',
  dataDetectionDescription: 'Automatically turn web addresses you type or paste into links.',
  dataLossMissingNotes: 'Data Loss/Missing Notes',
  deactivated: 'Deactivated',
  deactivatedAccountEmailMessage:
    '{{businessName}} has deactivated your account. To access Notability again, you can contact your admin to reactivate your account or <a href="{{loginLink}}">create a new Notability account</a> using a different email address.',
  deactivatedAccountEmailSubject: 'Your account has been deactivated.',
  deactivateOrgUserMinCountError: 'Must deactivate at least one user from the organization',
  defaultNoteTitle: 'Note {{createdDate}}',
  defaultNoteTitleWithVersion: 'Note {{createdDate}} ({{version}})',
  defaultPermissions: 'Default permissions',
  defaultSharedLibrary: 'Default shared library',
  defaultSharedLibraryDescription:
    'All members of {{organizationName}} will automatically be added to this Shared Library.',
  delete: 'Delete',
  deleteCollabNoteError: 'Failed to delete',
  deleteCommentBody: 'This comment and any replies will be permanently deleted.',
  deleteCommentTitle: 'Delete comment?',
  deleteConfirmationDividerTitle_v2: "Deleting '{{title}}' will also delete: {{otherTitles}}",
  deleteConfirmationTitle: 'Delete Divider?',
  deletedDate: 'Deleted {{deletedDate}}',
  deleteDividerError: 'Cannot delete this divider',
  deleteDividerServiceError: 'Deleting divider failed',
  deletedNoteGuideInfo:
    'This note has been deleted, restoring it will allow you and anybody it is shared with to view or edit it again.',
  deletedNotes: 'Deleted Notes',
  deletedNotesEmptyInfo: 'After deleting a note, it will appear here and be available for recovery for 30 days.',
  deletedNotesGuideInfo:
    'Select a note to restore it to your library. This will allow you and anyone it is shared with to view or edit it again.',
  deletedToday: 'Deleted today',
  deletedUser: 'Deleted User',
  deletedYesterday: 'Deleted yesterday',
  deleteFolderConfirmationBodyFoldersAndNotes:
    'Deleting "{{folderName}}" will also delete {{folderCountStr}} and {{noteCountStr}}.',
  deleteFolderConfirmationBodyFoldersOnly: 'Deleting "{{folderName}}" will also delete {{folderCountStr}}.',
  deleteFolderConfirmationBodyNotesOnly: 'Deleting "{{folderName}}" will also delete {{noteCountStr}}.',
  deleteFolderConfirmationTitle: 'Delete this folder and all its contents?',
  deleteGoal: 'Delete goal',
  deleteNoteConfirmationSubtitle: 'The selected note(s) will be moved to the Trash.',
  deleteNoteConfirmationTitle: 'Delete {{title}}?',
  deleteNoteError: 'Cannot delete these notes',
  deleteNoteModalConfirmationButton: 'Delete note',
  deleteNoteModalConfirmationTitle: 'Delete this note?',
  deleteOrganization: 'Delete organization',
  deleteOrganizationAndRevert: 'Delete organization and revert to individual account',
  deleteOrganizationConfirmationTitle: 'Delete organization?',
  deleteOrganizationNamedAndRevert: 'Delete {{organizationName}} and revert to individual account',
  deleteOrganizationNamedConfirmationTitle: 'Delete {{organizationName}}?',
  deleteOrganizationRevertsAndCancels:
    'This will revert you to an individual account and cancel your subscription immediately.',
  deletePage: 'Delete page',
  deletePendingInviteEmail:
    '<email>{{email}}</email> hasn’t accepted their invite to {{organizationName}} yet. Deleting will revoke their pending invite.',
  deletePendingInviteNameEmail:
    '<name>{{name}}</name> ({{email}}) hasn’t accepted their invite to {{organizationName}} yet. Deleting will revoke their pending invite.',
  deleteSharedLibrary: 'Delete shared library',
  deleteSharedLibraryConfirmationBody: 'All members will lose access to "{{workspaceName}}" and all its contents.',
  deleteSharedLibraryConfirmationTitle: 'Delete shared library?',
  deleteSubjectModalButton: 'Delete subject',
  deleteSubjectServiceError: 'Deleting subject failed',
  deleteThisSubjectAndContents: 'Delete this subject and all its contents?',
  deleteUser: 'Delete user?',
  deleteUserBulletLoseAccess: 'This user will lose access to any notes in {{organizationName}}',
  deleteUserBulletReactivate: 'You can restore access by reactivating their account within 30 days',
  deleteUserBulletSharedNotes:
    'Notes this user has shared or created in Shared Libraries will remain accessible to members of {{organizationName}}',
  deleteUserLeadEmail:
    '<email>{{email}}</email> will be deactivated for 30 days before the account is permanently deleted.',
  deleteUserLeadNameEmail:
    '<name>{{name}}</name> ({{email}}) will be deactivated for 30 days before the account is permanently deleted.',
  deleteUserUseRemoveHint:
    'To remove this user from {{organizationName}} without deleting their account, use "Remove".',
  deniedAccessToast: '{{name}} denied access',
  deniedEditAccessToast: '{{name}} denied edit access',
  deny: 'Deny',
  denyNoteAccessError: 'There was an error denying access to this note',
  Description: 'Description',
  deselectAll: 'Deselect all',
  desktop: 'Desktop',
  desktopCalendarGateAccountMismatchBody:
    'This browser is signed into a different Notability account than the app. Switch accounts to finish connecting your calendar.',
  desktopCalendarGateAccountMismatchTitle: "You're signed in as a different account",
  desktopCalendarGateConnectedBody: 'Return to the Notability app to continue.',
  desktopCalendarGateConnectedTitle: 'Connection successful',
  desktopCalendarGateConnectError: "Couldn't start connecting. Please try again.",
  desktopCalendarGateConnectErrorAccountMismatch:
    'Your browser is signed in to a different Notability account. Switch accounts there, then try again.',
  desktopCalendarGateConnectTitle: 'Connect your calendar',
  desktopCalendarGateFinishInBrowser: 'Finish connecting in your browser, then come back.',
  desktopCalendarGateLandingBody: 'Continue here to finish calendar connection.',
  desktopCalendarGateSignedInAs: 'Signed in as {{email}}',
  desktopCalendarGateSwitchAccounts: 'Switch accounts',
  desktopContextMenuAddToDictionary: 'Add to dictionary',
  desktopContextMenuCopyLinkAddress: 'Copy link address',
  desktopContextMenuEmojiAndSymbols: 'Emoji & symbols',
  desktopContextMenuInspect: 'Inspect',
  desktopContextMenuLookUp: 'Look up',
  desktopContextMenuNoGuessesFound: 'No guesses found',
  desktopContextMenuSearchWithGoogle: 'Search with Google',
  desktopContextMenuSpeech: 'Speech',
  desktopContextMenuStartSpeaking: 'Start speaking',
  desktopContextMenuStopSpeaking: 'Stop speaking',
  desktopHomeBack: 'Back',
  desktopHomeComingUp: 'Coming up',
  desktopHomeForward: 'Forward',
  desktopHomeGetStartedSubtitle:
    'Automatically transform your content into comprehensive notes, transcripts, and quizzes.',
  desktopHomeGetStartedTitle: 'Let’s get started',
  desktopHomeNoEventsFound: 'No events found',
  desktopHomeOpenNote: 'Open note',
  desktopHomeOpenNoteForEvent: 'Open note for {{eventTitle}}',
  desktopMenuBringAllToFront: 'Bring all to front',
  desktopMenuCheckingForUpdates: 'Checking for updates…',
  desktopMenuCloseWindow: 'Close window',
  desktopMenuDeveloperTools: 'Developer tools',
  desktopMenuDownloadingUpdate: 'Downloading update…',
  desktopMenuFile: 'File',
  desktopMenuFindNext: 'Find next',
  desktopMenuFindPrevious: 'Find previous',
  desktopMenuMinimize: 'Minimize',
  desktopMenuPasteAndMatchStyle: 'Paste and match style',
  desktopMenuQuit: 'Quit',
  desktopMenuReload: 'Reload',
  desktopMenuRestartToUpdate: 'Restart to update',
  desktopMenuUpToDate: 'Notability is up to date',
  desktopMenuView: 'View',
  desktopMenuWindow: 'Window',
  desktopOnboardingAllowMicrophone: 'Allow microphone access',
  desktopOnboardingCalendarBodyProfessional:
    "Connect your calendar, and we'll keep every meeting organized and surface what matters before your important deadlines.",
  desktopOnboardingCalendarBodyStudent:
    "Connect your calendar, and we'll keep every class organized and have your study guide ready before the exam.",
  desktopOnboardingCalendarTitleProfessional: 'Less digging.\nMore prep.',
  desktopOnboardingCalendarTitleStudent: 'Less cramming.\nMore prep.',
  desktopOnboardingLater: 'Later',
  desktopOnboardingNoCalendar: 'I don’t have a calendar',
  desktopOnboardingPermissionMicrophoneDescription: 'Record anything your microphone can hear.',
  desktopOnboardingPermissionMicrophoneLabel: 'Your microphone',
  desktopOnboardingPermissionsBodyProfessional:
    'Notability needs microphone and audio access to capture your meetings.',
  desktopOnboardingPermissionsBodyStudent: 'Notability needs microphone and audio access to capture your lectures.',
  desktopOnboardingPermissionsCta: 'Restart and get started',
  desktopOnboardingPermissionsTitleProfessional: 'Record and transcribe your meetings',
  desktopOnboardingPermissionsTitleStudent: 'Record and transcribe your classes',
  desktopOnboardingPermissionSystemAudioDescription: 'Record calls, videos and podcasts on your device.',
  desktopOnboardingPermissionSystemAudioLabel: 'System audio',
  desktopOnboardingRecordBodyProfessional:
    "Tap to record, and jot down what matters to you. After the meeting, we'll finish your notes and fill in the gaps so nothing gets missed.",
  desktopOnboardingRecordBodyStudent:
    'Tap to record, and we do the rest. After class, we turn your recordings and notes into quizzes, flashcards and practice tests.',
  desktopOnboardingRecordKickerStudent: 'You? Just stay focused.',
  desktopOnboardingRecordTitleProfessional: 'You record. We finish the notes.',
  desktopOnboardingRecordTitleStudent: 'You record. We make the study guide.',
  desktopOnboardingStoryBodyProfessional:
    'Six weeks of meetings, and every decision that matters is buried. Sound familiar?',
  desktopOnboardingStoryBodyStudent: 'Notebooks and print outs, and no idea where to start. Sound familiar?',
  desktopOnboardingStoryCta: 'Show me how',
  desktopOnboardingStoryKicker: 'There’s a better way.',
  desktopOnboardingStoryTitleProfessional: 'Presentation Friday.\nNotes everywhere.',
  desktopOnboardingStoryTitleStudent: 'Exam on Thursday.\nNotes everywhere.',
  desktopPermissionEnableMicrophone: 'Enable microphone',
  desktopPermissionEnableSystemAudio: 'Enable system audio',
  desktopPermissionMicrophoneEnabled: 'Microphone enabled',
  desktopPermissionRestarting: 'Restarting…',
  desktopPermissionRestartToFinishSetup: 'Restart to finish setup',
  desktopPermissionSystemAudioEnabled: 'System audio enabled',
  desktopRecordingDiscardCancel: 'Keep recording',
  desktopRecordingDiscardConfirm: 'Discard recording',
  desktopRecordingDiscardDetail: 'The audio recorded so far will be lost.',
  desktopRecordingDiscardTitle: 'A recording is in progress',
  desktopSignInDecisionBody:
    'This browser is signed into Notability as <Bold>{{email}}</Bold>, proceed with this account?',
  desktopSignInDecisionContinue: 'Continue',
  desktopSignInDecisionSwitch: 'Switch accounts',
  desktopSignInDecisionTitle: 'Signed into browser',
  desktopSignInSuccessBody: 'Return to the Notability app to continue.',
  desktopSignInSuccessTitle: 'Sign in successful',
  desktopStatusQuit: 'Quit',
  desktopUpdateAvailableLabel: 'Update',
  desktopUpdateAvailableTooltip: 'Update available',
  desktopUpdateLater: 'Later',
  desktopUpdateReadyBody:
    'Restart to update to the latest version of Notability. Any changes to your notes will be saved.',
  desktopUpdateReadyHeading: 'Update ready',
  desktopUpdateRecordingInProgressBody:
    "Updating Notability will restart the application and end your current recording, anything you've recorded already will be saved.",
  desktopUpdateRestartFailed: "Couldn't restart to update. Try again.",
  desktopUpdateRestartNow: 'Restart now',
  desktopUpdateUpdatingLabel: 'Updating',
  desktopUpsellBannerAppLink: 'Get the desktop app for a faster, offline-ready experience',
  desktopUpsellBannerLead: 'Notability for {{platform}} is here.',
  desktopUpsellBannerLoginLink: 'Get the desktop app instead',
  developer: 'Developer',
  diameterPixels: '{{diameter}} pixels',
  disconnect: 'Disconnect',
  disconnectFailedRetry: "We couldn't disconnect that account right now. Please try again.",
  discordFooterAlt: 'Notability Discord Link',
  discountBannerAllPlansText: 'Get 20% off all plans',
  discover: 'Discover',
  discussionCardHint:
    'A natural, guided, back-and-forth discussion with <bold>Sage</bold> on the core topics of your notes. Select a topic below to get a conversation started.',
  discussionErrorGeneric: 'Unable to start discussion. Please try again later.',
  discussionErrorTitle: 'Discussion Unavailable',
  discussionFreeformPlaceholder: 'Type your response...',
  discussionFreeformPreResponse: 'Let me think about that...',
  discussionGenericOverview: 'What would you like to learn about next?',
  discussionInternalError: 'Internal error communicating with Sage.  Contact support if the problem persists.',
  discussionLabel: 'Teach Me',
  discussionPreviewDescription: 'Chat with Sage to explore key concepts from your notes',
  discussionRevisit: 'Revisit discussion',
  discussionSetTopicMessage: 'Teach me about {{topicTitle}}',
  discussionSwitchTopicMessage: 'I want to change the subject. Tell me about {{topicTitle}}',
  discussionTopicStart: "{{topicTitle}}?  Let's dive in!",
  dismiss: 'Dismiss',
  disposableEmailNotAllowed:
    "This email address can't be used for a Business account. Please use your work email address.",
  dividerCountPluralSimple_one: '{{count}} divider',
  dividerCountPluralSimple_other: '{{count}} dividers',
  dividerName: 'Divider name',
  documentsCannotBeAddedToWhiteboardsYet: "Documents can't be added to whiteboards yet",
  doesNotApply: 'Does Not Apply',
  done: 'Done',
  dotted: 'Dotted',
  downgradedHeader: 'You have been removed from {{businessName}}',
  downgradedMessage1:
    'You still have access to your private library by logging into your <a href="{{loginLink}}">Notability account</a>.',
  downgradedMessage2: 'You no longer have access to Shared Libraries in {{businessName}}.',
  downgradedMessage3: 'If this is a mistake, contact your organization owner to be re-invited to {{businessName}}.',
  downgradedSubject: 'You have been removed from {{businessName}}',
  Download: 'Download',
  Downloaded: 'Downloaded',
  downloadedNotesEmptyText: 'Any note you download will appear here for easy reference later.',
  Downloading: 'Downloading',
  downloadNotability: 'Download Notability',
  downloadNotabilityForAndroid: 'Notability for Android',
  downloadNotabilityForIpad: 'Notability for iPad',
  downloadNotabilityForiPadAndiPhone: '<bold>Download Notability</bold> for iPad and iPhone',
  downloadNotabilityForIphone: 'Notability for iPhone',
  downloadNotabilityForMac: 'Notability for Mac',
  downloadNotabilityForWindows: 'Notability for Windows',
  downloadNote: 'Download Note',
  downloadOnAndroid: 'Download on Android',
  downloadOnIOS: 'Download on iOS',
  downloadOurMobileApp: 'Download our mobile app for the best experience.',
  downloadPDF: 'Download PDF',
  downloadsAndroidRequirement: 'Requires Android 12 and up.',
  downloadsHeroSubtitle: 'Take your notes on Mac, Windows, iPad, iPhone, Android, and <webLink>the web</webLink>.',
  downloadsHeroTitle: 'Get Notability',
  downloadsIosRequirement: 'Requires iOS or iPadOS 17 and up.',
  downloadTheApp: 'Download the app',
  duplicate: 'Duplicate',
  duplicateEducationLevels: 'Duplicate values for education level provided not allowed',
  duplicateNoteTitle: '{{noteTitle}} copy',
  edit: 'Edit',
  'Edit Note Details': 'Edit Note Details',
  editAccessRequested: "Edit access requested. You'll hear back if it's granted.",
  editAvatarButton: 'Change Avatar',
  editBioBlurbHint: 'Add a personal bio to help other Notability users like you find you!',
  editBioButton: 'Edit Profile',
  editBioSocialHint: 'Have other accounts you want to share?',
  editBioSocialUsername: '@username',
  editBioTitle: 'Introduce Yourself!',
  editBioYoutubeHint: 'youtube.com/...',
  editCollection: 'Edit Collection',
  editCollectionIsFeatured: 'Feature This Official Collection',
  editCollectionIsOfficial: 'This is an official Ginger Labs Collection.',
  editCollectionName: 'Collection Name',
  editCollectionOfficialId: 'Official collection ID',
  editCollections: 'My Collections',
  editEntityGroupAction: 'Edit group',
  editFolder: 'Edit folder',
  editFolderWithTitle: 'Edit "{{folderTitle}}"',
  editGoal: 'Edit goal',
  editLink: 'Edit',
  editLinkContextMenu: 'Edit link',
  editor: 'Editor',
  editorAccessRequiredToUploadFiles: 'Editor access required to upload files',
  editOrganizer: 'Edit',
  editOrganizerColorTab: 'Show color picker',
  editOrganizerColorTabTooltip: 'Choose a color',
  editOrganizerEmojiTab: 'Show emoji picker',
  editOrganizerEmojiTabTooltip: 'Choose an emoji',
  editStudyMaterial: 'Edit study material',
  editSubject: 'Edit subject',
  editSubjectWithTitle: 'Edit "{{subjectTitle}}"',
  editWorkspaceError: 'There was an error editing the shared library',
  educationHeaderLink: 'Education',
  educationPageDescription1:
    'Schools managing devices can use Notability for free. Notability for Education is full-featured and configurable with mobile device managers (MDMs), such as Jamf and Mosyle.',
  educationPageDescription2:
    "Notability is a trusted member of Apple's Education Partner Program. If you're a device administrator, tap Get Started below.",
  educationPageTitleLegacy: 'Get Notability for Education <Highlight>Free</Highlight>',
  educationTitle: 'We help<br></br>students <EducationHighlight>learn</EducationHighlight>',
  eduLicenseKeyReminderEmailMessage:
    'We noticed that you currently have no active licenses. To get started, you can log in to your Admin Panel below and follow the instructions to set up your app configuration for license key distribution. If you have any questions, feel free to reach out to edusupport@gingerlabs.com.',
  eduLicenseKeyReminderEmailSubject: 'License Key Deployment',
  eduLicenseRequestPageTitle: 'Notability for Education License Request',
  eduOrgRejectedEmailMessage:
    'Your request to enroll for {{orgName}} was not approved. {{rejectionReason}} Please contact edusupport@gingerlabs.com for more details.',
  eduOrgRejectedEmailSubject: 'Your Notability organization request was not approved',
  email: 'Email',
  'Email Address': 'Email Address',
  'Email Verified': 'Email Verified',
  emailAddress: 'Email address',
  emailAddresses: 'Email addresses',
  emailAlreadyInUseError: 'An account with this email address already exists',
  emailMayBeInvalid: 'Email address may be invalid',
  emailNotVerifiedNoteEditError: 'You must verify your email address before editing a note',
  emailNotVerifiedNotePublishError: 'You must verify your email address before publishing a note',
  emailValidationError: 'Please enter a valid email address',
  emailWillHaveFullAccess: '<email>{{email}}</email> will have full access to their notes and Shared Libraries again.',
  emoji: 'Emoji',
  emojiPickerLoadFailed: 'Couldn’t load emojis. Please try again later.',
  emojiShortcutMenu: 'Emoji shortcut menu',
  emojiShortcutNoResults: 'No emojis found',
  emptyFoldersPlaceholder: 'Organize notes into folders.',
  emptyLibraryGuideExplainer:
    'It looks like you don’t have any notes, get started by importing or creating a new note now!',
  emptyNotesGuideExplainer: 'Notes and imports go here.',
  emptyOtherReportReasonError: "Please provide an explanation for 'Other' option.",
  emptySubjectsPlaceholder: 'Organize notes into subjects.',
  endsInCountDays: 'Ends in {{count}} days',
  endsToday: 'Ends today',
  enforcedSso: 'Enforced SSO',
  enforcedSsoConfirmBody: 'All members of {{organizationName}} will be signed out and need to sign back in.',
  enforcedSsoConfirmGoogleTitle: 'Require sign in with Google?',
  enforcedSsoConfirmMicrosoftTitle: 'Require sign in with Microsoft?',
  enforcedSsoNoRequirements: 'No requirements',
  enforcedSsoRequireGoogle: 'Require sign in with Google',
  enforcedSsoRequireMicrosoft: 'Require sign in with Microsoft',
  enjoyLimitedAccess: 'Enjoy limited access to premium features with your {{tierName}} user account.',
  enjoyLimitedAccessWithStarter: 'Enjoy limited access to our premium features with Notability Starter.',
  enjoyPremiumFeaturesWithPlus: 'Enjoy premium features with Plus',
  'Enter Password': 'Enter Password',
  'Enter password instead': 'Enter password instead',
  'Enter your email address to request a password reset email.':
    'Enter your email address to request a password reset email.',
  'Enter your email address to verify your account.': 'Enter your email address to verify your account.',
  enterGiftCode: 'Enter gift code',
  enterYourEmail: 'Enter your email',
  entityAlignBottom: 'Align bottom',
  entityAlignHorizontalCenter: 'Align horizontal centers',
  entityAlignLeft: 'Align left',
  entityAlignRight: 'Align right',
  entityAlignTop: 'Align top',
  entityAlignVerticalCenter: 'Align vertical centers',
  Eraser: 'Eraser',
  eraserPromptBody: 'Pick the eraser then drag to remove ink and more!',
  eraserPromptTitle: 'Erase by dragging',
  eraserStyle: 'Eraser style',
  errorContentNotFound: 'Not Found',
  errorFeatureNotSupportedApple:
    'This Notability feature is unavailable in this browser. For the best experience, download Notability from the App Store or open Notability in Chrome or Edge.',
  errorFeatureNotSupportedHeader: 'Browser not supported',
  errorFeatureNotSupportedOther:
    'This Notability feature is unavailable in this browser. For the best experience, switch to the Chrome or Edge browser.',
  errorFetchingHelpContent: 'There was an error in loading Help content. Please refresh your browser and try again.',
  errorHeader: 'Sorry, something went wrong.',
  errorLoadingNotifications: 'Notifications could not load. Please try again or contact support.',
  errorLoadingPDF: 'Error Loading PDF',
  errorNetworkError: 'There was an issue communicating with the server.  Contact customer support if it persists.',
  errorNoAnimatedAvatarsAllowed: 'Animated avatars are not allowed.',
  errorNoRecordingPermission: 'Browser audio recording permission denied.',
  errorNoteChangeWhileRecording: 'Cannot exit note: recording in progress.',
  errorPlayingRecording: 'A playback error occurred.',
  errorRecording: 'Error recording audio.',
  errorRecordingCouldNotStart:
    "We couldn't start recording. Try again, or restart your browser if the problem continues.",
  errorRecordingDeviceAudio:
    "We couldn't add your computer's audio to the recording. Your microphone is still recording.",
  errorRecordingFormatNotSupported: 'Browser does not support recording a Notability-compatible audio format.',
  errorRecordingMicInUse:
    'Your microphone is in use by another app or browser tab. Close any apps or tabs using your mic (e.g. Zoom, Teams) and try again.',
  errorRecordingMicMuted:
    "Your microphone was muted by another app. We'll continue recording, but no audio is being captured. Unmute it or close the other app.",
  errorRecordingMicUnavailable:
    'Your microphone disconnected and no other one is available, so nothing is being recorded right now. Reconnect a microphone to continue.',
  errorRecordingNoMicrophoneSubtitle: 'Connect or enable a microphone to record audio.',
  errorRecordingNoMicrophoneTitle: 'Microphone not available',
  errorRecordingNoPermissionsSubtitle: 'Please check your browser settings and try again.',
  errorRecordingNoPermissionsTitle: 'Permission required to access your microphone',
  errorRecordingNoSystemAudioSubtitle: 'Please check your system settings and try again.',
  errorRecordingNoSystemAudioTitle: 'Permission required to record system audio',
  errorText: 'Please refresh the page or try again later.',
  errorUnsupportedContentType: 'Unsupported Content Type',
  errorUnsupportedFileTypeSelected: 'An unsupported file type was selected.',
  errorValidatingYoutubeVideo: 'Error validating YouTube video. Please try again.',
  etsyHandleLengthError: 'Etsy shopname must be between {{minLength}} and {{maxLength}} characters long.',
  etsyUsername: 'Etsy',
  example1Emailexample2Email: 'example1@mail.com, example2@mail.com',
  expand: 'Expand',
  expandChat: 'Expand chat',
  expiredMagicLink: 'Your login link has expired.',
  expiredPlayStorePurchaseToken: 'This subscription has expired. Please renew to continue.',
  expiresToday: 'Expires today',
  explainThis: 'Explain this',
  extractingInsightsFromYourRecordings: 'Extracting insights from your recordings...',
  facebookFooterAlt: 'Notability Facebook link',
  failedMigrationSizeLimitError: 'Note is too large to upload',
  failedToAddToClipboard: 'Error copying to the clipboard. Please try again.',
  false: 'False',
  families: 'families.',
  faqHeaderLink: 'FAQ',
  favorite: 'Favorite',
  Favorite: 'Favorite',
  Favorited: 'Favorited',
  favoritedNotesEmptyText: 'Like a note? Want to see it again easily? Favorite any note and it will show up here.',
  favoriteHintAdded: 'Added to Favorites',
  favoriteHintRemoved: 'Removed from Favorites',
  featureAdminPortalLink: 'Admin Portal Link',
  featureCollections: 'Note Collections (edit)',
  featureComments: 'comments',
  featureControlsAiFeatures: 'AI features',
  featureControlsAiFeaturesCaption: 'Includes all AI-powered features',
  featureControlsAiSection: 'AI',
  featureControlsAllowAi: 'Allow AI features',
  featureControlsAllowAiCaption: 'Members cannot use AI-powered features such as Smart Notes, transcription, and chat.',
  featureControlsAllowCapturePhoto: 'Allow capture photo',
  featureControlsAllowCapturePhotoCaption: 'Members cannot capture photos with the camera.',
  featureControlsAllowExports: 'Allow exports',
  featureControlsAllowExportsCaption: 'Allows users to export notes on iOS and Android',
  featureControlsAllowLinkSharing: 'Allow link sharing',
  featureControlsAllowLinkSharingCaption: 'Members cannot generate or copy share links to notes.',
  featureControlsAllowNoteGallery: 'Allow note gallery',
  featureControlsAllowNoteGalleryCaption: 'Members cannot publish notes to the public Notability Gallery.',
  featureControlsAllowPhotoLibrary: 'Allow photo library imports',
  featureControlsAllowPhotoLibraryCaption: 'Members cannot insert images from their photo library.',
  featureControlsAllowWebClip: 'Allow web clip',
  featureControlsAllowWebClipCaption: 'Members cannot save web pages as clips into notes.',
  featureControlsCapturePhoto: 'Capture photo',
  featureControlsCapturePhotoCaption: 'Allows capturing photos and inserting them into notes on iOS and Android',
  featureControlsExportSection: 'Export options',
  featureControlsExportTypeAirDrop: 'AirDrop',
  featureControlsExportTypeBox: 'Box',
  featureControlsExportTypeDropbox: 'Dropbox',
  featureControlsExportTypeEmail: 'Email',
  featureControlsExportTypeGoogleDrive: 'Google Drive',
  featureControlsExportTypeOneDrive: 'OneDrive',
  featureControlsExportTypeOpenIn: 'Other apps',
  featureControlsExportTypeWebDav: 'WebDAV',
  featureControlsInsertSection: 'Insert content',
  featureControlsIntune: 'Microsoft Intune',
  featureControlsIntuneCaption: 'Requires Microsoft Intune app protection enrollment on managed iOS devices',
  featureControlsLinkSharing: 'Link sharing',
  featureControlsLinkSharingCaption: 'Allows note sharing via links',
  featureControlsLinkSharingDisabled:
    'This feature is disabled by your organization.<br/>Contact your organization owner for access.',
  featureControlsNoteAccess: 'Note access',
  featureControlsNoteAccessCaption:
    'Allows Notability employees to access customer notes in response to customer support requests',
  featureControlsNoteAccessInfo: 'Notability employees will never access notes without customer permission.',
  featureControlsNoteAccessInfoLabel: 'About note access',
  featureControlsNoteGallery: 'Note gallery',
  featureControlsNoteGalleryCaption: 'Allows publishing and downloading notes from the Notability community',
  featureControlsNoteGallerySection: 'Note Gallery',
  featureControlsPhotoLibrary: 'Photo library',
  featureControlsPhotoLibraryCaption: 'Allows importing photos',
  featureControlsSettingTitle: 'Feature Controls',
  featureControlsSharingSection: 'Sharing',
  featureControlsWebClip: 'Web clip',
  featureControlsWebClipCaption: 'Allows inserting webpage previews into notes',
  featuredCollection: 'Featured Collection',
  featuredCollectionsCannotBeEmpty: 'You cannot feature a collection that has no notes',
  featureDisabledByOrgMessage: 'Contact your organization owner for access.',
  featureDisabledByOrgTitle: 'This feature is disabled by your organization.',
  featureInkHeader: 'Make marks with our ink',
  featureInkText: 'Ink so smooth that you might just forget it’s digital. ',
  featureListHeader: 'Enabled Features',
  featureMagicLinks: 'Magic Links',
  featureMatrixCaptionFree: 'Free',
  featureMatrixCaptionOneTimePurchase: 'One-time purchase',
  featureMatrixCategoryAi: 'AI',
  featureMatrixCategoryCollaboration: 'Collaboration',
  featureMatrixCategoryNoteTaking: 'Note-Taking',
  featureMatrixCategoryOrganization: 'Organization',
  featureMatrixCategorySupport: 'Support',
  featureMatrixFeatureAdminFeatureControls: 'Admin-based feature controls',
  featureMatrixFeatureAudioPlaybackSync: 'Audio playback sync',
  featureMatrixFeatureAudioRecording: 'Audio recording',
  featureMatrixFeatureAudioTranscription: 'Audio transcription',
  featureMatrixFeatureAuditLog: 'Audit Log',
  featureMatrixFeatureChatWithNotes: 'Chat with your notes',
  featureMatrixFeatureCloudStorage: 'Cloud storage',
  featureMatrixFeatureConvertMathLatex: 'Convert handwritten math to LaTeX',
  featureMatrixFeatureConvertMathToLatex: 'Convert Math to LaTeX',
  featureMatrixFeatureCustomerSupport: 'Customer support',
  featureMatrixFeatureFlashcardsQuizzes: 'Flashcards and quizzes',
  featureMatrixFeatureFlashcardsQuizzesInSettings: 'Flashcards and quizzes (available in settings)',
  featureMatrixFeatureFolders: 'Folders',
  featureMatrixFeatureHandwritingAnnotation: 'Handwriting and annotation',
  featureMatrixFeatureHandwritingRecognition: 'Handwriting recognition',
  featureMatrixFeatureHandwritingSearch: 'Handwriting search',
  featureMatrixFeatureICloudStorage: 'iCloud storage',
  featureMatrixFeatureImportPdfsDocsSlides: 'Import PDFs, docs, and slides',
  featureMatrixFeatureIntuneMamIntegration: 'Intune MAM (Mobile Application Management) integration',
  featureMatrixFeatureLinkSharing: 'Link sharing',
  featureMatrixFeatureLiveAudioTranscription: 'Live audio transcription',
  featureMatrixFeatureLiveCollaboration: 'Live collaboration',
  featureMatrixFeatureLiveSmartNotes: 'Live Smart Notes',
  featureMatrixFeatureMultiNote: 'Multi-note',
  featureMatrixFeatureNotabilityCloud: 'Notability Cloud',
  featureMatrixFeatureNotes: 'Notes',
  featureMatrixFeatureOutlines: 'Outlines',
  featureMatrixFeatureScanPaperDocuments: 'Scan paper documents',
  featureMatrixFeatureSharedLibraries: 'Shared Libraries',
  featureMatrixFeatureStickersGifsImages: 'Hundreds of stickers, GIFs, and images',
  featureMatrixFeatureSummaries: 'Summaries',
  featureMatrixFeatureSyncedAcrossDevices: 'Synced across devices',
  featureMatrixFeatureTemplatesNoteGallery: '20,000+ templates and note gallery',
  featureMatrixFeatureTemplatesPlannersWorksheets: 'Templates, planners and worksheets',
  featureMatrixFeatureThirdPartyBackup: 'Third party back-up',
  featureMatrixFeatureVersionHistory: 'Version history',
  featureMatrixFeatureYoutubeConversion: 'YouTube link-to-note conversion',
  featureMatrixPagerLabel: '{{current}} of {{total}}',
  featureMatrixPagerNext: 'Next plan',
  featureMatrixPagerPrevious: 'Previous plan',
  featureMatrixSupportContact: 'Contact <supportEmail>{{emailAddress}}</supportEmail>',
  featureMatrixSupportPrompt: 'Have questions or need support?',
  featureMatrixTagHigherMonthlyLimit: 'Higher monthly limit',
  featureMatrixTagLimited: 'Limited',
  featureMatrixTagUnlimited: 'Unlimited',
  featureMatrixTierBusiness: 'Business',
  featureMatrixTierBusinessPro: 'Business Pro',
  featureMatrixTierClassic: 'Classic',
  featureMatrixTierCustomContract: 'Custom Contract',
  featureMatrixTierLite: 'Lite',
  featureMatrixTierPlus: 'Plus',
  featureMatrixTierPro: 'Pro',
  featureMatrixTierStarter: 'Starter',
  featureMatrixTitle: 'Compare plans',
  featureMatrixValue20GbFailSafe: '20 GB (fail safe)',
  featureMatrixValue30Days: '30 days',
  featureMatrixValue5: '5',
  featureMatrixValue7Days: '7 days',
  featureMatrixValue90Days: '90 days',
  featureMatrixValueAvailableForBusinessPro: 'Available for Business Pro',
  featureMatrixValueAvailableForFree: 'Available for free',
  featureMatrixValueDedicatedSupport: 'Dedicated support',
  featureMatrixValueIncluded: 'Included',
  featureMatrixValueIosAndroidOnly: 'iOS and Android only',
  featureMatrixValueIosOnly: 'iOS only',
  featureMatrixValueNotabilityCloudOnly: 'Notability Cloud only',
  featureMatrixValueNotIncluded: 'Not included',
  featureMatrixValueNotSupported: 'Not supported',
  featureMatrixValueSupported: 'Supported',
  featureMatrixValueUnlimited: 'Unlimited',
  featureNotifications: 'Notifications',
  featureOfficialCollections: 'Official Note Collections',
  featurePresentHeader: 'Present and share your notes',
  featurePresentText:
    'View a second hidden note while presenting, share your notes to our public <1>Notability Gallery</1> and download notes from others!',
  featurePresentTextNoGallery: 'View a second hidden note while presenting.',
  featureReadCollections: 'Note Collections (view)',
  featureReplayHeader: 'Record and replay your notes',
  featureReplayText: 'Note replay captures audio and automatically syncs it to notes.',
  featureShowFeatures: 'Display Enabled Features',
  featureTemplates: 'Note Templates',
  featureThemeEditor: 'Theme Editor',
  featureThemes: 'UI Themes',
  fileOwner: 'File owner',
  fill: 'Fill',
  fillInTheBlank: 'Fill in the Blank',
  fillOutFormToCompleteSignupProcess: 'Fill out the form below to complete the sign up process.',
  finalizingSmartNotes: 'Finalizing Smart Notes...',
  findingPatternsWorthRemembering: 'Finding patterns worth remembering...',
  findInNote: 'Find in note',
  finishNotes: 'Finish my notes',
  finishNotesApplied: 'Text and transcripts combined into comprehensive notes',
  finishNotesApplyFailed: "Your notes are ready, but we couldn't add them to your page.",
  finishNotesCancelBody: 'This discards the version being generated. Your note is unchanged.',
  finishNotesCancelTitle: 'Stop finishing notes?',
  finishNotesCueCardBody:
    "Record a meeting or lecture, and Notability can finish your notes when it's over, filling in the details you missed while you were listening.",
  finishNotesCueCardTitle: 'Stay focused in the moment',
  finishNotesEditedWhileFinishing: 'Your note changed while finishing. Try again to include your edits.',
  finishNotesEnableAiCardBody: "Turn on Notability AI and we'll turn your transcript into organized notes.",
  finishNotesEnableAiCardCta: 'Enable AI features',
  finishNotesEnableAiCardTitle: 'Automatic notes from recording',
  finishNotesKeepGoing: 'Keep going',
  finishNotesMiscellaneousHeading: 'Miscellaneous',
  finishNotesNeedsMoreContent: 'Not enough content to summarize.',
  finishNotesOffline: "You're offline. Check your connection.",
  finishNotesRecordingStillProcessing: "Your recording isn't ready yet. Try {{action}} again in a moment.",
  finishNotesRetryableFailure: 'Something went wrong finishing your notes.',
  finishNotesStatusReadingTranscripts: 'Reading the transcripts…',
  finishNotesStatusReviewingNotes: 'Reviewing your notes…',
  finishNotesStatusUploading: 'Saving your recording…',
  finishNotesStop: 'Stop',
  finishNotesTerminalFailure: "We couldn't finish your notes. Add more notes or record more, then finish again.",
  finishNotesTranscriptionFailed: "We couldn't read your recording.",
  finishNotesTranscriptionUnavailable: "This recording can't be transcribed.",
  finishPersonalization: 'Finish personalization',
  finishQuiz: 'Finish quiz',
  finishSettingUp: 'Finish setting up',
  fixedWidth: 'Fixed Width',
  flaggingReasonNotFound: 'That flagging reason does not exist.',
  flagSuccessMessage: 'Thank you! We have received your report, which will be reviewed by our moderation team.',
  flashcardImportChooserInstructions:
    'To get started with flashcard import, make sure your TXT, CSV, or APKG file is saved on this device.',
  flashcardImportDelimiterComma: 'Comma',
  flashcardImportDelimiterCustom: 'Custom',
  flashcardImportDelimiterNewLine: 'New line',
  flashcardImportDelimiterSemicolon: 'Semicolon',
  flashcardImportDelimiterTab: 'Tab',
  flashcardImportEditorAddCard: 'Add a card',
  flashcardImportEditorAddDefinitionToFinish: 'Add a definition to finish this card',
  flashcardImportEditorAddTermToFinish: 'Add a term to finish this card',
  flashcardImportEditorDefinitionLabel: 'Definition',
  flashcardImportEditorDeleteCard: 'Delete card',
  flashcardImportEditorInstructions: 'Add a term and definition for each card.',
  flashcardImportEditorMissingDefinition: 'A card is missing a definition.',
  flashcardImportEditorMissingTerm: 'A card is missing a term.',
  flashcardImportEditorPlaceholderDefinition: 'Enter definition',
  flashcardImportEditorPlaceholderTerm: 'Enter term',
  flashcardImportEditorTabCreate: 'Create your own flashcards',
  flashcardImportEditorTabPaste: 'Paste text',
  flashcardImportEditorTermLabel: 'Term',
  flashcardImportErrorAnkiCollectionUnreadable:
    "We couldn't read the flashcards inside that Anki package. Try exporting it from Anki again.",
  flashcardImportErrorEmptyInput: 'Add some flashcard text before importing.',
  flashcardImportErrorNoFlashcardsFound:
    "We couldn't find any flashcards. Check that each row has both a term and a definition.",
  flashcardImportErrorNoOpenNote: 'Open a note first, then import these flashcards into it.',
  flashcardImportErrorNoteCreationFailed:
    "We couldn't create a note for these flashcards. Check your connection and try again.",
  flashcardImportErrorQuotaExceeded:
    'Your plan includes up to 3,000 imported flashcards. Upgrade to Plus or Pro for unlimited imports.',
  flashcardImportErrorUnreadableFile: "We couldn't read that file. It may be corrupted.",
  flashcardImportErrorUnsupportedFileType: "Notability can't import {{extension}} files. Try a TXT, CSV, or APKG file.",
  flashcardImportErrorUploadFailed: "Your flashcards couldn't be imported. Check your connection and try again.",
  flashcardImportErrorUploadRejected:
    "Notability couldn't accept this flashcard set. Try importing a smaller set, or contact support if this keeps happening.",
  flashcardImportFeature1Title: 'Upload Files',
  flashcardImportFeature3Title: 'Study like a pro',
  flashcardImportManualInstructions:
    'Paste your flashcard text into the input field — choose your delimiter and hit Import.',
  flashcardImportManually: 'Import manually',
  flashcardImportPageTitle: 'Improved Flashcards',
  flashcardImportPartialSuccess: 'Imported {{accepted}} of {{total}} flashcards.',
  flashcardImportPasteLabel: 'Flashcard text',
  flashcardImportPastePlaceholder:
    'Paste your flashcard text here:\n\nFlower, Plant with petals\nSun, Ball of gas\netc.',
  flashcardImportQuotaTitle: "You've reached your import limit",
  flashcardImportRowDelimiterCustomLabel: 'Custom separator between rows',
  flashcardImportRowDelimiterLabel: 'Between rows',
  flashcardImportSupportedFileTypes:
    'Notability supports <underline>TXT</underline>, <underline>CSV</underline>, and <underline>APKG</underline> file types for import.',
  flashcardImportTermDelimiterCustomLabel: 'Custom separator between term and definition',
  flashcardImportTermDelimiterLabel: 'Between term and definition',
  flashcardImportUploadFromAnki: 'Upload from Anki',
  flashcards: 'Flashcards',
  flashcardsCompleted: '<bold>{{count}}</bold> of <bold>{{total}}</bold> flashcards completed',
  flashcardsMastered: '<bold>{{count}}</bold> of <bold>{{total}}</bold> flashcards mastered',
  floatingChatPlaceholder: 'What should I catch up on?',
  folderContainsNoNotes: '<bold>{{title}}</bold> <noShrink>contains no notes</noShrink>',
  folderCount_one: '1 folder',
  folderCount_other: '{{count}} folders',
  folderQuizNoteCountOutOfRange: 'Choose between {{minNotes}} and {{maxNotes}} notes, then try again.',
  folderQuizNotOpen: 'This quiz has ended. Start a new one from the folder.',
  folders: 'Folders',
  folderTitle: 'Folder title',
  follow: 'Follow',
  followedUserDoesNotExistError: 'The user you are trying to follow does not exist',
  follower: 'Follower',
  followers: 'Followers',
  following: 'Following',
  fontSizeLabel: 'Font size',
  footerAppStore: 'Get Notability',
  footerCompany: 'Company',
  footerCopyright: '©2026 Ginger Labs - Notability is a registered trademark of Ginger Labs, Inc.',
  footerCopyrightLine1: '© 2026 Ginger Labs',
  footerCopyrightLine2: 'Notability is a registered trademark of Ginger Labs, Inc.',
  footerHeadingApps: 'Apps',
  footerHeadingNotability: 'Notability',
  footerLinkAboutUs: 'About us',
  footerLinkBlog: 'Blog',
  footerLinkJobs: 'Jobs',
  footerLinkMedia: 'Media',
  footerLinkPrivacy: 'Privacy Policy',
  footerLinkPrivacyV2: 'Privacy policy',
  footerLinkSupport: 'Support',
  footerLinkTermsOfService: 'Terms of Service',
  footerLinkTermsOfServiceV2: 'Terms of service',
  footerMadeWithLove: 'made with <Heart></Heart> in San Francisco',
  footerNotabilityAlt: 'notability',
  footerProduct: 'Product',
  footerSocial: 'Connect with us',
  footerSubscribe: 'Subscribe to our newsletter',
  footerSubscribeFailure: 'There was an error submitting your email. Please try again.',
  footerSubscribePlaceholder: 'Enter email address',
  footerSubscribeSuccess: 'You are now subscribed to receive newsletter updates.',
  footerTwobird: 'Twobird',
  forBestExperience: 'For the best experience, use a desktop device.',
  'Forgot password?': 'Forgot password?',
  forQuestionsReachOutToBusinessSupport: 'For questions, reach out to <Link>businesssupport@gingerlabs.com</Link>.',
  freehandSelection: 'Freehand',
  freeTierNoteLimitDescription:
    "Use Notability's core note-taking features with {{limit}} editable notes. Cloud syncing and Auto-Backup not included.",
  freeTrialOfPlus: 'Free trial of Notability Plus',
  fullPasswordRequirementsDescription:
    'Your password must be at least 8 characters, and contain at least one number and one special character.',
  fullScreen: 'Full screen',
  galleryBusinessTitle: 'Business',
  galleryEducationTitle: 'Edu',
  galleryNoteNotFoundBannerText: "We couldn't find that note.",
  galleryOverview: 'Gallery Overview',
  galleryPlannerText:
    'Take inspiration from this monthly planner on ways you can keep track of your time and boost your productivity!',
  galleryPlannerTitle: 'April Planner',
  galleryPortraitText:
    'Notability can be your digital canvas for your next artistic idea. Try mixing pen and highlighter tools to get this shaded effect.',
  galleryPortraitTitle: 'Portrait',
  galleryPostsArePublicDescription: 'Please do not upload personal information of any kind to the gallery.',
  galleryPostsArePublicTitle: 'Gallery Posts Are Public',
  gallerySchoolNotesText: 'Chemistry class notes covering Benzene, the simplest arene!',
  gallerySchoolNotesTitle: 'Chemistry: Benzene',
  galleryTitle: 'Gallery',
  galleryWelcomeNotification:
    'Find inspiration and take your notes to the next level with the <1>Notability Gallery</1> — tap to learn more.',
  general: 'General',
  generalAccess: 'General access',
  generalSubmissionError: 'An error occurred while submitting your request. Please try again.',
  generatingSmartNotes: 'Generating Smart Notes',
  genericFailureExplanation: 'Something went wrong, please try again later.',
  genericLoading: 'Loading...',
  getApp: 'Get App',
  getAppText: 'Available for iPad, Mac, and iPhone. Download now and unleash your ideas on all platforms.',
  getAppTitle: 'Get Notability on the App Store',
  getATasteNonPaidTier: 'Get a taste with {{tierName}}',
  getCollabNotesError: 'There was an error fetching your library. Please try again.',
  getInspired: 'Get inspired',
  getLiveTranscriptionWithPro: 'Get Live Transcription with Pro',
  getMoreDoneQuicker: 'Get <underline>more</underline> done, quicker',
  getOrganizerServiceError: 'Failed to retrieve',
  getStarted: 'Get started',
  getStartedButton: 'Get Started',
  getStartediOSORWeb: 'Get started with Notability on iOS or web.',
  getStartedWithNotabilityButton: 'Get started with Notability',
  getUnlimitedAiUsage: 'Get unlimited AI usage',
  getUnlimitedQuizzes: 'Get unlimited quizzes and flashcards',
  getUnlimitedSmartNotes: 'Get unlimited Smart Notes',
  getUnlimitedTranscripts: 'Get unlimited Transcripts',
  gift: 'Gift',
  giftAlreadyRedeemed: 'Gift already redeemed',
  giftAlreadyRefunded: 'Gift has been refunded, and is not eligible for redemption.',
  giftAutoRenewQuestion: 'Auto-renew?',
  giftFormMessageLabel: 'Add a note (optional)',
  giftFormNow: 'Now',
  giftFormRecipientEmailLabel: 'Recipient email',
  giftFormRecipientFirstNameLabel: 'Recipient first name',
  giftFormSchedule: 'Schedule',
  giftFormScheduleNote: 'Scheduled gifts send at 9am PST.',
  giftFormSenderEmailLabel: 'Sender email',
  giftFormSenderNameLabel: 'Sender name',
  giftFormWhenLabel: 'When should we send the gift?',
  giftHeroSubtitle:
    'Help someone with a full year of access to our best note-taking, learning and productivity features.',
  giftHeroTitle: 'Give the gift\nof Notability',
  giftHeroTitleInline: 'Give the gift of Notability',
  giftInvalidStatus: 'Gift cannot be redeemed in this status',
  giftInvoicedRequiresNoSubscription:
    'This gift can only be redeemed by an account without an existing subscription. Please redeem from an account with no active subscription, or contact support for assistance.',
  giftNotFound: 'Gift not found',
  giftNotYetSent: 'This gift is scheduled for future delivery and cannot be redeemed yet',
  giftPageTitle: 'Give the Gift of Notability',
  giftPaymentSuccessButton: 'Give another',
  giftPaymentSuccessSubtitle: 'Look for a confirmation email shortly.',
  giftPaymentSuccessTitle: "Congrats, you've successfully gifted Notability.",
  giftPurchaseConfirmationSubject: 'Thanks, your Notability gift is confirmed 🎁',
  giftRedemption: 'Gift Redemption',
  giftRedemptionSuccess: 'Congrats, enjoy your year of {{productName}} from {{gifterName}}.',
  giftStep1: 'Select Plus or Pro',
  giftStep2: 'Enter information',
  giftStep3: 'Give the gift of learning',
  giftSubject: '{{senderName}} gave you a year of Notability {{tier}}',
  giftSubjectChargeback: 'Your Notability gift subscription has ended',
  giftSubjectConfirmation: 'Thanks, your Notability gift is confirmed 🎁',
  giftSubjectFixed: '{{senderName}} gave you a year of {{notabilityTier}}',
  giftSubjectRedemptionSuccessfulGiftee: 'Your 1-year of {{notabilityTier}} starts today🤘',
  giftSubjectRedemptionSuccessfulGifter: 'Your Notability gift has been redeemed 🎉',
  giftUndeliverableEmailSubject: "ACTION NEEDED: your Notability gift couldn't be delivered",
  giftUndeliverableTierMismatchSubject: "Your Notability gift couldn't be redeemed by {{recipientName}}",
  giftUserHasExistingSubscription: 'You already have a subscription. Please contact support to redeem your gift.',
  giftUserHasExistingSubscriptionRefund:
    'You already have a subscription, and cannot redeem this gift. The person who sent you this gift will be refunded. Please contact support for additional details.',
  giftUserInOrganizationOrBusiness:
    'Gift subscriptions cannot be redeemed for organization or business accounts. Please contact support for assistance.',
  giftWhatTheyGetTitlePlus: "What they'll get in Plus for a full year...",
  giftWhatTheyGetTitlePro: "What they'll get in Pro for a full year...",
  giveCreditDescription: 'Credit the creator when publishing notes or templates inspired by existing content.',
  giveCreditTitle: 'Give Credit',
  goalTitle: 'Goal title',
  goalTitlePlaceholder: 'Study 2 hours daily',
  goalType: 'Goal type',
  goBack: 'Go back',
  goBackAndTryAgain: 'Go back and try again',
  goodJob: 'Good job!',
  gotIt: 'Got it',
  goToBrowserToCompleteSignIn: 'Go to the browser to complete sign in',
  goToCustomerPortal: 'Go to Customer Portal',
  goToNotability: 'Go to Notability',
  goToQuiz: 'Go to quiz',
  goToSettingsUsersToInvite: 'Go to Settings > Users to invite users to {{organizationName}}',
  grantedEditAccessToast: '{{name}} granted edit access',
  grantedViewAccessToast: '{{name}} granted view access',
  grantNoteAccessError: 'There was an error granting access to this note',
  greatWork: 'Great work!',
  grid: 'Grid',
  groupEntitiesAction: 'Group',
  guaranteeBadgeText: 'NOTABILITY LEARN GUARANTEE',
  guaranteeFaqLink: 'Frequently asked questions',
  guaranteeFinalHeading: 'Start the year organized. Download Notability today.',
  guaranteeGetTheApp: 'Get the app',
  guaranteeHeroCopy1: 'Make something of every lecture, every late night and every idea.',
  guaranteeHeroCopy2: "If it doesn't help, the rest of the semester is on us.",
  guaranteeHeroTerms: 'Terms and Conditions',
  guaranteeLockupGuarantee: 'GUARANTEE',
  guaranteeLockupLearn: 'LEARN',
  guaranteeLockupNotability: 'NOTABILITY',
  guaranteeOfferCta: 'Get student discount',
  guaranteeOfferEnds: 'ENDS SEPT 15',
  guaranteeOfferHeading: 'Get 20% off Notability Plus for students',
  guaranteeOfferSubtext: 'Unlimited storage, audio recording, and PDF annotation.',
  guaranteePageTitle: 'Learn Guarantee',
  guaranteePhotoStripAlt: 'Students using Notability',
  guaranteeStat1Label: 'students & educators',
  guaranteeStat1Value: '20M+',
  guaranteeStat2Label: 'app store rating',
  guaranteeStat2Value: '4.8/5',
  guaranteeStat3Label: 'schools used Notability',
  guaranteeStat3Value: '1.5k+',
  guaranteeStep1Body: 'Sign up for a Notability Plus or Pro between July 15 and September 30.',
  guaranteeStep1Title: 'Subscribe',
  guaranteeStep2Body:
    'Use Notability to capture notes from any source: audio recordings, handwritten, typed, annotated, etc.',
  guaranteeStep2Title: 'Take notes',
  guaranteeStep3Body:
    "to generate flashcards and quizzes to help you lock in the knowledge you've captured in class. If you don't feel more prepared for your mid terms, fill out the form and we'll extend your subscription for 90 days for free.",
  guaranteeStep3Title: 'Use Learn',
  guaranteeStepsChip: 'Learn Guarantee',
  guaranteeStepsHeading: "If Learn doesn't help you, the semester is on us",
  guaranteeTestimonial2Name: 'Shelby Elder',
  guaranteeTestimonial2Quote:
    '“Notability has absolutely saved me time, reduced my stress, and improved my retention. 10,000%.”',
  guaranteeTestimonial3Name: 'Ruby Massuard',
  guaranteeTestimonial3Quote: '“I use Notability for all my lectures because the note-taking is just so good.”',
  guaranteeTestimonialName: 'Jon Liu',
  guaranteeTestimonialQuote:
    '“Notability made preparing for my final exams so much easier. Having all my notes and highlights in one place helped me stay organized, study more efficiently, and feel confident on exam day.”',
  guaranteeTestimonialsHeading: 'Loved by students everywhere',
  Hand: 'Hand',
  headerIconsAlt: 'Header icons',
  heading1: 'Heading 1',
  heading2: 'Heading 2',
  heading3: 'Heading 3',
  help: 'Help',
  helpAndSupport: 'Help & Support',
  helpCenter: 'Help Center',
  heroSubtextWeb:
    'Stop just taking notes. Start learning from them. Notability Web turns your typed notes into personalized, AI-powered summaries, quizzes, flashcards and more.',
  heroTitle: 'Turn your notes into knowledge',
  hexColorLabel: 'Hex color',
  hideLibrary: 'Hide library',
  hideNavigation: 'Hide navigation',
  Highlighter: 'Highlighter',
  holdTight: 'Hold tight, taking longer than expected',
  home: 'Home',
  homeHeroLetsGetStarted: "Let's get started",
  homeQuestionPreviewAriaLabel: 'Continue studying {{title}}',
  homeStudyMaterials: 'Study materials',
  hotkeyBold: '{{platformKey}}B',
  hotkeyCodeBlock: '{{platformKey}}⇧C',
  hotkeyItalic: '{{platformKey}}I',
  hotkeyLink: '{{platformKey}}K',
  hotkeyNewNote: '{{platformKey}}N',
  hotkeyStrikethrough: '{{platformKey}}⇧X',
  hotkeyUnderline: '{{platformKey}}U',
  hours: 'Hours',
  howDoISyncAcrossDevices: 'How do I sync notes across devices?',
  howDoISyncAcrossDevicesAnswer:
    "<Bold>To sync notes across devices, you'll need both of these:</Bold><br/><br/>• You're signed in with the same Notability account email on each device.<br/>• Your iPad/iPhone is synced to Notability Cloud.<br/><br/>Start with the account email first (it's the most common fix). Then confirm Notability Cloud is synced.",
  howDoSubscriptionsWorkAcrossDevices: 'How do subscriptions work across my devices?',
  howDoSubscriptionsWorkAcrossDevicesAnswer:
    "Your plan is tied to your Notability account email. To see the same plan across devices, sign in with the same email on Notability Web and on your iPad/iPhone.<br/><br/>If the emails don't match, your plan may look different.",
  howDoYouWantToStudy: 'How do you want to study?',
  howOften: 'How often',
  'I am 16+ years old': 'I am 16+ years old',
  'I am over 16 years old': 'I am over 16 years old',
  identifyingKeySections: 'Identifying key sections...',
  'If this email address belongs to a Notability account, we have sent a password reset email to it.':
    'If this email address belongs to a Notability account, we have sent a password reset email to it.',
  'If this email address is associated with an unverified account, we have sent it a verification email.':
    'If this email address is associated with an unverified account, we have sent it a verification email.',
  imageUploadTypeError: 'Upload failed. Only image files are supported.',
  import: 'Import',
  importAFileLongDescription: 'PDF, DOC, PPT, Google Drive, and Dropbox.',
  importAsNewNote: 'Import as new note',
  importDragAndUpload: 'Drag a file or <underline>upload from your device</underline>',
  importFiles: 'Import files',
  importFlashcards: 'Import flashcards',
  importFlashcardSets: 'Import flashcard sets',
  importFromDrive: 'Import from Drive',
  importModalFootnoteGoogleTooltipTypes: 'Docs, Sheets, Slides',
  importModalFootnoteMicrosoftTooltipTypes: 'Word, PowerPoint, Excel',
  importModalSupportedTypesFootnote:
    'Notability supports PDF, image, <google>Google</google> and <microsoft>Microsoft</microsoft> file types.',
  importNote: 'Import',
  importNoteTooltip: 'Import note',
  importQuizContent: 'Import quiz content',
  importToCurrentNote: 'Import to current note',
  imSignedInButPlanIsntShowingCorrectly: 'I’m signed in, but my plan isn’t showing correctly. What should I do?',
  imSignedInButPlanIsntShowingCorrectlyAnswer:
    'First, confirm your account email matches on:<br/><br/>• Notability Web: Settings → Account<br/>• iPad/iPhone: Settings → Account<br/><br/>If the emails match and your plan isn’t showing correctly, go to Settings → Help → <Link>Contact Support</Link> to submit a request. This includes your diagnostic info, which helps us resolve your issue faster.',
  in: 'in',
  inactiveUsers: 'Inactive users',
  inappropriateContentDescription: "Content that is illegal, pornographic, racist, sexist or graphic isn't allowed.",
  inappropriateContentTitle: 'No Inappropriate Content',
  includedInStudyMaterial: 'Included in study material',
  includesAllAI: 'Includes all AI-powered features.',
  includesAudioTranscription: 'Convert your audio recordings to text, making them readable and searchable.',
  includesStudyFeatures: 'Includes study features such as quizzes and flashcards.',
  Incorrect: 'Incorrect',
  incorrectUsernamePasswordError: 'Invalid username or password. Please try again.',
  individual: 'Individual',
  individualPlans: 'Individual Plans',
  industry: 'Industry',
  industryIsRequired: 'Industry is required.',
  industryNotFoundError: 'Industry does not exist',
  inNoteTitle: 'In-note title input',
  inputTextNotProvided: 'No input text provided',
  Insert: 'Insert',
  insertDocument: 'Document',
  insertDocumentFormats: 'PDF, PPT, DOC',
  insertEmoji: 'Insert emoji',
  insertFolder: 'Insert folder',
  insertFromGoogleDrive: 'From Google Drive',
  insertFromGoogleDriveFormats: 'DOC, PDF, PPT',
  insertImage: 'Image',
  insertImageFormats: 'JPEG, PNG, GIF, WEBP',
  insertLink: 'Insert link',
  insertYouTube: 'YouTube',
  insertYouTubeDescription: 'Summarize Videos',
  Inspiration: 'Inspiration',
  instagramFooterAlt: 'Notability Instagram link',
  instagramHandleLengthError: 'Instagram username must be between {{minLength}} and {{maxLength}} characters long.',
  instagramServiceName: 'Instagram',
  instagramUsername: 'Instagram',
  'Internal server error': 'Internal server error',
  internalErrorMessage: 'Something went wrong. Incident identifier: {{incidentID}}',
  'Invalid password': 'Invalid password',
  'Invalid Password Link': 'Invalid Password Link',
  'Invalid username or password': 'Invalid username or password',
  invalidAdminGetUserDataArgs: 'Must provide either a username, email, or transaction id.',
  invalidBusinessAction: 'Business action is invalid',
  invalidCategoryError: 'No topic chosen',
  invalidCategoryValidationError: 'You must include a valid category',
  invalidClientMetadataError: 'The provided client metadata is invalid.',
  invalidEmail: 'Invalid email',
  invalidExportTypesError: 'Invalid export type provided',
  invalidFileType: 'Unsupported file type',
  invalidFileTypeDescription: 'We do not currently support {{fileExtension}} files',
  invalidInsertFileType: 'Unsupported file type',
  invalidInvitationError: 'Invalid or expired invitation link.',
  invalidJWTVersion: 'You have been logged out due to a change in your account.',
  invalidNewNoteFileType: 'Cannot create new notes from {{fileExtension}} files',
  invalidNoteLanguage: 'Invalid note language',
  invalidNoteOwnerError: 'You are not the owner of this published note',
  invalidPasswordError: 'Invalid Password',
  invalidPlayStorePurchaseToken: 'This purchase could not be verified. Please try again.',
  invalidPriceIdError: 'Price ID is invalid',
  invalidSamsungPurchase: 'This purchase could not be verified. Please try again.',
  invalidStripeActionForInvoice:
    'Your account is paid by invoice. Please contact businesssupport@gingerlabs.com to make changes.',
  invalidTagError:
    '#{{{tag}}} is not a valid tag. Tags may contain up to {{maxCharacters}} letters, numbers, emojis, and underscores.',
  invalidTagFormatError: 'Invalid tag format: "{{{tag}}}"',
  invalidUserDownloadedNotesError: 'You cannot see the downloaded notes of other people',
  invalidYoutubeUrl: 'Please paste a valid YouTube video link.',
  invitationAlreadyProcessed: 'This invitation has already been accepted or has expired.',
  invite: 'Invite',
  inviteExpired: 'Invite expired',
  inviteFailed: 'Invite failed',
  inviteOthersByEmail: 'Invite others by email',
  invitePeopleToSharedLibrary: 'Invite people to {{libraryName}}',
  inviteResults: 'Invite results',
  inviteSent: 'Invite sent!',
  inviteUsers: 'Invite users',
  inviteUsersByEmail: 'Invite users by email',
  inviteUserToBusinessError: 'There was an error inviting the user(s) to the organization',
  inviteUserToNoteError: 'There was an error in inviting the user(s) to the note',
  inviteUserToWorkspaceError: 'There was an error inviting the user(s) to the shared library',
  iOS: 'iOS',
  iosWebOfferSuccessSubtitle: 'Your plan is ready in the app.',
  iosWebOfferSuccessTitle: "You're subscribed",
  ipad: 'iPad',
  ipadDownloadBannerLink: 'Open your notes on iPad to get the full Notability experience',
  iphone: 'iPhone',
  iPurchasedOnOneDeviceHowDoIUseOnOther: 'I subscribed to Notability on one device. How do I use it on another?',
  iPurchasedOnOneDeviceHowDoIUseOnOtherAnswer:
    "Your plan is tied to your Notability account email. To see it on both web and iPad/iPhone:<br/><br/><Bold>On iPad/iPhone</Bold><br/>• Sign in with that same email (or, if you subscribed on web, sign in on iPad/iPhone with the same email you used on web).<br/><br/><Bold>On Notability Web</Bold><br/>• Open Notability and go to Settings → Account to confirm the email.<br/><br/>Once you're using the same Notability account on both, your plan should show automatically.",
  ipViolation: 'Intellectual Property Violation',
  issueDetails: 'Issue details',
  italic: 'Italic',
  joinOurCommunity: 'Join our community',
  justNotes: 'Just notes',
  justNow: 'Just now',
  keep: 'Keep',
  keepOrganization: 'Keep organization',
  keepPracticing: 'Keep practicing',
  keepSubscription: 'Keep subscription',
  Language: 'Language',
  'language-da': 'Danish',
  'language-de': 'German',
  'language-en': 'English',
  'language-es': 'Spanish',
  'language-fr': 'French',
  'language-id-ID': 'Indonesian',
  'language-it': 'Italian',
  'language-ja': 'Japanese',
  'language-ko': 'Korean',
  'language-ms': 'Malaysian',
  'language-nb': 'Norwegian',
  'language-nl': 'Dutch',
  'language-pt': 'Portuguese',
  'language-ru': 'Russian',
  'language-sv-SE': 'Swedish',
  'language-th': 'Thai',
  'language-tr': 'Turkish',
  'language-uk-UA': 'Ukranian',
  'language-vi': 'Vietnamese',
  'language-zh-Hans': 'Chinese (Simplified)',
  'language-zh-Hant': 'Chinese (Traditional)',
  languageSetting: 'Search Language',
  largeOrgSignupEmailMessage: '%s has requested an admin account. Please review the request to proceed.',
  largeOrgSignupEmailSubject: 'An organization needs your approval',
  largePdfTocGuide: 'Document is too large to study at once, please select specific chapters.',
  largeTitle: 'Large Title',
  lastUpdatedDate: '<0>Last updated </0><1>{{lastUpdatedDate}}.</1>',
  lastUpdatedXMinutesAgo_one: 'Last updated {{count}} minute ago',
  lastUpdatedXMinutesAgo_other: 'Last updated {{count}} minutes ago',
  layoutSetToPaged: 'Layout set to paged',
  layoutSetToPageless: 'Layout set to pageless',
  learn: 'Learn',
  learn404: 'The Learn content you are referencing could not be found',
  learnAccurateInformation: 'Accurate information',
  learnContinueQuiz: 'Continue in {{count}}',
  learnContinueStudying100: 'Keep it up!',
  learnContinueStudying99: "Let's keep going!",
  learnCopyFullTranscript: 'Copy full transcript',
  learnDismissButton: 'Dismiss',
  learnErrorContentTooShort: 'Need more content',
  learnErrorContentTooShortSubtitle: 'To utilize Learn on this note, additional content is required.',
  learnErrorCreatingFlashcardsSubtitle: 'Something went wrong creating your flashcards. Please retry.',
  learnErrorCreatingFlashcardsTitle: 'Error creating flashcards',
  learnErrorCreatingQuestionsSubtitle: 'Something went wrong creating your questions. Please retry.',
  learnErrorCreatingQuestionsTitle: 'Error creating questions',
  learnErrorCreatingSummarySubtitle: 'Something went wrong creating your summary. Please retry.',
  learnErrorCreatingSummaryTitle: 'Error creating summary',
  learnErrorCreatingTestSubtitle: 'Something went wrong creating your test. Please retry.',
  learnErrorCreatingTestTitle: 'Error creating test',
  learnErrorInsufficientContext: 'Try different content',
  learnErrorInsufficientContextSubtitle: 'This note content cannot be processed by Learn.',
  learnErrorNoInternet: 'Please check your connection',
  learnErrorNoSubscription: 'Learn is a Plus feature',
  learnErrorNoSubscriptionSubtitle: 'Upgrade to Notability Plus for access.',
  learnErrorPdfUnreadableSubtitle: 'Please retry.',
  learnErrorPdfUnreadableTitle: "Couldn't read this PDF",
  learnFeedbackEmailUs: 'Email us',
  learnFeedbackInappropriateContent: 'Inappropriate content',
  learnFeedbackIncorrectAnswer: 'Incorrect answer',
  learnFeedbackIncorrectInformation: 'Incorrect information',
  learnFeedbackIrrelevantInformation: 'Irrelevant information',
  learnFinishQuiz: 'Finish',
  learnFlashcardDoNotKnowButton: "I don't know",
  learnFlashcardKnowThisButton: 'I know this',
  learnFlashcardMarkAsNotStudiedButton: 'Mark as not studied',
  learnFlashcardMarkAsStudiedButton: 'Mark as studied',
  learnFlashCardQuestionProgress: '<1>{{currentQuestionNumber}}</1><0>of</0><1>{{totalQuestions}}</1>',
  learnFlashcardRatingAgain: 'Again',
  learnFlashcardRatingEasy: 'Easy',
  learnFlashcardRatingGood: 'Good',
  learnFlashcardRatingHard: 'Hard',
  learnFlashcardsCaughtUp: 'All caught up',
  learnFlashcardsCaughtUpBody: 'No cards are due for review right now. Check back later to keep them fresh.',
  learnFlashcardsCaughtUpKeepReviewing: 'Keep reviewing flashcards',
  learnFlashcardsCaughtUpTitle: "You're all caught up",
  learnFlashcardsDueCount_one: '<bold>{{count, number}}</bold> card due',
  learnFlashcardsDueCount_other: '<bold>{{count, number}}</bold> cards due',
  learnFlashcardsDueCountTruncated: '<bold>{{count, number}}+</bold> cards due',
  learnFlashcardSeeAnswerButton: 'See definition',
  learnFlashcardSeeQuestionButton: 'See term',
  learnFlashcardsQuizTitle: 'Flashcards',
  learnFlashcardStudiedLabel: 'Studied',
  learnGoalCadenceCustom: 'Custom',
  learnGoalCadenceDaily: 'Daily',
  learnGoalCadenceMonthly: 'Monthly',
  learnGoalCadenceWeekly: 'Weekly',
  learnGoalCompletedSummary_one: 'Schedule • {{dateRange}} • {{count}} session',
  learnGoalCompletedSummary_other: 'Schedule • {{dateRange}} • {{count}} sessions',
  learnGoalIncompleteDescription: 'Reached {{progressHours}} of {{targetHours}} hours',
  learnGoalIncompleteTitle: 'Goal incomplete',
  learnGoalMinutesProgress: '{{progress}}/{{target}} mins',
  learnGoalQuotedTitle: '“{{title}}”',
  learnGoalReminderNone: 'No reminder',
  learnGoalReminderOneDayBefore: '1 day before',
  learnGoalReminderOneHourBefore: '1 hour before',
  learnGoals: 'Learn goals',
  learnGuaranteeCta: 'Learn more',
  learnGuaranteeEyebrow: 'Learn Guarantee',
  learnGuaranteeHeadline:
    "Make something of every lecture, late night, and idea. If Notability doesn't help, we'll cover the cost for the rest of the semester.",
  learnImportButton: 'Import',
  learnInaccurateInformation: 'Inaccurate information',
  learnInvalidQuizSessionType: 'Invalid quiz session type requested',
  learnLoadingContent: 'Building your content',
  learnLoadingQuiz: 'Building your quiz',
  learnLoadingQuizzes: 'Building your quizzes',
  learnLoadingSummary: 'Building your summary',
  learnLowContentBody: 'Start note-taking, record audio or import a document to use Learn.',
  learnLowContentBodyGeneric: 'Start note-taking, record audio or import a document.',
  learnLowContentError: 'Could not find or generate enough material to study.',
  learnLowContentTitle: "There's not enough here, yet!",
  learnMoreGuidelinesDescription: 'Read all guidelines <1>here</1>.',
  learnMoreGuidelinesTitle: 'Curious to learn more?',
  learnMoreTemplateLink: '<1>Learn more</1>',
  learnMultipleChoiceQuestion: '<0>Question</0><1>{{currentQuestionNumber}}</1><0>of</0><1>{{totalQuestions}}</1>',
  learnNewQuestionSet: 'Challenge yourself to another set of 10 harder questions.',
  learnNewQuestionSetCount: 'Challenge yourself to another set of {{count}} harder questions.',
  learnNewQuestionSetCountNew: 'Challenge yourself to a new set of {{count}} questions.',
  learnPaywallBodyGeneric:
    'Access powerful tools like automatic note summaries, audio transcription and intelligent quizzes that make studying and retention easier than ever before.',
  learnPaywallTitleGeneric: 'Upgrade to Plus to access premium features',
  learnQuestionCount: '<bold>{{currentQuestionNumber}}</bold> of <bold>{{totalQuestions}}</bold>',
  learnQuestionCountToReview: '{{count}} to review',
  learnQuizFeedbackSubhead: 'Your feedback helps us to improve future quizzes we generate.',
  learnQuizFeedbackTitle: 'Quiz feedback',
  learnQuizOnboardingBody:
    'Any missed questions will be automatically reviewed alongside new and increasingly challenging questions in each set.',
  learnQuizOnboardingTitle: 'Intelligent quiz progression',
  learnQuotaExceeded: 'You’ve reached your AI usage limit.',
  learnRecordButton: 'Record',
  learnResumeFlashcards: 'Resume flashcards',
  learnResumeMultipleChoice: 'Resume multiple choice',
  learnRetryingConnection: 'Connection issue, retrying…',
  learnReviewQuestionSet: "We'll review the questions you missed alongside new, more challenging questions.",
  learnReviewQuiz: 'Review in {{count}}',
  learnScore100: 'Amazing!',
  learnScore99A: 'Nice work!',
  learnScore99B: 'Nice Try!',
  learnScore99C: 'Almost there!',
  learnScore99D: 'Keep it up!',
  learnScore99E: 'Way to go!',
  learnScore99F: 'Nice job!',
  learnSummaryFeedbackSubhead: 'Your feedback helps us to improve future summaries we generate.',
  learnSummaryFeedbackTitle: 'Summary feedback',
  learnSummaryOnboardingBody:
    "We'll automatically summarize your notes. Study with interactive quizzes that keep you learning.",
  learnSummaryOnboardingTitle: 'Review your summary, study with quizzes',
  learnTooMuchContent: 'You are requesting too much Learn content at once',
  learnTranscriptsEmptySubtitle:
    'Use the recording tool to capture everything you need to generate transcripts, study materials and more!',
  learnTranscriptsEmptyTitle: 'No transcripts, yet!',
  learnTrayEmptySubtitle:
    "In order to create meaningful study materials, you'll need to add more content to your note.",
  learnTrayEmptyTitle: 'No summary, yet!',
  learnYourAnswer: 'Your answer:',
  leftAlign: 'Left align',
  library: 'Library',
  libraryFailedToUpdate: 'Library failed to update',
  libraryFailedToUpdateDescription: 'Unable to connect to the server. Your library may be out of date.',
  librarySurveyFooterButtonFinish: 'Finish the survey',
  librarySurveyFooterButtonStart: 'Take the survey',
  librarySurveyFooterMessage: 'Personalize your experience',
  librarySurveyLink: 'Personalize Notability',
  libraryTabsAriaLabel: 'Library sections',
  licenseRequestSuccessTitle: 'Thank you for your request',
  like: '{{count}} like',
  Like: 'Like',
  Liked: 'Liked',
  likedNotesEmptyText: 'Found a great note and want to see it again easily? Like any note and it will show up here.',
  likeHintAdded: 'Added to Liked',
  likeHintRemoved: 'Removed from Liked',
  likes: '{{count}} likes',
  limitedAccessToPremiumFeatures: 'Limited access to premium features, full access to core note-taking.',
  lineSpacing: 'Line spacing',
  linkAccessLevel: 'Link access',
  linkedinFooterAlt: 'Notability LinkedIn Link',
  linkEditTextAriaLabel: 'Link Text Input',
  linkEditURLAriaLabel: 'URL input',
  linkExpirationWarning: 'Your link will expire in 24 hours.',
  linkTitleFieldLabel: 'Link title',
  linkToNoteFieldLabel: 'Link',
  linkToNoteHasRecording: 'has recording',
  linkToNoteListLabel: 'Notes',
  linkToNoteLoading: 'Loading notes',
  linkToNoteNoResults: 'No matching notes',
  linkToNoteOpen: 'Open note',
  linkToNoteOpenNamed: 'Open note {{name}}',
  linkToNoteOrWebPage: 'Link to a note or web page',
  linkToNoteRecents: 'Recents',
  linkToNoteResultCount_one: '{{count}} note',
  linkToNoteResultCount_other: '{{count}} notes',
  linkToNoteSearchPlaceholder: 'Paste link or search notes',
  linkTooltipLinkCTA: 'Open link in new tab',
  list: 'List',
  lists: 'Lists',
  liveTranscriptionStoppedDescription:
    "The transcription service can't be reached. Your recording will continue, and a full transcript will be generated once it's saved.",
  liveTranscriptionStoppedTitle: 'Live transcription stopped',
  liveTranscriptionUnavailableAiUsageLimit:
    'Live transcription isn’t available because you’ve reached your AI usage limit.',
  liveTranscriptionUpsellTitle: 'Live Transcription',
  lockButton: 'Lock',
  lockSubject: 'Lock Subject',
  'Log in to Notability': 'Log in to Notability',
  'Log out': 'Log out',
  loggingIn: 'Logging in',
  logIn: 'Log In',
  loginButtonText: 'Log In',
  loginPreviewMessage: 'Log in to your Notability account to view the full note and access all features.',
  logo: 'Logo',
  logoutSuccessMessage: "You've successfully signed out.",
  logoutSuccessTitle: 'Signed Out',
  loseAccessHeader:
    "Don't lose access to your favorite features or any summaries, quizzes or transcripts you've already made, subscribe to Plus now.",
  mac: 'Mac',
  magicLinkDidntReceive: "Didn't receive an email?",
  magicLinkEmailMessageMobile:
    'Quickly share notes with links, publish and manage your notes in the Gallery and start following your favorite publishers to stay inspired!\n\nOpen this link to log into the Notability app!',
  magicLinkEmailMessageWeb:
    'Quickly share notes with links, publish and manage your notes in the Gallery and start following your favorite publishers to stay inspired!\n\nOpen this link to log into Notability in your browser!',
  magicLinkEmailSubject: 'Log in to your Notability account',
  magicLinkEnterUsernameExplainer:
    'Your username will appear beneath your published notes in the Gallery. Please enter a username to continue.',
  magicLinkEnterUsernameHeading: 'Enter a username',
  magicLinkExplainer: 'Enter your email and we’ll send you a link to log in!',
  magicLinkLoginSentExplainer:
    "If your email address is connected to a valid account, you'll receive a link you can click to log in.",
  magicLinkLoginSentHeading: 'Check your email!',
  magicLinkSignUpSentExplainer:
    'To log in to your account, please click on the link sent to the email address you provided.',
  magicLinkSignUpSentHeading: 'A link has been sent to your email address.',
  magicLinkSignUpSuccessExplainer: 'To get started, click continue.',
  magicLinkSignUpSuccessHeading: 'Almost there.',
  magicLinkUsernameSuccessExplainer: 'You are now signed in as {{username}}!',
  magicLinkUsernameSuccessHeading: 'Sign up successful!',
  makeAdmin: 'Make Admin',
  makeMember: 'Make Member',
  makingConnectionsBetweenIdeas: 'Making connections between ideas...',
  manageCurrentPlan: 'Manage current plan',
  manageGoals: 'Manage goals',
  manageSubscription: 'Manage subscription',
  manageSubscriptionTitle: 'Manage Subscription',
  manageUsers: 'Manage users',
  manageYourSubscriptionAndViewYourBilling:
    'Manage your subscription and view your billing information in your Stripe customer portal.',
  markAsStudied: 'Mark as studied',
  marketingAboutUsAiTools:
    "Notability's AI-powered tools make it easy for people to act on information across multiple devices in real time.",
  marketingAboutUsBestNotebook:
    "It's the best notebook millions of students and professionals use to understand more, retain more, and move forward faster.",
  marketingAboutUsCarouselGoTo: 'Go to photo {{index}}',
  marketingAboutUsCarouselLabel: 'Photos of the Notability team',
  marketingAboutUsCarouselNext: 'Next photo',
  marketingAboutUsCarouselPrevious: 'Previous photo',
  marketingAboutUsExploreRoles: 'Explore open roles',
  marketingAboutUsHeroImageAlt:
    'Hands taking handwritten notes with an Apple Pencil in Notability on an iPad, on a desk with glasses and books',
  marketingAboutUsHeroTitle: 'About <Scribble>us</Scribble>',
  marketingAboutUsHowWeWorkSub: "A look inside our team and the culture we've built together.",
  marketingAboutUsHowWeWorkTitle: 'How we <Scribble>work</Scribble>',
  marketingAboutUsLead:
    'Notability combines handwritten notes, text, recordings, images, and imported documents into one connected workspace.',
  marketingAboutUsMilestoneAndroidBody:
    'Notability launches on Android through the Google Play Store in August 2026, as a fully native Android app.',
  marketingAboutUsMilestoneApplePencilBody:
    'Notability adds Apple Pencil support in 2015, alongside the first iPad Pro.',
  marketingAboutUsMilestoneApplePencilTitle: 'Apple Pencil support added',
  marketingAboutUsMilestoneBusinessBody:
    'Notability launches for business teams with Shared Libraries, live collaboration, and AI meeting tools.',
  marketingAboutUsMilestoneCloudBody:
    'Notability launches on the web in 2025, with Notability Cloud syncing notes across devices and enabling real-time collaboration.',
  marketingAboutUsMilestoneCloudTitle: 'Notability Cloud launches with the web app',
  marketingAboutUsMilestoneFoundedBody:
    'Fred Mitchell founds Ginger Labs, the software company behind Notability, in Silicon Valley with an accessibility and sensory mission.',
  marketingAboutUsMilestoneFoundedTitle: 'Ginger Labs is founded',
  marketingAboutUsMilestoneGalleryBody:
    'Users are able to publish, discover, and download thousands of templates, planners, and notes for free.',
  marketingAboutUsMilestoneGalleryTitle: 'Notability Gallery launches',
  marketingAboutUsMilestoneInkyBody:
    'Notability introduces Inky, a goose mascot created at an internal company hackathon.',
  marketingAboutUsMilestoneInkyTitle: 'Inky is born',
  marketingAboutUsMilestoneIpadBody:
    'Notability launches on iPad alongside the original iPad, combining handwritten notes with synchronized audio recording.',
  marketingAboutUsMilestoneIpadTitle: 'Notability for iPad',
  marketingAboutUsMilestoneLearnBody:
    'Notability launches Learn, its AI study suite: audio transcription, note summaries, Smart Notes, Quizzes, Flashcards, and Chat With Your Notes.',
  marketingAboutUsMilestoneLearnTitle: 'Notability Learn launches',
  marketingAboutUsMilestoneMacAppBody: 'Apple names Notability its Mac App of the Year in 2014.',
  marketingAboutUsMilestoneMacAppTitle: 'Mac App of the Year',
  marketingAboutUsSanFranciscoImageAlt:
    'The San Francisco–Oakland Bay Bridge seen down a San Francisco street lined with buildings',
  marketingAboutUsTeamPhotoAxeThrowingAlt:
    'Notability teammates posing in front of a mobile axe-throwing cage, with a dog in the foreground',
  marketingAboutUsTeamPhotoBoatAlt: 'The Notability team gathered together on the deck of a boat on San Francisco Bay',
  marketingAboutUsTeamPhotoGoldenGateAlt:
    'Four teammates smiling on a boat deck with the Golden Gate Bridge behind them',
  marketingAboutUsTeamPhotoHalloweenAlt: 'Teammates in Halloween costumes posing together in the Notability office',
  marketingAboutUsTeamPhotoLoungeAlt:
    'Teammates with laptops meeting together in a lounge area of the Notability office',
  marketingAboutUsTeamPhotoMatchingShirtsAlt:
    'Five teammates in matching gray T-shirts cheering and holding up an iPad in the office',
  marketingAboutUsTeamPhotoOnsiteAlt:
    'The full Notability team gathered together outside a glass-walled building during a company on-site',
  marketingAboutUsTeamPhotoSmashRoomAlt:
    'Teammates in hard hats and safety glasses posing in a smash room covered in graffiti',
  marketingAboutUsTeamPhotoStepsAlt: 'A group of teammates sitting together on outdoor steps holding coffee',
  marketingAboutUsTimelineTitle: 'Building notes for how people think',
  marketingAboutUsTrusted:
    'Trusted every day in classrooms and businesses worldwide, including Fortune 500 companies and pro sports teams.',
  marketingAboutUsWhereWeWorkBody:
    "We're building the next generation of tools designed to improve how people learn, think, and collaborate. Join Notability and shape the future of learning.",
  marketingAboutUsWhereWeWorkEyebrow: 'San Francisco, CA',
  marketingAboutUsWhereWeWorkTitle: 'Where we work',
  marketingFaqBasics10Answer:
    'Notability Cloud is our built-in sync service. It keeps your notes backed up, accessible across your devices, and allows for live collaboration with peers on a single note.',
  marketingFaqBasics1Answer:
    'Notability is a powerful digital note-taking app built for students, professionals, and everyone in between. Write by hand or type, record audio while you take notes, annotate PDFs, and use Learn to turn your notes into flashcards, quizzes, and summaries. Everything stays organized and syncs across your devices.',
  marketingFaqBasics1Question: 'What is Notability?',
  marketingFaqBasics2Answer:
    'A note-taking app helps you capture, organize, and find information for class lectures, meeting notes, research, and to-do lists. Your notes stay all in one place instead of scattered across paper, files, and apps. The best note-taking apps also make your notes searchable and easy to share.',
  marketingFaqBasics2Question: 'What is a note-taking app used for?',
  marketingFaqBasics3Answer:
    'Notability combines handwriting, typing, audio, and external media and documents in a single note. You can record a lecture while writing notes, mark up a PDF, and search across all your notes later. Most basic notes apps handle only typed text.',
  marketingFaqBasics3Question: 'How is Notability different from a regular notes app?',
  marketingFaqBasics4Answer:
    "Physical, paper notebooks don't sync your notes, search your notes, or convert your handwriting to text. Notability keeps the feel of writing by hand while adding what paper can't: your notes are all in one place, searchable, backed up, and easy to find months later.",
  marketingFaqBasics4Question: 'Is Notability better than handwritten notebooks?',
  marketingFaqBasics5Answer:
    'Yes. Notability is built for handwriting with an Apple Pencil or Android stylus, with tools for ink color, thickness, and shape recognition, plus Handwriting Recognition to convert what you write into text. Our engineering team has worked diligently to come up with a smooth digital ink engine that feels like pen on paper.',
  marketingFaqBasics5Question: 'Is Notability good for handwritten note-taking on an iPad or Android tablet?',
  marketingFaqBasics6Answer:
    'Notability is available for download on the App Store for iPhone, iPad, and Mac, the Google Play Store for Android devices, or on your web browser at notability.com.',
  marketingFaqBasics6Question: 'How do I download Notability?',
  marketingFaqBasics7Answer:
    'Notability is available on iPhone, iPad, Mac, any Android device, and any web browser on your laptop.',
  marketingFaqBasics7Question: 'What devices can I use Notability on?',
  marketingFaqBasics8Answer: 'Yes. Notability recently launched a fully native Android app on the Google Play Store.',
  marketingFaqBasics8Question: 'Is Notability available on Android?',
  marketingFaqBasics9Answer:
    'Notability Cloud keeps your notes in sync across all your devices, including cross-platform on iOS, Android, and web. Log in to your Notability account to get started. Need help setting up sync? Visit our Help Center.',
  marketingFaqBasics9Question: 'How do I sync my notes across devices?',
  marketingFaqComparisons1Answer:
    'Both Notability and GoodNotes support handwriting and PDF annotation. Notability adds audio transcription and Live transcription, so you can record and transcribe a lecture alongside your written notes. This is useful for students who want a lecture recording tied to the exact moment they wrote something down. Notability also provides powerful study tools via Learn, including comprehensive summaries, quiz questions, and flashcards that you can review — straight from the content in your note.',
  marketingFaqComparisons1Question:
    "What's the difference between Notability vs GoodNotes? Which is better for students?",
  marketingFaqComparisons2Answer:
    'OneNote is built around free-form pages and deep Microsoft integration. Notability requires no app integration, and is built around handwriting-first note-taking, with Handwriting Recognition, Math Conversion, audio transcription, and AI study tools designed specifically for writing by hand and studying from what you wrote.',
  marketingFaqComparisons2Question:
    "What's the difference between Notability vs OneNote? Which is better for students?",
  marketingFaqCtaHeading: 'Ready to take better notes?',
  marketingFaqFeatures1Answer:
    "Learn is Notability's suite of AI tools. With Learn, you can turn your notes into comprehensive study tools. Open any note, tap Learn, and choose to generate flashcards, a quiz, or a summary.",
  marketingFaqFeatures1Question: 'What is Learn?',
  marketingFaqFeatures2Answer:
    'Yes. Handwriting Recognition in Notability turns your handwritten notes into typed text, so you can copy, search, or share what you wrote by hand. It works alongside your original handwriting. Nothing gets erased or replaced.',
  marketingFaqFeatures2Question: 'Can Notability convert handwriting to text?',
  marketingFaqFeatures3Answer:
    'Yes. Audio transcription records a lecture or meeting and turns it into text you can read, search, and edit. Live transcription displays the transcription of your audio recording as you or someone else speaks, so you can follow along in real time.',
  marketingFaqFeatures3Question: 'Can I record and transcribe audio in Notability?',
  marketingFaqFeatures4Answer:
    'Math Conversion turns your handwritten equations into clean, typed LaTeX math notation. Write an equation by hand, and Notability converts it. This is useful for problem sets, study notes, or tutoring sessions.',
  marketingFaqFeatures4Question: 'What is Math Conversion in Notability?',
  marketingFaqFeatures5Answer:
    'Yes. Chat with your notes lets you ask questions about your own notes and get answers pulled directly from them, instead of scrolling to find where you wrote something down. You can also search your notes directly by keyword, and Notability will search all of your notes and handwriting to find the note that includes the keyword you are searching for.',
  marketingFaqFeatures5Question: 'Can I chat with my notes to find things faster?',
  marketingFaqHeroHeading: 'Frequently<br/>asked questions',
  marketingFaqHeroTitle: 'Frequently asked questions',
  marketingFaqLinkDownloadAndroid: 'Download Notability on Android',
  marketingFaqLinkPlans: 'View all plans and pricing',
  marketingFaqLinkStarter: "View what's included in Starter",
  marketingFaqMetaDescription:
    'Everything you want to know about Notability—how to get started, what features are included, and how it compares.',
  marketingFaqPlans1Answer: 'Notability is free to download, and free to use via our Starter plan.',
  marketingFaqPlans1Question: 'Is Notability free?',
  marketingFaqPlans2Answer:
    "You don't need a subscription to use Notability. Our free Starter plan is great for getting started. We also offer Classic, a one-time purchase to Notability that doesn't require a subscription.",
  marketingFaqPlans2Question: 'Do I need a subscription to use Notability?',
  marketingFaqPlans3Answer:
    'To access more advanced features like handwriting recognition, live audio transcription, summaries, and AI study tools, you can purchase a subscription to our Lite, Plus, or Pro plans. More advanced subscriptions like Plus and Pro unlock features like Learn, audio transcription, and more.',
  marketingFaqPlans3Question: "What's the difference between Notability's plans?",
  marketingFaqPlans4Answer:
    'Notability Pro is our subscription for people who want Learn, our most advanced AI study and productivity tools. The plan includes all our core note-taking features, a 90-day version history, and unlimited Live transcription, AI-powered summaries, YouTube link-to-note conversions, quizzes and flashcards, and chat with your notes for explanations and quicker learning.',
  marketingFaqPlans4Question: 'What does Notability Pro include?',
  marketingFaqSectionBasics: 'Basics',
  marketingFaqSectionComparisons: 'Comparisons',
  marketingFaqSectionFeatures: 'Features',
  marketingFaqSectionPlans: 'Plans & pricing',
  marketingFaqSectionUseCases: 'Use cases',
  marketingFaqUseCases1Answer:
    "Yes. Millions of students across the world use Notability to write lecture notes by hand, record and transcribe the lecture at the same time, annotate PDFs and worksheets, study their notes' content through quizzes and flashcards, and search everything later when preparing for exams.",
  marketingFaqUseCases1Question: 'Is Notability good for college students?',
  marketingFaqUseCases2Answer:
    'Yes. Many working professionals and business teams use Notability for their day-to-day tasks in their workplace. You can record a meeting with audio transcription while taking handwritten or typed notes, then search the transcript and your notes together afterward to find decisions or action items.',
  marketingFaqUseCases2Question: 'Can I use Notability for work meetings?',
  marketingFaqUseCases3Answer:
    'Yes. Many teachers use Notability to annotate lesson materials, record and transcribe lectures, come up with quiz content for students, and organize notes by class or subject. Shared Libraries also let teachers distribute notes to students instantly.',
  marketingFaqUseCases3Question: 'Can teachers use Notability in the classroom?',
  marketingFaqVisitHelpCenter: 'Visit the Help Center',
  marketingFlashcardsFeatureInstantUploadDesc:
    'Import documents or manually create and format your own flashcards to create study-able decks.',
  marketingFlashcardsFeatureInstantUploadTitle: 'Instant upload',
  marketingFlashcardsFeatureQuizzesDesc:
    'Activate your learning with instant practice questions, quizzes, and flashcards—all generated directly from your notes.',
  marketingFlashcardsFeatureQuizzesTitle: 'Quizzes',
  marketingFlashcardsFeatureSpacedRepetitionDesc:
    'With spaced repetition, you’ll reinforce long-term knowledge of your study materials. Cards that are harder appear more often, while easier cards are spaced further apart.',
  marketingFlashcardsFeatureSpacedRepetitionTitle: 'Spaced Repetition',
  marketingFlashcardsFeaturesTitle: 'Learn features',
  marketingFlashcardsHeroSubtitle: 'Import from Anki and review flashcards with spaced repetition.',
  marketingFlashcardsHeroTitle: 'Upgrade your studying with improved <MotionScribble>flashcards.</MotionScribble>',
  marketingFlashcardsHowItWorksTitle: 'How it works',
  marketingFlashcardsStep1Body: 'Import text files from Anki, Quizlet, and more.',
  marketingFlashcardsStep2Body: 'We’ll help you memorize your flashcards using spaced repetition.',
  marketingFlashcardsStep2Title: 'Memorize',
  marketingFlashcardsStep3Body: 'Study alongside your notes with Smart Notes, quizzes, and more.',
  marketingFlashcardsTryNow: 'Try now',
  marketingHeaderBuiltFor: 'Built for',
  marketingHeaderBusinessDescription: "Turn your team's notes into clarity, captured in real time.",
  marketingHeaderCloseMenu: 'Close menu',
  marketingHeaderConstructionDescription: 'Work together from the field and the office in real time.',
  marketingHeaderConstructionLink: 'Construction',
  marketingHeaderDownloadToday: 'Download today',
  marketingHeaderIndustries: 'Industries',
  marketingHeaderLawDescription: 'Shared document libraries and AI tools built for the pace of legal work.',
  marketingHeaderLawLink: 'Law',
  marketingHeaderMeetingsDescription: 'The AI notebook for back-to-back meetings, lectures, and conferences.',
  marketingHeaderMeetingsLink: 'Meetings',
  marketingHeaderMenuTitle: 'Menu',
  marketingHeaderOpenMenu: 'Open menu',
  marketingHeaderScrollDown: 'Scroll down',
  marketingHeaderSportsDescription: 'The digital whiteboard that fits in your bag for on-the-go strategy.',
  marketingHeaderSportsLink: 'Sports',
  marketingHeaderWealthManagementDescription:
    'One workspace to run meetings, mark up plans, and stay in sync with your team.',
  marketingHeaderWealthManagementLink: 'Wealth Management',
  marketingHeaderWebApp: 'Web app',
  marketingHomeCarouselNext: 'Next animation',
  marketingHomeCarouselPrevious: 'Previous animation',
  marketingHomeCtaHeading: 'Download Notability for free',
  marketingHomeFeatureActionItemsDesc:
    'Get ahead of your next task with a checklist of action items generated from your meeting notes or recording.',
  marketingHomeFeatureAnnotationDesc: 'Mark up any PDF, textbook, lecture slides, images, presentations, and more.',
  marketingHomeFeatureAnnotationTitle: 'Annotation',
  marketingHomeFeatureAudioRecordingDesc: 'Record lectures, meetings, and ideas while you write—fully synced.',
  marketingHomeFeatureChatDesc: 'Ask Notability questions about your note and get instant explanations.',
  marketingHomeFeatureEditableRecordingsDesc:
    'Adjust playback speed or trim audio recordings to listen to what matters most.',
  marketingHomeFeatureEditableRecordingsTitle: 'Editable recordings',
  marketingHomeFeatureFoldersDesc: 'Keep your notes organized in customizable folders within folders.',
  marketingHomeFeatureFoldersTitle: 'Organized folders',
  marketingHomeFeatureHandwritingDesc:
    'Handwrite or sketch with fluid digital ink and customizable pens and highlighters.',
  marketingHomeFeatureHandwritingTitle: 'Handwritten notes',
  marketingHomeFeatureInstantSummariesDesc:
    'Take notes, import documents, or record audio and get comprehensive summaries in real time.',
  marketingHomeFeatureInstantSummariesTitle: 'Instant summaries',
  marketingHomeFeatureLiveCollaborationDesc: 'Work with multiple team members on one note in real time.',
  marketingHomeFeatureLiveTranscriptionDesc: 'Get live transcripts that are searchable the moment they’re created.',
  marketingHomeFeaturePlaybackSyncDesc: 'Tap any word in your notes to jump to that exact moment in the recording.',
  marketingHomeFeaturePlaybackSyncTitle: 'Playback sync',
  marketingHomeFeatureRealtimeSyncDesc: 'View edits in a note instantly across devices.',
  marketingHomeFeatureRealtimeSyncTitle: 'Real-time sync',
  marketingHomeFeatureSearchableDesc: 'Search your handwriting, typed notes, transcripts, and PDFs in seconds.',
  marketingHomeFeatureSearchableTitle: 'Searchable notes',
  marketingHomeFeatureShareableNotesDesc:
    'Invite team members to collaborate on a note or share the note as a PDF or via a link.',
  marketingHomeFeatureShareableNotesTitle: 'Shareable notes',
  marketingHomeFeatureSharedLibrariesDesc:
    'Create a shared library of notes and documents that your whole team can access from anywhere.',
  marketingHomeFeatureSharedLibrariesTitle: 'Shared Libraries for business teams',
  marketingHomeFeatureStickersDesc: 'Add stickers, GIFs, and images to your note.',
  marketingHomeFeaturesTitle: 'Tools for every idea',
  marketingHomeFeatureStudyMaterialsDesc:
    'Activate your learning with instant practice questions, quizzes, and flashcards—all generated directly from your notes.',
  marketingHomeFeatureStudyMaterialsTitle: 'Study materials',
  marketingHomeFeatureTapeDesc:
    'Use Tape to practice active recall, emphasize key concepts, and add personality to your note.',
  marketingHomeFeatureTemplatesDesc: 'Download hundreds of digital templates, planners, and worksheets.',
  marketingHomeFeatureTemplatesTitle: 'Note templates',
  marketingHomeFeatureYoutubeDesc:
    'Convert any YouTube video into a full note about the video’s content with a transcript and summary.',
  marketingHomeFeatureYoutubeTitle: 'YouTube link-to-note',
  marketingHomeHeroDownloadAndroid: 'Download for Android',
  marketingHomeHeroDownloadHeading: 'Download for free',
  marketingHomeHeroDownloadIOS: 'Download for iOS',
  marketingHomeHeroDownloadWeb: 'Download for Web',
  marketingHomeHeroSubtitle:
    'Stop just taking notes. Start learning from them.<br></br>Handwritten notes, live audio transcription, AI-powered quizzes and flashcards, and more.',
  marketingHomeHeroSubtitleChina: 'Take handwritten notes—with easy audio capture, sketching, and annotation.',
  marketingHomeHeroTitleV2: 'Notes that help you <MotionScribble>think</MotionScribble>',
  marketingHomeTabNoteTaking: 'Note-taking',
  marketingHomeTabPersonalization: 'Personalization',
  marketingHomeToolbarNextTab: 'Next tab',
  marketingHomeToolbarPreviousTab: 'Previous tab',
  marketingInplaceInterestFeatureAudioBody:
    'Record a voice note while you write. Your handwriting plays back in step with the audio, so context comes along with the markup.',
  marketingInplaceInterestFeatureAudioTitle: "Say what a note can't",
  marketingInplaceInterestFeatureFilesBody:
    "PDFs, drawings, scans, and images from your team's cloud storage open as a Notability note you can write on.",
  marketingInplaceInterestFeatureFilesTitle: 'Work on the files you bring in',
  marketingInplaceInterestFeatureInkBody:
    'Pen, pencil, and highlighter with real pressure and tilt on Apple Pencil. Mark up a drawing as fast as you would on a print.',
  marketingInplaceInterestFeatureInkTitle: 'Ink that feels like ink',
  marketingInplaceInterestFeaturesBody:
    'Notability was built to feel like paper, then made better. The same pen, highlighter, and audio notes work on every PDF and drawing you bring in.',
  marketingInplaceInterestFeaturesTitle: 'Handwriting is the <Highlight>point.</Highlight>',
  marketingInplaceInterestFormBody:
    "Let us know where files live, who marks them up, and what happens after. We're talking with teams now to learn where this helps most.",
  marketingInplaceInterestFormCompanyPlaceholder: 'Company name',
  marketingInplaceInterestFormEmailLabel: 'Work email',
  marketingInplaceInterestFormLocationsHint: '(Select all that apply)',
  marketingInplaceInterestFormLocationsLabel: 'Where do your files live?',
  marketingInplaceInterestFormOptional: '(Optional)',
  marketingInplaceInterestFormPoint1: 'A short, no-pressure walkthrough',
  marketingInplaceInterestFormPoint2: 'We come with questions, not a pitch',
  marketingInplaceInterestFormPoint3: 'Your answers help shape what we build',
  marketingInplaceInterestFormPrivacyNote: "We'll only use this to reach out about this feature.",
  marketingInplaceInterestFormRolePlaceholder: 'What you do',
  marketingInplaceInterestFormTitle: 'Tell us how your team works.',
  marketingInplaceInterestHeroBody:
    'Open PDFs and drawings from OneDrive, Box, or Egnyte. Annotate them in Notability, then save them back to the source.',
  marketingInplaceInterestHeroCta: 'Talk to our team',
  marketingInplaceInterestHeroNote: 'Built for iPad and Apple Pencil',
  marketingInplaceInterestHeroTitle: 'Mark up your files with the best handwriting tool.',
  marketingInplaceInterestStep1Body:
    'Pick a file from OneDrive, Box, or Egnyte. Notability keeps track of where it came from.',
  marketingInplaceInterestStep1Title: 'Import to Notability',
  marketingInplaceInterestStep2Body: 'Write, highlight, sketch, and record — the way you would on any Notability note.',
  marketingInplaceInterestStep2Title: 'Annotate the file',
  marketingInplaceInterestStep3Body:
    'One tap returns the annotated file to the same folder it started in, as a new version.',
  marketingInplaceInterestStep3Title: 'Save back to its location',
  marketingInplaceInterestStepsBody:
    'Notability remembers where the file came from, so you never have to find the folder again, rename anything, or ask which copy is current.',
  marketingInplaceInterestStepsTitle: 'Saving your edits back is one tap.',
  marketingIntegrationsBoxDesc: 'Bring your Box files into Notability, and write them back to the same place.',
  marketingIntegrationsBoxName: 'Box',
  marketingIntegrationsDropboxDesc: 'Bring your Dropbox files into Notability, and write them back to the same place.',
  marketingIntegrationsDropboxName: 'Dropbox',
  marketingIntegrationsDynamicsDesc:
    'Create and import notes from Dynamics 365, linking them with your Notability library. Push notes into Dynamics 365.',
  marketingIntegrationsDynamicsName: 'Microsoft Dynamics 365',
  marketingIntegrationsEmailLabel: 'Where should we reach you?',
  marketingIntegrationsEmailPlaceholder: 'you@company.com',
  marketingIntegrationsGoogleDriveDesc:
    'Bring your Google Drive files into Notability, and write them back to the same place.',
  marketingIntegrationsGoogleDriveName: 'Google Drive',
  marketingIntegrationsGridSub:
    "We are building integrations in priority order based on interest from our customers. Don't see the integration you want? <requestLink>Let us know</requestLink>.",
  marketingIntegrationsGridTitle: "Select all integrations you'd be interested in, then submit your response below.",
  marketingIntegrationsHeroSub:
    "We're making it easier to connect Notability to the systems where your documents live. Let us know which matter most to your team.",
  marketingIntegrationsHeroTitle: 'Which tools should Notability <Highlight>connect</Highlight> to?',
  marketingIntegrationsIftttDesc: 'Trigger actions between Notability and your apps.',
  marketingIntegrationsIftttName: 'IFTTT',
  marketingIntegrationsIManageDesc: 'Link iManage documents and matters to your notes.',
  marketingIntegrationsIManageName: 'iManage',
  marketingIntegrationsN8nDesc: 'Automate Notability workflows with n8n.',
  marketingIntegrationsN8nName: 'n8n',
  marketingIntegrationsOneDriveDesc:
    'Bring your OneDrive files into Notability, and write them back to the same place.',
  marketingIntegrationsOneDriveName: 'OneDrive',
  marketingIntegrationsPageTitle: 'Integrations',
  marketingIntegrationsPipedriveDesc:
    'Create and import notes from Pipedrive, linking them with your Notability library. Push notes into Pipedrive.',
  marketingIntegrationsPipedriveName: 'Pipedrive',
  marketingIntegrationsPrivacyNote:
    "We'll only email you about these integrations. We collect your email only to gauge interest in them.",
  marketingIntegrationsProcoreDesc: 'Connect Procore projects and documents to your notes.',
  marketingIntegrationsProcoreName: 'Procore',
  marketingIntegrationsRequestSub: 'Tell us which tool should connect to Notability, and where to reach you.',
  marketingIntegrationsRequestTitle: "Don't see your tool?",
  marketingIntegrationsSalesforceDesc:
    'Create and import notes from Salesforce, linking them with your Notability library. Push notes into Salesforce.',
  marketingIntegrationsSalesforceName: 'Salesforce',
  marketingIntegrationsSubmitSuccess: "Thanks — we've recorded your interest.",
  marketingIntegrationsToolLabel: 'Which tool should we connect?',
  marketingIntegrationsToolPlaceholder: 'Tool name',
  marketingIntegrationsZapierDesc: 'Connect Notability to thousands of apps with Zapier.',
  marketingIntegrationsZapierName: 'Zapier',
  marketingInTheMediaEditorsPicks: 'Editor’s picks',
  marketingInTheMediaFilterCoverage: 'Coverage',
  marketingInTheMediaFilterPressRelease: 'Press release',
  marketingInTheMediaFilterReview: 'Review',
  marketingInTheMediaFiltersLabel: 'Filter stories by type',
  marketingInTheMediaHeroSub: 'Catch up on press coverage, reviews, and news about Notability.',
  marketingInTheMediaHeroTitle: 'In the media',
  marketingInTheMediaPageLabel: 'Page {{page, number}}',
  marketingInTheMediaPagination: 'Story pages',
  marketingInTheMediaStoryCount_one: '{{count, number}} story',
  marketingInTheMediaStoryCount_other: '{{count, number}} stories',
  marketingInTheMediaTitleWithPage: 'In the media – Page {{page, number}}',
  marketingLogo: 'Marketing Logo',
  marketingMacInstallInstallBody: 'Drag and drop the app icon into your Applications folder.',
  marketingMacInstallInstallTitle: 'Install',
  marketingMacInstallOpenBody: 'Double click on the Notability.dmg file.',
  marketingMacInstallOpenTitle: 'Open',
  marketingMacInstallStartBody: 'Open Notability from the Applications folder.',
  marketingMacInstallStartTitle: 'Start',
  marketingMacInstallTitle: 'Get started with Notability',
  marketingPromoBody: 'Get {{discountPct}}% off your first year of Notability Plus <1>here</1>',
  marketingPromoExpiration: 'Offer valid through {{date}}',
  marketingPromoHeader: 'Make Notability your study sidekick this year!',
  marketingPromoSplat: '{{discountPct}}% Off',
  marketingWebProductivityBody: 'Arm yourself with more superpowers with these amazing features!',
  marketingWebProductivityHeader: 'Boost your <Highlight>productivity</Highlight>',
  marketingWebReturned: 'Jump back in',
  marketingWindowsInstallInstalling: 'Installing Notability',
  marketingWindowsInstallOpenBody: 'Double click on the Notability-Setup.exe file.',
  marketingWindowsInstallOpenTitle: 'Open',
  marketingWindowsInstallStartBody: 'Notability installs and opens on its own. Find it later in your Start menu.',
  marketingWindowsInstallStartTitle: 'Install and start',
  marketingWindowsInstallTitle: 'Get started with Notability',
  mastered: 'Mastered',
  matchSystemAppearance: 'Match System Appearance',
  maxDescriptionCountValidationError: 'The note description cannot be more than {{maxDescriptionCount}} characters',
  maxEditorLimit: 'This note is at its editor limit right now.\nYou can still view, but not edit.',
  maxLinkSharingNotesReachedUploadError:
    'You have reached the {{maxNoteCount}} note limit for notes shared by link. To share a new note, first unshare notes in your library.',
  maxNotesReachedPublishError: 'You have published the maximum number of notes for your account',
  maxNotesReachedUploadError: 'You have uploaded the maximum number of notes for your account',
  maxTagCountNoteValidationError: 'You cannot assign more than {{maxTagCount}} tags',
  maxTitleLengthValidationError: 'The note name cannot be more than {{maxTitleCount}} characters',
  maxViewerLimit: 'This note is at its viewer limit right now.\nTry again in a moment.',
  mcpConsentAllow: 'Allow {{clientName}}',
  mcpConsentCancel: '<0>Cancel</0> and go back.',
  mcpConsentCapabilitiesLabel: 'It will be able to',
  mcpConsentCapabilityNoWrites: 'It can’t create, edit or delete anything',
  mcpConsentCapabilityReadNotes: 'Read your notes and their summaries',
  mcpConsentCapabilityReadTranscripts: 'Read your audio transcripts',
  mcpConsentCapabilitySearch: 'Search your notes',
  mcpConsentConnectedTitle: 'You’re connected',
  mcpConsentDeclinedTitle: 'Request declined',
  mcpConsentExpiredBody: 'Go back to the app you were connecting and choose Connect again.',
  mcpConsentExpiredTitle: 'This link has expired',
  mcpConsentFailedBody: 'Something went wrong. Go back to the app you were connecting and try again.',
  mcpConsentRedirectHost: 'Your choice will be sent to {{redirectHost}}.',
  mcpConsentReturnToClient: 'Return to {{clientName}} to continue.',
  mcpConsentSignedInAs: 'Signed in as {{email}}. <0>Switch accounts</0>',
  mcpConsentTitle: 'Connect {{clientName}} to Notability',
  mcpConsentUnverifiedWarning:
    'Notability hasn’t verified this app. Only allow it if you set it up yourself or trust who made it.',
  me: 'Me',
  mediaUploadSizeLimit: 'Uploaded media cannot be larger than 4 GB',
  mediumFooterAlt: 'Notability Medium link',
  meetingCaptureNotificationAppName: 'Notability',
  meetingCaptureNotificationDismiss: 'Dismiss',
  meetingCaptureNotificationJoinMeeting: 'Join meeting',
  meetingCaptureNotificationMenuCantRecord: 'I can’t record',
  meetingCaptureNotificationMenuHeader: 'Don’t notify me because',
  meetingCaptureNotificationMenuLabel: 'Stop notifications',
  meetingCaptureNotificationMenuNoNotesNeeded: 'I don’t need notes',
  meetingCaptureNotificationOpenNotability: '+ open Notability',
  meetingCaptureNotificationRecord: 'Record',
  meetingCaptureNotificationScheduledSubtitle: 'Record it in a new note.',
  meetingCaptureNotificationScheduledTitle: '{{eventTitle}} starting',
  meetingCaptureNotificationSummarySubtitle: 'Record to get summaries and action items in your notes.',
  meetingCaptureNotificationUnscheduledTitle: 'A call is starting',
  meetingMinutesDone: 'Meeting minutes, done in seconds',
  meetingNoteFallbackTitle: 'Meeting',
  meetingsHeroAlsoAvailable: 'Also available for macOS, iOS, Android, and web',
  meetingsHeroDownloadCta: 'Download for free',
  meetingsHeroImageAlt:
    'A Notability notification offering to record a meeting that is starting, above a list of upcoming meetings',
  meetingsHeroSubtitle: 'Every meeting recorded and transcribed to a note. No bot attached.',
  meetingsHeroTitle: 'The AI notebook for back-to-back meetings and lectures',
  meetingsPageTitle: 'Meetings',
  meetTheToolbarEmailBodyCopy:
    "Pick a tool and try it out. Once you've gotten the hang of the Toolbar, we'll show you what to try next.",
  meetTheToolbarEmailCtaButton1: 'Create my next note',
  meetTheToolbarEmailCtaButton2: 'Start Exploring',
  meetTheToolbarEmailCtaHeading: 'Ready to get started?',
  meetTheToolbarEmailFeature1Desc: 'Write or sketch anything that comes to mind.',
  meetTheToolbarEmailFeature1Title: 'Pen or Pencil',
  meetTheToolbarEmailFeature2Desc: 'Emphasize key ideas with translucent ink.',
  meetTheToolbarEmailFeature2Title: 'Highlighter',
  meetTheToolbarEmailFeature3Desc: 'Fix mistakes instantly.',
  meetTheToolbarEmailFeature3Title: 'Eraser',
  meetTheToolbarEmailFeature4Desc: 'Add movable text boxes anywhere on the page.',
  meetTheToolbarEmailFeature4Title: 'Text Tool',
  meetTheToolbarEmailFeature5Desc: 'Move elements around, or convert handwriting to typed text.',
  meetTheToolbarEmailFeature5Title: 'Selection',
  meetTheToolbarEmailHeroBody:
    'Say hello to your new best friend: the Toolbar. This is where you can take control of your note. Once you get to know the tools available in the Toolbar, making your next note feels effortless.',
  meetTheToolbarEmailHeroHeading: 'Meet the Toolbar',
  meetTheToolbarEmailHeroSubheading: 'Congratulations on creating your first note. Ready to level up?',
  meetTheToolbarEmailPs:
    "Pro-Tip: Once you've created multiple notes, you can organize them into different subjects in your Library.",
  meetTheToolbarEmailSignOff: 'Happy note-taking,',
  meetTheToolbarEmailSubject: 'Welcome to Notability! | Meet the Toolbar',
  meetTheToolbarEmailTeamName: '— The Notability Team 💙',
  member: 'Member',
  Members: 'Members',
  membersOfWorkspaceWillLoseAccessToNote:
    'Members of {{workspaceName}} will lose access to "{{noteTitle}}" unless it is shared with them again.',
  membersOfWorkspaceWillLoseAccessToSubject:
    'Members of {{workspaceName}} will lose access to "{{subjectTitle}}" and its contents.',
  memorize: 'Memorize',
  memorizeResultCardsMastered_one: '<numCards>{{count}}</numCards><cardsMastered>card mastered</cardsMastered>',
  memorizeResultCardsMastered_other: '<numCards>{{count}}</numCards><cardsMastered>cards mastered</cardsMastered>',
  memorizeResultMasteredAll: "You've mastered every flashcard in this note.",
  memorizeResultNextToPracticeV2: 'Practice and assess your knowledge with quiz questions next.',
  memorizeResultReviewOrContinue:
    'Review your flashcards, or continue to assess your knowledge with quiz questions next.',
  memorizeWithFlashcards: 'Memorize with flashcards',
  memorizeWithXFlashcardsV2: 'Memorize with <bold>{{total}} flashcards</bold>',
  mentionedInCommentNotification: '<0>@{{screenname1}}</0> mentioned you in a comment on note: <1>{{noteName}}</1>.',
  metaDescriptionAndroid:
    'Notability is on Android. Take notes, record audio, annotate PDFs, and study with AI on your Android phone or tablet. Download it free on Google Play.',
  metaDescriptionApps:
    'Download Notability for Mac, Windows, iPad, iPhone, and Android, or use it on the web. Your notes sync across every device with Notability Cloud.',
  metaDescriptionBusiness:
    'Notability for Business brings shared libraries, document markup, meeting transcripts, and real-time collaboration to your team. Start a free trial.',
  metaDescriptionChina:
    'Notability is the award-winning note-taking app for iPad, iPhone, and Mac. Handwrite, type, annotate PDFs, and record audio alongside your notes.',
  metaDescriptionCompare:
    'Compare Notability plans and features side by side, from Starter to Pro and Business, to find the right fit for you or your team.',
  metaDescriptionConstruction:
    'Notability for Business lets construction teams capture site notes, annotate plans, and sync field updates to the office in real time. Start a free trial.',
  metaDescriptionDefault:
    'Notability is the award-winning note-taking app on iPad, iPhone, Android, and desktop. Handwrite, type, annotate PDFs, record audio, and study with AI.',
  metaDescriptionEducation:
    'Notability for Education gives schools a free, MDM-configurable note-taking system with handwriting recognition and math conversion.',
  metaDescriptionFlashcardImport:
    'Import your flashcards from Anki, Quizlet, and more into Notability, then review them alongside your notes with spaced repetition.',
  metaDescriptionGift:
    'Give someone a full year of Notability Plus or Pro: handwritten and typed notes, audio recording, and AI study tools on all their devices.',
  metaDescriptionHome:
    'Notability turns handwritten notes, audio, and documents into AI-powered summaries, flashcards, and quizzes. Download for free today.',
  metaDescriptionLearnGuarantee:
    "Subscribe to Notability Plus or Pro and study with Learn. If it doesn't help you feel ready for midterms, the rest of the semester is on us.",
  metaDescriptionMeetings:
    'Record and transcribe every meeting and lecture into a note, with no bot joining the call. Notability works on Mac, iPad, iPhone, Android, and the web.',
  metaDescriptionPricing:
    'See Notability plans and pricing, from a free Starter tier to Plus, Pro, and Business, with AI-powered notes and study tools.',
  metaDescriptionSports:
    'Notability for Business gives coaching staff one workspace to sketch plays, annotate film, and share game plans with the whole team. Start a free trial.',
  metaDescriptionStudents:
    'Record class, get a clear summary, and turn your notes into quizzes and flashcards. Notability for Students is free to start, no credit card required.',
  metaDescriptionWeb:
    'Use Notability in your browser. Type notes that sync across your devices, then turn them into AI summaries, quizzes, and flashcards. Try it for free.',
  migrationRequiredForOrganization:
    'You must migrate your notes to Notability server before accepting this organization invitation.',
  minimumFileDimensionsError: 'Avatar images must be larger than 128px wide by 128px tall.',
  minute: '{{count}} minute',
  minutes: '{{count}} minutes',
  mismatchPasswordsError: 'Your passwords must match each other.',
  missingAtLeastOneParameter: 'Missing at least one parameter',
  missingContractAcceptedAt: 'ContractAcceptedAt field is missing',
  missingIndustry: 'Industry field is missing',
  missingLicense: 'License missing',
  mixAndMatchDefinitionTileLabel: 'Definition: {{content}}. {{state}}',
  mixAndMatchDevTestOnly: 'Mix and Match (Dev)',
  mixAndMatchNudgeDescription:
    'Our new quiz method allows you to match terms and definitions and actively connect concepts to their meanings.',
  mixAndMatchNudgeTitle: 'Try out Mix and Match!',
  mixAndMatchTermTileLabel: 'Term: {{content}}. {{state}}',
  mixAndMatchTileStateDefault: 'Not selected',
  mixAndMatchTileStateMatched: 'Matched',
  mixAndMatchTileStateMismatched: 'Incorrect match',
  mixAndMatchTileStateSelected: 'Selected',
  mixedMethodsTest: 'Mixed-methods test',
  mobile404Header: 'Nothing to note',
  mobile404Text: 'The content you were looking for is unavailable.',
  modalCancel: 'Cancel',
  Monthly: 'Monthly',
  more: 'More',
  'More like this': 'More like this',
  'More options': 'More options',
  moreGuidelinesInfo: 'For more information, please view our <1>Community Guidelines</1>.',
  moreQuestionsAsYouStudy: 'More questions as you study',
  moreTopics: 'More topics',
  mostPopular: 'Popular',
  mostRecentScore: 'Most recent score: <bold>{{score}}</bold>%',
  move: 'Move',
  moveBackwardAction: 'Move backward',
  moveForwardAction: 'Move forward',
  moveNoteTo: 'Move "{{noteTitle}}"',
  moveOrganizerTo: 'Move "{{subjectTitle}}"',
  moveThisFolder: 'Move this folder?',
  moveThisNote: 'Move this note?',
  moveThisSubject: 'Move this subject?',
  moveThisSubjectAndItsContents: 'Move this subject and its contents?',
  moveThisSubjectAndItsContentsOutOfWorkspace: 'Move this subject and its contents out of {{workspaceName}}?',
  moveTo: 'Move to',
  multipleChoice: 'Multiple choice',
  mustAcceptOrganizationInviteError:
    'You must accept your organization invitation before you can log in. Please check your email for the invitation link.',
  mustBeOwner: 'You must be the owner of the note to perform that action',
  mustLogIn: 'You must log in to perform that action',
  'My Profile': 'My Profile',
  myLibrary: 'My Library',
  name: 'Name',
  nameEmailWillHaveFullAccess:
    '<name>{{name}}</name> ({{email}}) will have full access to their notes and Shared Libraries again.',
  nameFormatRequirementError:
    'Names must contain only letters and may include spaces, apostrophes, or hyphens between words',
  nameNotAvailableError: 'Name is not available',
  nameYou: '{{name}} (you)',
  nbClassic: 'Notability Classic',
  nbLight: 'Notability Lite',
  nbPlusAudioHeader: 'Audio Transcription',
  nbPlusAudioText_v2: 'Search and copy time-stamped text of what was said in every recording.',
  nbPlusAudioText_v3: 'Capture audio and get them transcribed to text - all synced to your notes!',
  nbPlusHandwritingText: 'Search and convert your handwriting to text. Powered by MyScript.',
  nbPlusMathHeader: 'Math Conversion',
  nbPlusStickersHeader: 'Planners & Stickers',
  nbPlusStickersText: 'Stay organized and add flair to your notes.',
  'Need to make an account': 'Need to make an account?',
  needsNewReview: 'Needs Re-Review',
  new: 'New',
  newBadge: 'New',
  newContentBadge: 'New',
  newFolderInputAriaLabel: 'New folder input',
  newFolderPlaceholder: 'New folder',
  newNote: 'New note',
  newNoteFromPdf: 'New Note from PDF',
  newNoteFromTemplate: 'New note from template',
  newNoteFullPageTextPrompt: 'New note',
  newNoteWithRecording: 'New note with recording',
  newSharedLibrary: 'New shared library',
  newSharedLibraryDescriptionPlaceholder: 'Details about your shared library',
  newSharedLibraryNamePlaceholder: 'Name of shared library (e.g. Marketing)',
  newSubjectInputAriaLabel: 'New subject input',
  newSubjectOrDividerButtonLabel: 'New Subject or Divider',
  newSubjectPlaceholder: 'New subject',
  newWhiteboard: 'Whiteboard',
  newWhiteboardMenuItem: 'New whiteboard',
  next: 'Next',
  no: 'No',
  'No account found': 'No account found',
  noAccountQuestion: "Don't have an account?",
  noBusinessFound: 'No business found',
  noCollabNotePermission: 'User does not have access to note',
  noCollabNoteWritePermission: 'User does not have access to edit this note',
  noCommentsCTA: 'There are no comments yet on this note, add one to get the conversation started.',
  noCopyrightDescription: 'Please do not upload copyrighted material. Find more info on our DMCA Policy <1>here</1>.',
  noCopyrightTitle: 'No Copyrighted Material',
  noEmojisFound: 'No emojis found',
  noFollowingResults: "Content curated by you! Press <1>Follow</1> on a user's profile page and see their notes here.",
  noInternetConnection: 'Could not connect to the internet. Please try again.',
  nonexistentNote: 'That note does not exist',
  noNotificationsFound:
    'Notifications occur when your notes get favorited, your profile is followed, and for other interactions.',
  noNotificationsFound_v2:
    'Notifications occur when someone likes your note, your profile is followed, and for other interactions.',
  nonPaidQuotaReached: '{{tierName}} quota reached',
  nonPaidUserLimited: 'As a {{tierName}} user you have limited access to Smart Notes, Live Transcription and Quizzes.',
  noOrganizationFound: 'No organization found',
  noOrganizerPermission: 'User does not have access to this subject or divider',
  noOrganizerWritePermission: 'User does not have access to change this subject or divider',
  noPermissionError: 'You do not have permission to perform this action.',
  noRecoveryEmailError: 'No recovery email address is set.',
  noResultsInstruction: 'Check your spelling or try another search.',
  noResultsInstructionWithLink: 'Check your spelling or try <1>searching {{refinement}}</1>.',
  noResultsQuery: 'We couldn\'t find any results for "{{query}}."',
  noResultsQueryAndCategory: 'We couldn\'t find any results for "{{query}}" in {{categoryName}}.',
  noResultsQueryAndLanguage: 'We couldn\'t find any results for "{{query}}" in {{language}}.',
  noResultsSearchAllLanguagesInstruction: 'Check your spelling or try <1>searching in all languages</1>.',
  noResultsTitle: 'Sorry, no results found.',
  noResultsUserQuery: '"{{query}}" is not a registered username.',
  noSearchResults: 'No search results',
  noSpamDescription: "Content that intends to scam, mislead, spam, or defraud other users isn't allowed.",
  noSpamTitle: 'No Spam',
  noSpeechDetected: 'No speech detected',
  noSpeechErrorDescription: 'Check that your microphone is not obstructed and is working properly.',
  noStudyMaterialsBatchFound: 'No study materials found',
  notabilityCloudSupportInviteHeader: 'Page not available',
  notabilityCloudSupportInviteText: 'Please open the link on an iPad with the Notability app installed.',
  notabilityForBusiness: 'Notability for Business',
  notabilityForBusinessPro: 'Notability for Business Pro',
  notabilityIsFor: 'Notability is for',
  notabilityPlusFeatures:
    'Automatic audio transcription\nComprehensive note summaries\nAI generated quizzes and summaries',
  notabilityPlusFeaturesList:
    'Unlimited notes\nSyncing with Notability Cloud\nAudio recording\nAll editing tools & content\nNote summaries\nLimited quizzes & flashcards\nAudio transcription\nReal-time Smart Notes\nLive transcription\nChat with your notes',
  notabilityProFeatures:
    'Live transcripts and real-time Smart Notes\nAI-powered summaries, quizzes and flashcards from your notes\nChat with your note to learn your content quicker',
  notabilityProFeaturesList:
    'Unlimited notes\nSyncing with Notability Cloud\nAudio recording\nAll editing tools & content\nNote summaries\nUnlimited quizzes & flashcards\nAudio transcription\nReal-time Smart Notes\nLive transcription\nChat with your notes',
  notabilityWeb: 'Notability Web',
  notabilityWebApp: 'Notability web app',
  notAuthorizedError: 'This user is not authorized to perform this action',
  notAValidTemplateError: 'Templates can only contain 1 page and cannot contain audio recordings.',
  note: '{{count}} note',
  noteAccess: 'Note access',
  noteAccessBusinessCanEdit: 'Members of this organization can edit this note.',
  noteAccessBusinessCanView: 'Members of this organization can view this note.',
  noteAccessPrivate: 'Private',
  noteAccessPrivateExplainer: 'Only you can view and edit this note.',
  noteAccessPublic: 'Public',
  noteAccessPublicExplainer: 'Anyone with the link can view and edit this note.',
  noteAlreadyLikedError: 'You cannot like the same note twice',
  noteAlreadyPublishedError: 'This note is already published. Please unpublish it before trying to publish it again.',
  noteApprovedNotification: 'Your note <1>{{noteName}}</1> was approved after an admin review.',
  noteAwaitingTriageMessage:
    'This note contains content that must be reviewed before it is made visible in the Gallery.',
  noteCommentedOnByManyNotification:
    '<0>@{{screenname1}}</0>, <1>@{{screenname2}}</1>, and {{count}} others commented on your note <2>{{noteName}}</2>.',
  noteCommentedOnByOneMoreThanMaxMentionedNotification:
    '<0>@{{screenname1}}</0>, <1>@{{screenname2}}</1>, and 1 other commented on your note <2>{{noteName}}</2>.',
  noteCommentedOnByOneNotification: '<0>@{{screenname1}}</0> commented on your note <1>{{noteName}}</1>.',
  noteCommentedOnByTwoNotification:
    '<0>@{{screenname1}}</0> and <1>@{{screenname2}}</1> commented on your note <2>{{noteName}}</2>.',
  noteCount_one: '1 note',
  noteCount_other: '{{count}} notes',
  noteDeleted: 'Note deleted',
  noteDeletionConfirmationModalBodyTextv2: 'Your note can be recovered within 30 days via the Settings menu.',
  noteDoesNotExistError: 'Could not find the note you requested',
  noteFailedToLoad: 'Note failed to load',
  noteFailedToLoadDescription: 'Try reloading the note or contact support if the issue persists.',
  noteFailedToLoadGpuDisabled: 'Hardware acceleration disabled, please enable it in your browser settings.',
  noteFlaggedNotification: 'Your note <1>{{noteName}}</1> was flagged.',
  noteFullPageTextPrompt: 'Type Something...',
  noteLikedByManyNotification:
    '<0>@{{screenname1}}</0>, <1>@{{screenname2}}</1>, and {{count}} others favorited your note <2>{{noteName}}</2>.',
  noteLikedByManyNotification_v2:
    '<0>@{{screenname1}}</0>, <1>@{{screenname2}}</1>, and {{count}} others liked your note <2>{{noteName}}</2>.',
  noteLikedByOneMoreThanMaxMentionedNotification:
    '<0>@{{screenname1}}</0>, <1>@{{screenname2}}</1>, and 1 other favorited your note <2>{{noteName}}</2>.',
  noteLikedByOneMoreThanMaxMentionedNotification_v2:
    '<0>@{{screenname1}}</0>, <1>@{{screenname2}}</1>, and 1 other liked your note <2>{{noteName}}</2>.',
  noteLikedByOneNotification: '<0>@{{screenname1}}</0> liked your note <1>{{noteName}}</1>.',
  noteLikedByTwoNotification:
    '<0>@{{screenname1}}</0> and <1>@{{screenname2}}</1> favorited your note <2>{{noteName}}</2>.',
  noteLikedByTwoNotification_v2:
    '<0>@{{screenname1}}</0> and <1>@{{screenname2}}</1> liked your note <2>{{noteName}}</2>.',
  noteLimit: 'Note limit',
  noteLimitCount: '{{current}}/{{limit}} notes',
  noteLimitReachedModalBody:
    'Upgrade to get unlimited notes, handwriting search, audio transcription, quizzes, and more.',
  noteLimitReachedNoticeWarning: 'You can no longer create new notes. Upgrade to create unlimited notes and more.',
  noteLimitReachedRecoverBody:
    "You've reached your note limit. Upgrade to recover deleted notes and get unlimited storage.",
  noteLimitReachedRecoverTitle: 'Notes cannot be recovered',
  noteLimitReachedSubscriptionWarning: 'You can no longer create new notes. Upgrade to unlock unlimited notes.',
  noteLimitReachedTitle: 'Note limit reached',
  noteLinkSharingUnverifiedEmailError: 'You must verify your email address before creating a note link',
  noteListOptionsButtonLabel: 'Note list options',
  noteNotFoundError: 'Gallery note not found',
  notEnoughContentSelected: 'Not enough content selected',
  noteOptionEdit: 'Edit',
  noteOptionReport: 'Report',
  noteOptionUnpublish: 'Unpublish',
  notePage: '{{count}} page',
  notePages: '{{count}} pages',
  notePreviewAltText: 'Note preview',
  notePreviewGetTheApp: 'Get the app',
  notePreviewReopenAfterInstall: 'After you sign in to the app, open this link again.',
  noteProfileHiddenMessage:
    "This note is hidden from public view because its author's profile has been hidden by the moderation team.",
  noteQuarantinedMessage: 'This note is quarantined and completely hidden.',
  noteQuarantinedNotification: 'Your note <1>{{noteName}}</1> was quarantined.',
  noteRemixedByUserNotification: '<0>@{{screenname1}}</0> remixed your note <1>{{noteName}}</1>.',
  noteRenameAriaLabel: 'Rename a note',
  noteResult: '{{count}} note result',
  noteResults: '{{count}} note results',
  noteReviewPendingMessage: 'This note is flagged for review and hidden from public view.',
  notes: '{{count}} notes',
  'notes shared': '{{count}} notes shared',
  noteSharingHistory: 'Note Sharing History',
  noteSharingLinkCopied: 'Note link copied',
  notesHeader: 'Notes',
  noteTriagePendingMessage:
    'This note is being reviewed because it contains images. Once approved, it will be visible in the Gallery.',
  noteUnavailable: 'Note unavailable',
  noteUnavailableExplainer:
    'The note you are trying to access is unavailable at this time. Ready to start something new?',
  noteUploadFailureError: 'Note failed to upload. Try again.',
  noteURLLabel: 'Note URL',
  noThanks: 'No thanks',
  nothingToSeeHere: 'Nothing to see here',
  notificationMenuItem: 'Activity',
  notInBusinessInvitedStatus: 'No valid business invitation found for your account.',
  notSeeingBrowserTab: 'Not seeing the browser tab?',
  notStarted: 'Not started',
  noUpdateOrganizationDetailsProvidedError: 'Must provide detail to update for organization',
  noUserWithUsernameError: 'There is no user with that name',
  nowAvailableOnPro: 'Now available on PRO',
  nowRecordingInNote: 'Now recording in {{noteTitle}}',
  numberedList: 'Numbered list',
  numFolderMatches_one: '1 folder match',
  numFolderMatches_other: '{{count}} folder matches',
  numNoteMatches_one: '1 note match',
  numNoteMatches_other: '{{count}} note matches',
  numPeople_one: '1 person',
  numPeople_other: '{{count}} people',
  numQuestionsCompleted: '<results>{{completed}}/{{total}}</results> questions completed',
  numQuestionsMissed_one: '<incorrect>1</incorrect> question missed',
  numQuestionsMissed_other: '<incorrect>{{count}}</incorrect> questions missed',
  numSubjectMatches_one: '1 subject match',
  numSubjectMatches_other: '{{count}} subject matches',
  oauthAccountRevoked: 'Your connected account is no longer authorized. Please reconnect to continue.',
  oauthConnectFailed: "We couldn't complete the connection. Please try again.",
  oauthInsufficientScope: 'Additional permissions are required to complete this action.',
  OK: 'OK',
  onboarding: 'Onboarding',
  onboardingBody:
    'Transform your notes into interactive study sessions with automatic summaries and personalized quizzes.',
  onboardingBrainBreakBody:
    'Take a break from studying with 5 days of puzzles. Find them at the bottom of your Home feed.',
  onboardingBrainBreakTitle: 'Brain breaks are here',
  onboardingChatAcrossNotesBody: 'Chat across your library is here. Ask anything across every note you’ve ever taken.',
  onboardingChatAcrossNotesTitle: 'One chat for all your notes',
  onboardingCTACreateNote: 'Create note',
  onboardingCTAImportPDF: 'Import PDF',
  onboardingLiveCollaborationBody: "Share your notes, see who's present, and collaborate in real time.",
  onboardingLiveCollaborationTitle: 'Live collaboration',
  onboardingNotabilityForBusinessBody:
    'Create Shared Libraries that entire teams can access. Collaborate in real time and control who can view, edit, or manage content.',
  onboardingNotabilityForBusinessTitle: 'Notability for Business',
  onboardingStudentBetterGrades_addMaterials: 'Add course materials',
  onboardingStudentBetterGrades_addMaterialsBody:
    'Bring presentations, textbooks, journal articles, PDFs, and more into your workspace.',
  onboardingStudentBetterGrades_studyLearn: 'Study with Notability Learn',
  onboardingStudentBetterGrades_studyLearnBody:
    'Turn your notes into a study guide. Get clear answers or build quizzes and flashcards to review.',
  onboardingStudentBetterGrades_takeNotes: 'Take notes in class',
  onboardingStudentBetterGrades_takeNotesBody:
    'Type your notes or let Notability capture them for you in real time during class or a lecture.',
  onboardingStudentBetterGradesTitle: 'Improve <underline>your</underline> grades',
  onboardingTitle: 'Unlock your learning potential',
  onboardingTourCountdownBeginsIn: 'Recording begins in',
  onboardingTourCountdownBody:
    'Check that your microphone is not obstructed and the audio you intend to capture is ready to play and within hearing distance.',
  onboardingTourCountdownStartRecording: 'Start recording',
  onboardingTourCountdownTitle: 'Get ready to record',
  onboardingTourCueCardCaptureDetailBody:
    'We capture and transcribe every word with clarity so you never miss a thing.',
  onboardingTourCueCardCaptureDetailTitle: 'Capture every detail',
  onboardingTourCueCardGotIt: 'Got it',
  onboardingTourCueCardKeepAddingTextBody:
    'Capture sufficient information to generate Smart Notes, quizzes, and flashcards. Aim to capture a minimum of 500 words in your note.',
  onboardingTourCueCardKeepAddingTextTitle: 'Keep going to experience Smart Notes',
  onboardingTourCueCardKeepRecordingBody: 'Capture more audio to generate Smart Notes, quizzes, and flashcards.',
  onboardingTourCueCardKeepRecordingTitle: 'Keep recording to experience Smart Notes',
  onboardingTourCueCardKnowledgeTestBody:
    'Your content has been turned into an interactive quiz. Try it out to see what you retained and what you need to review.',
  onboardingTourCueCardKnowledgeTestTitle: 'Put your knowledge to the test',
  onboardingTourCueCardLearnHomeWatchNotesBody:
    'As enough information is captured, content is distilled into succinct, structured notes and quizzes automatically.',
  onboardingTourCueCardLearnHomeWatchNotesTitle: 'Watch your notes transform',
  onboardingTourCueCardSmartNotesBegunBody:
    'As information is captured, your content automatically turns into detailed, digestible notes.',
  onboardingTourCueCardSmartNotesBegunTitle: 'Watch your notes become knowledge',
  onboardingTourCueCardWatchRecordingsInsufficientBody:
    'To create Smart Notes, you will need to capture enough information. Make sure that your lecture, video or dictation is loud enough for the microphone to capture.',
  onboardingTourCueCardWatchRecordingsInsufficientTitle: 'Watch your recordings transform',
  onboardingUpgradedFoldersBody:
    'Organize folders within folders, providing deeper note organization with less complexity.',
  onboardingUpgradedFoldersTitle: 'Upgraded Folders system',
  oneOrMoreEmailsInvalid: 'One or more of the email addresses entered is invalid.',
  oneTeamSamePage: 'One team, same page',
  onlyInvitedUsersCanAccessThisNote: 'Only invited users can access this note.',
  Open: 'Open',
  'Open in App': 'Open in App',
  openBilling: 'Open Billing',
  openInDesktopApp: 'Open in desktop app',
  openInNewTab: 'Open in new tab',
  openInNewWindow: 'Open in new window',
  openLibraryTooltip: 'Open library',
  openLink: 'Open link',
  openNamedNote: 'Open “{{title}}”',
  openNote: 'Open note',
  openQuizMenu: 'Open quiz menu',
  optional: 'optional',
  options: 'Options',
  orderedList: 'Ordered List',
  orgAdminAccountCreatedMessage:
    'Your Notability account has been granted admin permissions for an organization. You can access your organization information in your Admin Portal.',
  orgAdminAccountCreatedSubject: 'Log in to your Notability admin account',
  organization: 'Organization',
  organizationDetailsUpdateError: 'We could not update your organization. Please try again or contact Support.',
  organizationName: 'Organization name',
  organizationNameIsRequired: 'Organization name is required.',
  organizationSettings: 'Organization Settings',
  organizationUsersPartialListError:
    'We could not load your full list of members. Please try again or contact Support.',
  organizeMyClasses: 'Organize my classes',
  organizeMyClassesDescription: 'Set up subjects so your notes stay sorted.',
  organizeNotesIntoSubjects: 'Organize notes into subjects',
  organizeNotesIntoSubjectsDescription: 'Group notes into folders.',
  organizerAll: 'All',
  organizerFavorites: 'Favorites',
  organizerMyNotes: 'My Notes',
  organizerRecents: 'Recents',
  organizerUpdateInputAriaLabel: 'Update organizer title input',
  orgApprovedEmailMessage:
    "Your organization has been approved. You can access your organization's license key now by logging into your account through the link below.",
  orgApprovedEmailSubject: 'Welcome to Notability for Education',
  orgIndustryMinLengthError: 'Organizations must have a longer industry name',
  orgNameMinLengthError: 'Organizations must have a longer name',
  orgOwnerAccountCreatedMessage:
    'Your Notability account has been granted owner permissions for an organization. You can access your organization information in your Admin Portal.',
  orgOwnerAccountCreatedSubject: 'Log in to your Notability owner account',
  orgSubscriptionExplainer: 'Contact your system administrator to manage your account.',
  original: 'Original',
  other: 'Other',
  otherReportReasonPlaceholder: 'Explain other reporting reason',
  outline: 'Outline',
  outlinesAriaLabel: 'Document Outline',
  outsidePageBoundsBannerText: 'Switch to pageless mode to work outside page boundaries.',
  overDeviceLimitActionButton: 'Subscriptions over the device limit',
  overDeviceLimitDeviceCount: 'Device count:',
  overDeviceLimitDeviceLimitEnforced: 'Device limit enforced:',
  overDeviceLimitEnforcedFalse: 'False',
  overDeviceLimitEnforcedTrue: 'True',
  overDeviceLimitModalTitle: 'Subscriptions over the device limit',
  overDeviceLimitMoreInfoCTA: 'More info',
  overDeviceLimitOriginalTransactionId: 'Original transaction id:',
  overrideNotFoundError: 'Subscription override not found',
  owner: 'Owner',
  'Page not found': 'Page not found',
  pageCountError: 'The page count must be at least one.',
  pagedLayout: 'Paged layout',
  pagelessLayout: 'Pageless layout',
  pageManager: 'Page Manager',
  pageNavigatorCurrentPageButton: 'Current page {{currentPage}}, click to edit',
  pageNavigatorNextPage: 'Next page',
  pageNavigatorPreviousPage: 'Previous page',
  pageTitle404: 'Not Found',
  pageTitleError: 'Error',
  pageTitleHome: 'Notability Gallery',
  pageTitleLogin: 'Log In',
  pageTitleOwnProfile: 'My Profile',
  pageTitleSub: '{{pageTitle}} - Notability Gallery',
  parenthetical: '({{text}})',
  partialEraser: 'Partial',
  passkeyAuthenticationChallengeExpired: 'Your passkey sign-in took too long. Please try again.',
  passkeyAuthenticationVerificationFailed: "We couldn't verify your passkey sign-in. Please try again.",
  passkeyRegistrationChallengeExpired: 'Adding your passkey took too long. Please try again.',
  passkeyRegistrationVerificationFailed: "We couldn't finish adding your passkey. Please add it again.",
  passkeyUnknownCredential: "We don't recognize this passkey. Please try another way to sign in.",
  Password: 'Password',
  'Password must be at least 8 characters long': 'Password must be at least 8 characters long',
  'Password must be between 8 and 64 characters': 'Password must be between 8 and 64 characters',
  'Password must be less than 64 characters long': 'Password must be less than 64 characters long',
  'Password must contain a letter': 'Password must contain a letter',
  'Password must contain a number': 'Password must contain a number',
  'Password must contain one of these symbols:': 'Password must contain one of these symbols: %s or a space',
  passwordChangeConfirmationEmailMessage:
    'Your Notability password was changed successfully.<br /><br />If you did not request this password change, please contact us at <a href="mailto:support@gingerlabs.com">support@gingerlabs.com</a>.',
  passwordChangeConfirmationEmailSubject: 'Password change confirmation',
  passwordConfirmationError: 'Password must be confirmed',
  passwordLengthError: 'Password must be between 8 and 64 characters',
  passwordLengthRequirement: 'Password must be between {{min}} and {{max}} characters',
  passwordMustContainLetterError: 'Password must contain a letter',
  passwordMustContainNumberError: 'Password must contain a number',
  passwordMustContainSymbolsError: 'Password must contain one of these symbols: {{{symbols}}} or a space',
  passwordRequirementsDescription:
    'Your password must be at least 8 characters, and contain at least one number and one special character.',
  passwordResetComplete:
    'Your link will expire in 24 hours. If you do not see a message, please check your spam folder.',
  passwordResetDescription:
    "If you have a Notability account, we'll send you a link to the email to reset your password.",
  passwordResetEmailActionButton: 'Reset My Password',
  passwordResetEmailMessage:
    'Click the button below to reset your Notability password. If you did not request to change your password, please <a href="mailto:support@gingerlabs.com">contact us</a>.',
  passwordResetEmailSubject: 'Reset your password',
  'Passwords do not match': 'Passwords do not match',
  passwordsDoNotMatchError: 'Passwords do not match',
  paste: 'Paste',
  pasteInNewNoteAddMoreWords_one: 'Add at least 1 more word',
  pasteInNewNoteAddMoreWords_other: 'Add at least {{count}} more words',
  pasteInNewNotePlaceholder:
    'Paste information from Docs, ChatGPT, Gemini, Wikipedia or your favorite source. We’ll create a note for you based on that content.',
  pasteInNewNoteTitle: 'Paste content to get started',
  pasteLink: 'Paste link',
  pausePlaybackTooltip: 'Pause playback',
  pdfExport: 'Export as PDF',
  pdfExportFailed: 'PDF export failed',
  pdfExportInProgress: 'Exporting PDF…',
  pdfExportSuccess: 'PDF exported',
  pdfOutlineChunkedRange: 'Pages {{start}}–{{end}}',
  Pen: 'Pen',
  pencil: 'Pencil',
  pencilBannerBody: 'Browse all new pencil notes.',
  pencilBannerHeader: 'Every idea starts with a sketch!',
  pencilBannerLink: 'Browse all #pencil notes',
  pencilBannerTitle: 'Amazing pencil creations! Bam!',
  pencilPromoNotification:
    'See how other notetakers are using Pencil to bring ideas to life.  Browse new Pencil notes on the Gallery.',
  pending: 'Pending',
  pendingRequests: 'Pending requests',
  pendingUsers: 'Pending users',
  pensiveThinking: 'Thinking...',
  peopleInSharedLibrary: 'People in {{sharedLibraryName}}',
  peopleWithAccess: 'People with access',
  percentageScore: '<score>{{score}}</score><percent>%</percent>',
  permanentlyDeleteCountNotes_one: 'Permanently delete 1 note?',
  permanentlyDeleteCountNotes_other: 'Permanently delete {{count}} notes?',
  permissionRequestAlreadyExists: 'A permission request for this note is already pending',
  permissionRequestAlreadyProcessed: 'This permission request has already been processed',
  permissionRequestNotFoundError: 'Permission request not found',
  permissionRequiredClipboard: 'Permission required to access your clipboard',
  permissionRequiredNoteAccessDescription: 'You do not have permission to access this note.',
  permissionRequiredNoteAccessTitle: 'Permission required',
  permissionRequiredToAccessYourMicrophone: 'Permission required to access your microphone',
  pickADay: 'Pick a day.',
  plan: 'Plan',
  planDetails: 'Plan details',
  planIsRequired: 'Plan is required.',
  planNameLite: 'Lite',
  planNameLiteFull: 'Notability Lite',
  planNamePlus: 'Plus',
  planNamePlusFull: 'Notability Plus',
  planNamePro: 'Pro',
  planNameProFull: 'Notability Pro',
  playAudioTooltip: 'Play audio',
  playbackPositionLabel: 'Playback position',
  playbackPositionValue: '{{current}} of {{total}}',
  playStorePurchaseTokenAlreadyClaimed: 'This purchase is already associated with another account.',
  pleaseCheckBrowserSettings: 'Please check your browser settings and try again.',
  pleaseCheckContentTryAgain: 'Please check the content and try again.',
  pleaseCheckEmailsTryAgain: 'Please check the email addresses and try again.',
  pleaseCheckYourBrowserSettingsAndTryAgain: 'Please check your browser settings and try again.',
  plusFreeTrial: 'Notability Plus free trial',
  plusHeading: 'PLUS',
  plusTrialDurationPluralSimple: '{{count}} days remaining',
  popularBadge: 'Popular',
  popularSearchesTitle: 'Trending Searches',
  popularTags: 'Popular tags',
  popularTagsTitle: 'Popular Tags',
  postAComment: 'Let your voice be heard. Post a comment to get the conversation started.',
  postAction: 'Post',
  Posted: 'Posted {{date}}',
  practice: 'Practice',
  practiceResultKeepGoing: 'Keep going to master this note.',
  practiceResultKeepPracticing: 'Keep practicing — questions you missed will come back until you master them.',
  practiceResultMasteredAll: "You've correctly answered every question in this note.",
  practiceWithQuestions: 'Practice with questions',
  practiceWithXQuestionsV2: 'Practice with <bold>{{total}} questions</bold>',
  preferences: 'Preferences',
  preferencesKeepAwakeWhileRecording: 'Keep your device awake while recording',
  preferencesKeepAwakeWhileRecordingDescription:
    "Prevents your device from sleeping during a recording so it isn't cut off",
  preferencesMenuBarItem: 'Show Notability in the menu bar',
  preferencesMenuBarItemDescription: 'Adds a menu bar icon with quick actions',
  preferencesOpenAtLoginMac: 'Open Notability at login',
  preferencesOpenAtLoginMacDescription: 'Notability opens automatically when you log in to your Mac',
  preferencesOpenAtLoginWindows: 'Open Notability at startup',
  preferencesOpenAtLoginWindowsDescription: 'Notability opens automatically when you sign in to Windows',
  preferencesSystemTrayItem: 'Show Notability in the system tray',
  preferencesSystemTrayItemDescription: 'Adds a system tray icon with quick actions',
  preferredName: 'Preferred name',
  preferredNameModalTitle: 'Access "{{noteTitle}}"',
  preferredNameNoteAccess: 'Please set a preferred name so collaborators can identify you.',
  pressRecordGetTranscripts: 'Press record, get transcripts, and summaries in real time',
  previous: 'Previous',
  pricingBillingToggleMonthly: 'Monthly',
  pricingBillingToggleOneTime: 'One-time',
  pricingBillingToggleScrollNext: 'Show more billing options',
  pricingBillingToggleScrollPrevious: 'Show previous billing options',
  pricingBillingToggleYearly: 'Yearly',
  pricingBusinessSectionSubtext:
    'For teams looking to simplify workflows: notes, document markup, forms, shared libraries and live collaboration in one tool.',
  pricingCancelAnytime: 'Cancel anytime. Your notes remain secure and accessible.',
  pricingEduHeader: 'Are you part of an education institution?',
  pricingEduText:
    'For the first time ever, we’re able to offer Notability for free to educational institutions through Apple School Manager. If you are an institution representative, contact us!',
  pricingFeature20kTemplates: 'Access to 20,000+ note-taking templates',
  pricingFeature30DayVersionHistory: '30-day version history',
  pricingFeature5FreeNotes: '5 free notes',
  pricingFeature7DayVersionHistory: '7-day version history',
  pricingFeature90DayVersionHistory: '90-day version history',
  pricingFeatureAcademicPlanner: 'Academic Planner',
  pricingFeatureAddPdfsDocs: 'Add PDFs and docs directly into your notes',
  pricingFeatureAdminControls: 'Admin-based feature controls',
  pricingFeatureAiChat: 'AI Chat',
  pricingFeatureAiQuizzesFlashcardsLimited: 'AI-powered quizzes & flashcards (limited)',
  pricingFeatureAiSummariesLimited: 'AI-powered summaries (limited)',
  pricingFeatureAiSummariesTranscripts: 'AI-powered summaries and transcripts',
  pricingFeatureAiTranscripts: 'AI-powered transcripts',
  pricingFeatureAllEditingTools: 'All editing tools & content',
  pricingFeatureAudioTranscriptionLimited: 'Audio transcription (limited)',
  pricingFeatureAuditLog: 'Audit Log',
  pricingFeatureBuiltForTeams: 'Built for teams that need control and flexibility.',
  pricingFeatureBulkDiscounts: 'Bulk discounts',
  pricingFeatureCentralizedAdmin: 'Centralized user admin and billing',
  pricingFeatureChatWithNotes: 'Chat with your notes for explanations & quicker learning',
  pricingFeatureChatWithNotesExplanations: 'Chat with your notes for explanations',
  pricingFeatureCheerfulSticker: 'Cheerful Friends',
  pricingFeatureControlFlexibility: 'Control & flexibility',
  pricingFeatureCustomPaymentTerms: 'Custom payment terms',
  pricingFeatureDedicatedSupport: 'Dedicated support',
  pricingFeatureDedicatedSupportItalic: '<Italic>Dedicated support</Italic>',
  pricingFeatureEverythingInBusiness: '<Italic>Everything in Business and...</Italic>',
  pricingFeatureEverythingInLite: '<Italic>Everything in Lite and...</Italic>',
  pricingFeatureEverythingInLiteAndClassic: '<Italic>Everything in Lite and Classic</Italic>',
  pricingFeatureEverythingInLiteClassic: '<Italic>Everything in Lite and Classic and...</Italic>',
  pricingFeatureEverythingInPlus: '<Italic>Everything in Plus and...</Italic>',
  pricingFeatureEverythingInStarter: '<Italic>Everything in Starter and...</Italic>',
  pricingFeatureFunctionalSticker: 'Functional Stickies',
  pricingFeatureGardenSticker: 'Garden Blooms Monthly',
  pricingFeatureHandwritingRecognition: 'Handwriting recognition',
  pricingFeatureHandwritingSearch: 'Handwriting search and conversion',
  pricingFeatureHandwrittenMathToLatex: 'Handwritten math conversion to LaTeX',
  pricingFeatureICloudSync: 'iCloud sync',
  pricingFeatureIntuneMam: 'Intune MAM (Mobile Application Management) integration',
  pricingFeatureLifePlanner: 'Digital Life Planner',
  pricingFeatureLiveCollaboration: 'Live collaboration',
  pricingFeaturePlanetSticker: 'Blue Planet',
  pricingFeaturePlanFitsNeeds: '<Italic>A plan that fits your needs...</Italic>',
  pricingFeaturePlanFitsTeam: '<Italic>A plan that fits your team...</Italic>',
  pricingFeaturePortraitPlanner: 'Portrait Planner',
  pricingFeatureRealtimeCollab: 'Real-time collaboration',
  pricingFeatureRecordTranscribe: 'Record & transcribe audio',
  pricingFeatureRuler: 'Ruler',
  pricingFeatureSearchConvertHandwriting: 'Search & convert handwriting to text',
  pricingFeatureSearchHandwriting: 'Search your handwritten notes instantly',
  pricingFeatureSearchHandwritingInstantly: 'Search your handwriting instantly',
  pricingFeatureSharedNoteLibraries: 'Shared note libraries for real-time team collaboration',
  pricingFeatureSmartNotes: '<Bold>Smart Notes:</Bold> Transcription & AI-powered summaries in real time',
  pricingFeatureSyncAcrossDevices: 'Sync across devices and apps (Notability Cloud only)',
  pricingFeatureThirdPartyBackups: 'Third party backups',
  pricingFeatureThirdPartyBackupsIosOnly: 'Third party backups (iOS only)',
  pricingFeatureTypeFeature: 'Feature',
  pricingFeatureTypePlanner: 'Planner',
  pricingFeatureTypeStickers: 'Stickers',
  pricingFeatureUnlimitedEditsWebOnly: '<Bold>Unlimited</Bold> note-editing <Italic>(web only)</Italic>',
  pricingFeatureUnlimitedLiveTranscription: 'Unlimited live audio transcriptions',
  pricingFeatureUnlimitedNotabilityAi: '<Bold>Unlimited Notability AI:</Bold>',
  pricingFeatureUnlimitedNotes: 'Unlimited notes',
  pricingFeatureUnlimitedNoteTaking: '<Bold>Unlimited</Bold> note-taking and PDF annotation',
  pricingFeatureUnlimitedQuizzes: '<Bold>Unlimited</Bold> quizzes & flashcards',
  pricingFeatureUnlimitedQuizzesFlashcards: 'Unlimited quizzes & flashcards',
  pricingFeatureUnlimitedTranscription: '<Bold>Unlimited</Bold> live audio transcriptions',
  pricingFeatureUnlimitedTranscriptionSummaries: 'Unlimited transcription & AI-powered summaries in real time',
  pricingFeatureUnlimitedYoutube:
    '<Bold>Unlimited</Bold> YouTube link-to-note conversions with transcripts & summaries',
  pricingFeatureUnlimitedYoutubeMonthly:
    'Unlimited YouTube link-to-note conversions a month with transcripts & summaries',
  pricingFeatureYoutubeLinkToNote: 'YouTube link-to-note conversions with transcripts & summaries',
  pricingFeatureYoutubeLinkToNoteLimited: 'YouTube link-to-note conversions with transcripts & summaries (limited)',
  pricingFreeBody:
    'Import and annotate documents, record lectures while taking notes, and create custom templates. All for free, with limited edits.',
  pricingFreeBodyLegacy:
    'Import documents for annotating, record lectures while taking notes, create custom templates... and much more! Enjoy the advantages of digital note-taking for free with limited edits.',
  pricingFreeButton: 'Download Free',
  pricingFreeExcludedItems: 'iCloud sync across devices\nHandwriting recognition\nAuto-backup\nMath conversion',
  pricingFreeHeaderIncluded: 'Notability for free',
  pricingFreeHeaderLegacy: 'Notability is free to use!',
  pricingFreeHeaderNew: 'Start Notability<br></br>for free',
  pricingFreeItemList:
    'Create multi-media notes with limited edits\nPDF import and annotation\nAudio-recording synced to your notes\nGallery and templates\nCustom Stickers\nPresentation Mode\nDocument Scanning\nVarious sharing and export options\nMulti-Note side by side viewing',
  pricingFreeSubHeader: 'Free',
  pricingGetStarted: 'Get started with Notability for free',
  pricingGetStartedBody:
    'Import documents for annotating, record lectures while taking notes, create custom templates...and much more! Enjoy all of the advantages of digital note-taking for free with limits on editing.',
  pricingGridHeaderLegacy: "What's included in...",
  pricingGridHeaderNew: 'Plans tailored to <PricingScribble>you</PricingScribble>',
  pricingHeroSubtext:
    'Import and annotate documents, record lectures while taking notes, and create custom templates. Select a plan:',
  pricingHeroTitle: 'Plans tailored to you',
  pricingIndividualFootnote: '*Start a free 14-day trial to experience web services like iCloud.',
  pricingIndividualSectionSubtext: 'For personal note-taking, learning, and everyday productivity.',
  pricingIndividualTab: 'Individual',
  pricingLearnMoreButton: 'Learn more',
  pricingMostPopular: 'MOST POPULAR',
  pricingPayAsYouGoBilling: '<Bold>*Pay-as-you-go Billing:</Bold> new users are billed automatically.',
  pricingPlusFeatureListV2:
    'Unlimited edits and notes\nHandwriting conversion and search\niCloud Sync \nAuto-back up\nMath Conversion\nAutomatic audio transcription\nLearn',
  pricingPlusFeatureListV3Legacy:
    'Unlimited edits and notes\nHandwriting conversion and search\niCloud Sync \nAuto-back up\nMath Conversion\nAutomatic audio transcription\nLearn: note summaries, quizzes, and flashcards',
  pricingPlusItemList:
    'Unlimited edits and notes\nHandwriting conversion and search\niCloud Sync \nAuto-back up\nMath Conversion\nRuler and compass\nYearly planners and journals\nStickers, themes and more',
  pricingPlusPrice: '$20',
  pricingPlusPriceMonthly: '$7.99',
  pricingPlusSubheaderLegacy: 'Everything in Notability Starter plus:',
  pricingPremiumFeatureList:
    'Unlimited edits\niCloud Sync across devices\nAuto-back up for peace of mind\nHandwriting to text conversion\nHandwriting search and indexing\nMath equation conversion to LaTeX\nPremium features, content, and more',
  pricingPremiumFeaturesV3:
    'Unlimited edits\niCloud Sync across devices\nAuto-back up for peace of mind\nHandwriting to text conversion\nHandwriting search and indexing\nMath equation conversion to LaTeX\nAutomatic audio transcription\nLearn',
  pricingPremiumFeaturesV4:
    'Unlimited edits\niCloud Sync across devices\nAuto-back up for peace of mind\nHandwriting to text conversion\nHandwriting search and indexing\nMath equation conversion to LaTeX\nAutomatic audio transcription\nLearn: Ace your exams with note summaries, quizzes and flashcards',
  pricingPremiumHeader: 'Unleash the power with Notability Plus ',
  'pricingPremiumHeader-v2': 'Unleash the power of Notability Plus ',
  pricingPremiumSubheader: 'Experience the limitless note taking experience with more technology and bonus content:',
  pricingProLearnHeader: 'LEARN',
  pricingProOtherFeatures:
    'Unlimited edits\nHandwriting recognition\nMath conversion\nAudio recording\nPDF annotations\nNotes automatically sync across devices and platforms',
  pricingProOtherFeaturesHeader: 'Other Features',
  pricingProPrice: '$99',
  pricingProPriceMonthly: '$19.99',
  pricingStarterFeatureListLegacy:
    'Create multi-media notes with limited edits\nPDF import and annotation\nAudio recording synced to your notes\nGallery and templates\nPresentation Mode\nDocument Scanning\nVarious sharing and export options\nMulti-note side by side viewing\nStickers, themes and more!',
  pricingStarterFree: '<Link>Starter</Link> is available for free.',
  pricingStarterHeaderIncludedLegacy: 'Notability Starter',
  pricingSubscriptionHeaderIncluded: 'Notability <1>Plus</1>',
  pricingSubscriptionUpdatedItems: 'Yearly planners\n500+ stickers\nThemes\nJournals',
  pricingSubscriptionUpdates: 'Regularly updated content:',
  pricingTierBusinessDescription: 'For businesses that share notes and documents.',
  pricingTierBusinessProDescription: 'For businesses that want to enhance their work with AI.',
  pricingTierClassicDescription: 'For people who prefer a one-time purchase of unlimited note-taking.',
  pricingTierCustomButtonText: 'Talk to sales',
  pricingTierCustomDescription: 'For teams that have unique needs and the flexibility to work their way.',
  pricingTierFree: 'free',
  pricingTierLiteDescription: 'For note-takers who want unlimited notes and reliable backups.',
  pricingTierMostPowerful: 'MOST POWERFUL',
  pricingTierOneTime: 'one-time',
  pricingTierPerMonth: '/mo',
  pricingTierPerMonthPerUser: '/mo, per user*',
  pricingTierPerYear: '/yr',
  pricingTierPerYearPerUser: '/yr, per user*',
  pricingTierPlusDescription: 'For people who want faster note-taking with AI help.',
  pricingTierProDescription: 'For people who want the most advanced AI study & productivity tools.',
  pricingTierStarterDescription: 'For everyday note-takers who want reliability.',
  pricingUnleashSubheader: 'Experience limitless note-taking with additional capabilities.',
  pricingUsdDisclaimer: '*Prices listed are in USD and may vary',
  pricingUsdDisclaimerNoLeadingStar: 'Prices listed are in USD and may vary.',
  pricingVariesByLocation: 'Price varies by region',
  primaryEmailChangedNotificationEmailMessage:
    'Your Notability login email has been updated to {{newPrimary}}.\n\nIf you did not make this change, please contact us at support@gingerlabs.com',
  primaryEmailChangedNotificationEmailSubject: 'Your Notability login email has changed',
  print: 'Print',
  printFailed: 'Print failed',
  printInProgress: 'Preparing to print…',
  prioritizingWhatMattersMost: 'Prioritizing what matters most...',
  privacyPolicy: 'Privacy Policy',
  proBadge: 'PRO',
  processing: 'Processing...',
  processingTranscripts: 'Processing transcripts...',
  proCostCapNotice: 'You’ve exceeded your usage allowance for this month. Please reach out to <0>support</0>.',
  proCostCapNoticeContactAdmin: 'You’ve exceeded your usage allowance for this month. Please reach out to your admin.',
  proCostCapNoticeShort: 'You’ve exceeded your usage allowance for this month.',
  proCostCapTitle: 'AI usage allowance exceeded',
  productTitle: 'Notability',
  professionals: 'professionals.',
  profileApprovedNotification: 'Your profile was approved after an admin review.',
  profileFlaggedNotification: 'Your profile was flagged for review and hidden.',
  profileFollowedByManyNotification:
    '<0>@{{screenname1}}</0>, <1>@{{screenname2}}</1>, and {{count}} others followed you.',
  profileFollowedByOneMoreThanMaxMentionedNotification:
    '<0>@{{screenname1}}</0>, <1>@{{screenname2}}</1>, and 1 other followed you.',
  profileFollowedByOneNotification: '<0>@{{screenname1}}</0> followed you.',
  profileFollowedByTwoNotification: '<0>@{{screenname1}}</0> and <1>@{{screenname2}}</1> followed you.',
  profileHiddenNotification: 'Your profile has been hidden after an admin review.',
  profileMentionedNotification: 'You were mentioned in <1>{{noteName}}</1>.',
  profileNotFoundError: 'User profile not found.',
  profileReviewBlockedMessage: 'This user has been banned from Notability Web Services.',
  profileReviewFollowup: 'Please contact <1>support</1> for assistance.',
  profileReviewHiddenMessage: 'This profile has been hidden from public view after a review by our moderation team.',
  profileReviewPendingMessage: 'This profile has been flagged for review and is hidden from public view.',
  profileSocialAccounts: 'Social Accounts',
  profileTriageAdminNotesHint: 'These will be shown to the end user.',
  profileTriageApprove: 'Approve Profile',
  profileTriageBan: 'Ban User',
  profileTriageConfirm: 'Hide Profile',
  profileTriageConfirmApprove: 'Are you sure you want to approve this profile?',
  profileTriageConfirmBan: 'Are you sure you want to ban this user from Notability?',
  profileTriageConfirmHide: 'Are you sure you want to hide this profile and all associated notes from public view?',
  profileTriageDefaultApproveNotes: 'No issues found.',
  profileTriageEmpty: 'No profiles to review.',
  profileTriageNotesPlaceholder: 'Add some notes explaining your decision.',
  profileTriageReviewerNotes: 'Reviewer Notes',
  profileTriageReviewOutcome: 'Reviewer Assessment',
  profileTriageTitle: 'Profile Triage',
  promoCodeApplied: 'promo code <bold>{{code}}</bold> applied',
  promoNotificationsAdmin: 'Promotional Notifications',
  promoNotificationStudyTape:
    'Introducing Tape -— turn your notes into an interactive quiz! Cover up key information with Tape then tap to reveal the answers to study. See how others are using Tape now.',
  proUpsellCardDescription:
    'Get unlimited notes, handwriting conversion, handwriting search, live transcription, AI generated summaries, quizzes, and more.',
  publicSharedLibrary: 'Public shared library',
  publicSharedLibraryDescription: 'All members of {{organizationName}} will have access to this shared library.',
  Published: 'Published',
  purchases: 'Purchases',
  purgeCacheForNote: 'Purge Note Cache (Cloudflare)',
  quarantinePageTitle: 'Quarantined Notes',
  questionsAnswered: '<bold>{{count}}</bold> of <bold>{{total}}</bold> questions answered',
  questionsCorrect: '<bold>{{count}}</bold> of <bold>{{total}}</bold> questions correct',
  quickActions: 'Quick actions',
  quickAdd: 'Quick add',
  quickGoal: 'Quick goal',
  quickGoalDescription10Hours: 'Recommended study hours for grades 9–10',
  quickGoalDescription20Hours: 'Recommended for college prep and advanced high school courses',
  quickGoalDescription25Hours: 'Recommended for STEM, advanced college courses, and graduates',
  quickGoalDescription5Hours: 'Use Learn for 1 hour every day per week',
  quickGoalPresetTitle: '{{hours}} hrs weekly',
  quickGoalTitle: 'Study {{hours}} hours weekly',
  quizCompleteRestartOrMakeYourOwn:
    'Challenge yourself again, or create your own quizzes by getting started in Notability.',
  quizLabel: 'Quiz',
  quizLimitProgression: 'You learned {{answered}} out of {{total}} questions.',
  quizNotFound: 'Quiz not found',
  quizQuestionTipDontShowAgain: "Don't show again",
  quizShareExplainer: 'You will only share this quiz. Your notes will remain private.',
  quizSharingLinkCopied: 'Quiz link copied',
  quizURLLabel: 'Quiz share link',
  quotaReachedChangesNotSaved: 'Quota reached. Changes not saved',
  quote: 'Quote',
  reactivate: 'Reactivate',
  reactivatedAccountEmailMessage:
    '{{businessName}} has re-activated your Notability account. Log in and access your notes to start collaborating with your team!',
  reactivatedAccountEmailSubject: 'Your account has been restored.',
  reactivateUser: 'Reactivate user?',
  recenter: 'Recenter',
  recentlyCreated: 'Recent',
  recentlyDeleted: 'Recently Deleted',
  recentlyDeletedNotesWillBeShownHere:
    '<notice>Recently deleted notes will be shown here.</notice><warning>Notes will be permanently deleted after 30 days.</warning>',
  recentlyDeletedSharedLibrariesWillBeShownHere:
    '<notice>Recently deleted shared libraries will be shown here.</notice><warning>Shared libraries will be permanently deleted after 30 days.</warning>',
  recentNotes: 'Recent notes',
  recentQuizzes: 'Recent quizzes',
  recentSearches: 'Recent searches',
  recentSearchesTitle: 'Recent Searches',
  recentTagsTitle: 'Recent Tags',
  recievedFeedbackMessage: 'Thanks for your feedback!',
  record: 'Record',
  recordALectureDescription: 'Automatic transcripts',
  recordAudioTooltip: 'Record audio',
  recording: 'Recording',
  recordingAlreadyActiveInAnotherTab: 'Stop the recording in your other tab to record here.',
  recordingAutoStoppedTitle: 'Recording stopped',
  recordingConsentCardNotice: "By recording, you confirm you've told everyone in the meeting.",
  recordingConsentModalBody:
    "By starting recording, you confirm you've told everyone in this meeting that it's being recorded, and that you have obtained any consent required by law.",
  recordingConsentModalConfirm: 'Start recording',
  recordingConsentModalTitle: 'Confirmation',
  recordingCueCardBody:
    'Record audio and watch as Notability automatically creates transcripts and summaries—perfect for reviewing and studying later. Try it now!',
  recordingCueCardTitle: 'Turn Speech Into Smart Notes',
  recordingHasBeenDeleted: 'Recording has been deleted',
  recordingInactiveStopped: "We haven't heard anything for 15 minutes, so we stopped and saved your recording.",
  recordingInProgress: 'Recording in progress',
  recordingInProgressByUserTooltip: '{{userName}} is recording',
  recordingInProgressInAnotherNote: 'Recording in progress in another note.',
  recordingInProgressTooltip: 'Recording in progress',
  recordingInputDevice: 'Microphone',
  recordingInputNoneFound: 'No audio input devices found.',
  recordingInputSwitched: "Your system's default microphone changed.",
  recordingInputSwitchedTitle: 'Now recording from {{label}}',
  recordingLowVolumeWarningDescription: 'Try checking your microphone.',
  recordingLowVolumeWarningTitle: 'Poor audio input',
  recordingMeetingEnded: 'It looks like your meeting ended, so we stopped and saved your recording.',
  recordingNoAudioDescription: 'Check your microphone or input settings.',
  recordingNoAudioTitle: 'No audio detected',
  recordingOutputDevice: 'Speaker',
  recordingOutputNoneFound: 'No audio output devices found.',
  recordingPausePlayback: 'Pause recorded audio',
  recordingSavedOffline:
    "You're offline, so we saved your recording in the browser. We'll upload it for you when you're back online.",
  recordingSavedOfflineTitle: 'Recording saved',
  recordingSectionStartedAt: '{{day}}, {{time}}',
  recordingSectionTitle: 'Recording {{number}}',
  recordingSettingMeetingPrompt: 'Meeting detection',
  recordingSettingMeetingPromptDescription:
    'Suggest starting a recording in a new note when another app begins using your microphone.',
  recordingStartPlayback: 'Play recorded audio',
  recordingStartRecording: 'Start recording audio',
  recordingStopped: 'Recording stopped',
  recordingStoppedNoteDeleted: 'Recording stopped because the note it belonged to was deleted.',
  recordingStopRecording: 'Stop recording audio',
  recordingYourClass: 'Recording your class…',
  recordNow: 'Record now',
  recordYourClassPrompt: 'Want to record audio too?',
  recover: 'Recover',
  recoveryEmailAddedNotificationEmailMessage:
    'A recovery email address has been added to your Notability account.\n\nIf you did not make this change, please contact us at support@gingerlabs.com',
  recoveryEmailAddedNotificationEmailSubject: 'A recovery email was added to your Notability account',
  recoveryEmailAlreadyConfirmedError: 'This email change has already been confirmed',
  recoveryEmailAlreadyVerifiedError: 'This recovery email address has already been verified.',
  recoveryEmailCurrentUserUsingError: 'You are already using this email address',
  recoveryEmailDuplicatePromotionError: 'An email change request is already pending',
  recoveryEmailPendingError: 'A verification is already pending for this email address',
  recoveryEmailPromotionConfirmationEmailActionButton: 'Confirm Email Change',
  recoveryEmailPromotionConfirmationEmailMessage:
    'A request was made to change your Notability login email to {{newPrimary}}. Click the button below to confirm.\n\nIf you did not make this request, please contact us at support@gingerlabs.com',
  recoveryEmailPromotionConfirmationEmailSubject: 'Confirm your Notability email change',
  recoveryEmailRemovedNotificationEmailMessage:
    'Your Notability recovery email address has been removed.\n\nIf you did not make this change, please contact us at support@gingerlabs.com',
  recoveryEmailRemovedNotificationEmailSubject: 'Your Notability recovery email was removed',
  recoveryEmailTokenExpiredError: 'This verification link has expired. Please request a new one.',
  recoveryEmailTokenInvalidError: 'This verification link is invalid or has already been used.',
  recoveryEmailVerificationEmailActionButton: 'Verify Recovery Email',
  recoveryEmailVerificationEmailMessage:
    'Click the button below to verify your recovery email address. This link will expire in 24 hours.',
  recoveryEmailVerificationEmailSubject: 'Verify your Notability recovery email',
  rectangleSelection: 'Rectangle',
  redeemGiftHeadingSignIn: 'Redeem your gift',
  redeemGiftHeadingSignUp: 'Sign up to redeem your Notability gift',
  redo: 'Redo',
  referralCannotApplyBody:
    "This may be because you've already used a free trial, currently have a subscription, or aren't eligible for this offer. You can still get started with Notability for free.",
  referralCannotApplyHeading: 'This guest pass can’t be applied to your account.',
  referralCodeGenerationError: 'Unable to generate a referral code. Please try again.',
  referralGetStartedHeading: 'Your guest pass is ready',
  referralIneligibleError: "This guest pass can't be applied to your account.",
  referralLandingBody:
    "A friend sent you a 30-day guest pass to {{planName}}. See what's included, then continue to check your eligibility and redeem your offer.",
  referralLandingCta: 'Unlock your guest pass',
  referralLandingDisclaimerMonthly:
    'Guest pass available for eligible users only. Eligibility will be confirmed after sign-in. If redeemed, a payment method is required and the subscription renews automatically at {{price}}/mo unless canceled before the trial ends.',
  referralLandingDisclaimerNoPrice:
    'Guest pass available for eligible users only. Eligibility will be confirmed after sign-in. If redeemed, a payment method is required and the subscription renews automatically unless canceled before the trial ends.',
  referralLandingDisclaimerYearly:
    'Guest pass available for eligible users only. Eligibility will be confirmed after sign-in. If redeemed, a payment method is required and the subscription renews automatically at {{price}}/yr unless canceled before the trial ends.',
  referralLandingHeading: '<eyebrow>Claim your Guest Pass for</eyebrow><planName>{{planName}}</planName>',
  referralLandingLiteFeature1: '<bold>Unlimited note editing</bold> with all of our tools and content',
  referralLandingLiteFeature2: '<bold>Third party backups (iOS only)</bold>',
  referralLandingLiteFeature3: '<bold>7-day version history</bold>',
  referralLandingPlusFeature1: '<bold>Unlimited note editing</bold> with all of our tools and content',
  referralLandingPlusFeature2: '<bold>Add PDFs and docs</bold> directly into your notes',
  referralLandingPlusFeature5: '<bold>Record and transcribe audio</bold>, plus instantly search your handwritten notes',
  referralLandingPlusFeatureQuizzes: '<bold>AI-powered quizzes and flashcards</bold> (limited)',
  referralLandingPlusFeatureYoutube: '<bold>YouTube link-to-note conversions</bold> with transcripts and summaries',
  referralLandingProFeature1: '<bold>Unlimited note editing</bold> with all of our tools and content',
  referralLandingProFeature2: '<bold>Instant search</bold> across your handwritten notes',
  referralLandingProFeature3: '<bold>Smart Notes</bold> with real-time transcription and AI-powered summaries',
  referralLandingProFeature4: '<bold>Unlimited YouTube-to-note conversions, quizzes, and flashcards</bold>',
  referralLandingProFeature5:
    '<bold>Unlimited live audio transcription</bold>, plus chat with your notes for explanations and quicker learning',
  referralNotAvailableBody:
    'This referral link may be invalid, expired, or no longer active. Please reach out to the person who sent it to share a new link.',
  referralNotAvailableHeading: 'This guest pass link isn’t available.',
  referralPageTitle: 'Claim your Guest Pass',
  referralSignUpHeading: 'Create a new account',
  referralStepFreeTrial: 'Free trial',
  referralTrialDisclaimerMonthly:
    'This offer is for new members only. Membership will automatically renew to a paid monthly subscription at {{price}}.',
  referralTrialDisclaimerNoPrice:
    'This offer is for new members only. Membership will automatically renew to a paid subscription.',
  referralTrialDisclaimerYearly:
    'This offer is for new members only. Membership will automatically renew to a paid annual subscription at {{price}}.',
  referralUnavailableError: "This guest pass link isn't available.",
  reloadNote: 'Reload note',
  reminder: 'Reminder',
  remix: 'Remix',
  remixCount: '{{count}} Remix',
  remixes: 'Remixes',
  remixesCount: '{{count}} Remixes',
  remixOf: 'Remix of',
  remoteConfigHeader: 'Configuration',
  remove: 'Remove',
  removeCropEdits: 'Remove cropping',
  removeLink: 'Remove link',
  removeUser: 'Remove user?',
  removeUserBulletKeepPrivate: 'Maintain access to their private library',
  removeUserBulletLoseSharedAccess: 'Lose access to Shared Libraries',
  removeUserError: 'There was an error removing this user. Please try again or contact Support',
  removeUserLeadEmail: '<email>{{email}}</email> will be removed from {{organizationName}}.',
  removeUserLeadNameEmail: '<name>{{name}}</name> ({{email}}) will be removed from {{organizationName}}.',
  removeUserListHeader: 'This user will:',
  removeUserMembersStillHaveAccess:
    'Members of {{organizationName}} will still have access to notes shared by this user.',
  renameDividerServiceError: 'Renaming divider failed',
  renameNote: 'Rename',
  renameOrganizer: 'Rename',
  renameSubjectServiceError: 'Renaming subject failed',
  reply: 'Reply…',
  replyCount_one: '{{count}} reply',
  replyCount_other: '{{count}} replies',
  reportBioArea: 'Where does the issue appear on this profile?',
  reportBioAreaAvatar: 'Avatar',
  reportBioAreaDescription: 'Bio',
  reportBioAreaLinks: 'Social Media Links',
  reportBioAreaMultiple: 'Multiple Areas',
  reportBioButton: 'Report',
  reportBioConfirm: 'Are you sure you want to report {{user}} for {{reason}}?',
  reportBioConfirmed: 'Your report has been filed.',
  reportBioNextButton: 'Next',
  reportBioReason: 'What is the issue with this profile?',
  reportBioTitle: 'Report {{screenname}}',
  reportNoteHeader: 'Report this note?',
  reportNoteText: 'Please select the reason why you are reporting this note below.',
  reportNoteTreeFamilyDescription: "Please select the reason why you are reporting this note's family tree below.",
  reportNoteTreeFamilyTitle: 'Report a note family tree',
  requestAccess: 'Request access',
  requestedAccess: 'Requested access',
  requestedAccessPending: 'Requested',
  requestedEditAccess: 'Requested edit access',
  requestEditPermission: 'You can only view this note',
  requestEditPermissionSubhead: 'Request edit access',
  requestedNoteAccess: "Access requested. You'll hear back if it's granted.",
  requestedUnauthenticatedUser: 'Cannot request user other than currently authorized user.',
  requestNoteAccessError: 'There was an error requesting access to this note',
  requiresEditAccess: 'Edit access required',
  resendInvitation: 'Resend invitation?',
  resendInvitationAlreadyAccepted: 'This user has already accepted an invitation to this organization.',
  resendInvitationAlreadyInvited: 'This user has already been invited to this organization.',
  resendInvitationNotInBusiness: 'This user is not a member of this organization.',
  resendInvite: 'Resend invite',
  'Reset Password': 'Reset Password',
  'Reset your password': 'Reset your password',
  resetFlashcardProgressBody: 'This will set your memorization progress to 0 cards.',
  resetFlashcardProgressTitle: 'Reset flashcard progress?',
  resetFlashcards: 'Reset flashcards',
  resetProgressMenuItem: 'Reset progress',
  resetQuizProgressBody: 'This will reset your quiz progress to 0 questions.',
  resetQuizProgressTitle: 'Reset quiz progress?',
  resetTestProgressBody: 'This will reset your test progress and create a new one.',
  resetTestProgressTitle: 'Create new test?',
  resetZoom: 'Reset zoom',
  resourcesHeaderDropdown: 'Resources',
  restoreNote: 'Restore note',
  restoreSharedLibrariesError: 'There was an error restoring the shared libraries',
  restoreSharedLibrariesPartialError: 'Some shared libraries could not be restored',
  restricted: 'Restricted',
  reSubscribe: 'Re-subscribe',
  resumeDiscussion: 'Resume Discussion',
  retry: 'Retry',
  retryGoal: 'Retry goal',
  returnToApp: 'Return to App',
  returnToLibrary: 'Return to library',
  returnToNotability: 'Return to Notability',
  returnToRecordingNote: 'Return to {{noteTitle}}',
  review: 'Review',
  Review: 'Review',
  reviewIncorrect: 'Review incorrect',
  reviewSmartNotes: 'Review Smart Notes',
  rightAlign: 'Right align',
  rights: 'All rights reserved',
  role: 'Role',
  samsungPurchaseAlreadyClaimed: 'This purchase is already associated with another account.',
  samsungPurchaseValidationUnavailable:
    'We could not verify your purchase right now. Please try again in a few minutes.',
  Save: 'Save',
  saveAsSticker: 'Save as sticker',
  saveChanges: 'Save changes',
  saveTemplate: 'Save Template',
  scanningForImportantTopicsAndThemes: 'Scanning for important topics and themes...',
  screennameAlphanumericEnd: 'Usernames must end with an alphanumeric character',
  screennameAlphaStart: 'Usernames must start with an alphabetic character',
  screennameCharacterSetRequirement: 'Usernames can only contain lowercase alphanumeric characters, plus "-" and "_"',
  screennameFormatError: 'Usernames can only contain alphanumeric characters, plus - and _',
  screennameInUseError: 'That username is already in use',
  screennameLengthRequirement: 'Username must be between {{min}} and {{max}} characters',
  screennameLowercaseRequirementError: 'Usernames may not contain capital letters',
  screennameNotAvailableError: 'That username is not available',
  screennameRepeatedCharacterLimitation: 'Username may not contain more than one "-" or "_" in a row',
  screennameRequiredError: 'Choose a username before viewing your favorited notes.',
  screennameTooLongError: 'The username must be shorter than {{maxScreennameLength}} characters',
  screennameTooShortError: 'The username must be at least {{minScreennameLength}} characters long',
  scrim: 'Scrim',
  scrollLeft: 'Scroll left',
  scrollRight: 'Scroll right',
  search: 'Search',
  searchByTitle: 'Search by title',
  searchEmojis: 'Search emojis',
  searchGallery: 'Search Gallery',
  searchPeople: 'Search people',
  searchTagsClear: 'clear tags',
  searchTip: 'type @ to search users or # to search tags',
  searchTooltip_styled: 'Search any topic, or type <1>#</1> to search tags',
  sectionHeaderGallery1: 'Get',
  sectionHeaderGallery2: 'inspired...',
  sectionHeaderGalleryHighlight: 'Get <Highlight>inspired...</Highlight>',
  sectionHeaderNBPlus1: 'Customize your experience with',
  sectionHeaderNPPLusV2: 'Unlock superpowers\n with <Highlight>Notability Plus</Highlight>',
  sectionHeaderShop1: 'Introducing',
  sectionHeaderShop2: 'Notability Extensions',
  sectionTextGallery:
    '...by our all new note-sharing platform, <1>Notability Gallery</1>, where you can publish your work, spark new ideas, save your favorites, and discover endless inspiration!',
  sectionTextNBPlus:
    'Take your notes to the next level with add-ons! Sticker packs, themes, journals, and more! Now included with an annual subscription.',
  sectionTextNBPlusV2: 'Take your notes to the next level with add-ons! Now included with an annual subscription.',
  sectionTextNBPlusV3:
    'Take your notes to the next level! Enjoy unlimited note taking, exclusive technology, and\ncontent with an annual subscription.',
  seeAll: 'See all',
  seeAllFeatures: 'See all features',
  seeDetails: 'See details',
  seeLess: 'See Less',
  seeMore: 'See More',
  seeMoreResultsPrompt: 'Looking for more?',
  seeMoreTemplates: 'See more',
  Select: 'Select',
  selectAll: 'Select all',
  selectAnIndustry: 'Select an industry',
  selectAnIssue: 'Select an Issue',
  selectionStyle: 'Selection style',
  selectMaterialsToReview: 'Select materials to review',
  selectNotesToAddThemBack:
    'Select notes to add them back into your library. Unless recovered, notes in this list will be permanently deleted after 30 days.',
  selectPlan: 'Select Plan',
  selectSharedLibrariesToRestore:
    'Select shared libraries to restore them. Unless recovered, shared libraries in this list will be permanently deleted after 30 days.',
  selectStudyMaterials: 'Select study materials',
  'Send link': 'Send link',
  'Send me a link instead': 'Send me a link instead',
  sendBackward: 'Send Backward',
  sendToBack: 'Send to Back',
  sendToBackAction: 'Send to back',
  sendToFrontAction: 'Send to front',
  sendToSupport: 'Send to Support',
  sendWebFeedback: 'Send feedback',
  serverConnectionErrorMessageNew:
    'There was an issue connecting with the server. Please check your connection and try again.',
  serverConnectionErrorTitle: 'Server Connection Error',
  serverErrorMessage:
    "We're sorry, something went wrong on our server. Please try again later or contact support if the problem persists.",
  serverErrorTitle: 'Server Error',
  sessionsAWeek_one: '1 session a week',
  sessionsAWeek_other: '{{count}} sessions a week',
  setCustomGoal: 'Set custom goal',
  setCustomGoalDescription: 'Track progress exactly how you want to',
  setDeviceLimitEnabledForSubscriptionNoSubscriptionErr: 'There is no subscription with the given transactionId',
  setGoal: 'Set goal',
  setGoals: 'Set goals',
  setQuickGoalTitle: 'Set goal: study {{hours}} hours weekly',
  setStudyGoalsSubtitle: 'Studies show writing down goals can make you 1.4x more likely to achieve them.',
  setStudyGoalsTitle: 'Set study goals to track your progress',
  settingsSaved: 'Settings saved',
  sexualContent: 'Sexual Content',
  shapeArrow: 'Arrow',
  shapeDiamond: 'Diamond',
  shapeEllipse: 'Ellipse',
  shapeLine: 'Line',
  shapePolygon: 'Polygon',
  shapeRectangle: 'Rectangle',
  Shapes: 'Shapes',
  shapeStar: 'Star',
  shapesToolbox: 'Shapes',
  shapeTriangle: 'Triangle',
  share: 'Share',
  shared: 'Shared',
  sharedLibraries: 'Shared Libraries',
  sharedLibraryRestored_one: '1 shared library restored',
  sharedLibraryRestored_other: '{{count}} shared libraries restored',
  sharedLibrarySettings: 'Shared library settings',
  sharedNoteInvalidOwnerError: 'You are not the owner of this shared note',
  sharedNotesEmptyText: 'Publish your notes right from Notability and share with others!',
  sharedQuiz: 'Shared Quiz',
  sharedQuizSignupPromptSubtitle: 'Create quizzes from your notes, imported documents and even YouTube links.',
  sharedQuizSignupPromptTitle: 'Sign up for Notability and start creating your own quiz!',
  sharedQuizUnavailableSubtitle: 'Shared quizzes are coming back soon',
  sharedQuizUnavailableTitle: 'This share link is no longer active',
  sharedWithMe: 'Shared with me',
  shareNote: 'Share Note',
  shareNoteButton: 'Share',
  shareNoteDisclosure: 'Anyone with the link will be able to view, edit and share this note.',
  shareNoteError: 'There was an error sharing your note. Please try again.',
  shareNoteModalTitle: 'Share {{noteTitle}}',
  sharePromptProfessionalCta: 'Share with teammates',
  sharePromptProfessionalPdfBody: 'Share with teammates to highlight and add notes in one place.',
  sharePromptProfessionalPdfTitle: 'Review together',
  sharePromptProfessionalReopenBody: 'Share your note so teammates can add to it and stay aligned.',
  sharePromptProfessionalReopenTitle: 'Invite your team',
  sharePromptStudentCta: 'Share with classmates',
  sharePromptStudentLearnCloseBody: 'Send your note to classmates so they can review it and study with you.',
  sharePromptStudentLearnCloseTitle: 'Share your study materials',
  sharePromptStudentPdfBody: 'Invite classmates and friends to highlight, annotate, and learn in one place.',
  sharePromptStudentPdfTitle: 'Study together',
  sharePromptStudentReopenBody: 'Work on the note together or study as a group.',
  sharePromptStudentReopenTitle: 'Invite classmates to join',
  shareQuiz: 'Share quiz',
  shareQuizModalTitle: 'Share {{title}} Quiz',
  shareWithYourWholeTeam: 'Share with your whole team',
  shareWorkspaceButton: 'Share',
  shortenedSearchTooltip: 'Search',
  showFewerTools: 'Show fewer tools',
  showLibrary: 'Show library',
  showMoreTools: 'Show more tools',
  showNavigation: 'Show navigation',
  showTip: 'Show tip',
  'Sign in to Notability': 'Sign in to Notability',
  'Sign up to get started': 'Sign up to get started',
  signedInAs: 'Signed in as {{userEmail}}',
  signInButtonText: 'Sign in',
  signInFailed: 'Sign in failed',
  signingUp: 'Signing up',
  signInHere: 'Sign in here',
  signInMethodDidNotWork: 'The sign in method did not work. Please try again.',
  signInNotVerifiedError: "We couldn't verify this sign-in. Check your password and try again.",
  signInSwitchToSignUp: "Don't have an account? <0>Sign up here</0>",
  signInWithEmailInstead: '<0>Sign in with email</0> instead.',
  signInWithPasswordInstead: '<0>Sign in with a password</0> instead.',
  signOut: 'Sign out',
  signUp: 'Sign up',
  signUpSwitchToLogin: 'Already signed up? <0>Sign in here</0>',
  signUpWithEmailInstead: '<0>Sign up with email</0> instead.',
  signUpWithPasswordInstead: '<0>Sign up with a password</0> instead.',
  siteBlurb: 'Notes are just the beginning. Create and annotate anything, from study guides to storyboards.',
  siteCardBottomHeader: '...and from\nmany places',
  siteCardBottomText: 'Conversations, nature, books!',
  siteCardTopHeader: 'Notability captures\nideas in many\nforms...',
  siteCardTopText: 'Photos, sketches!',
  siteHeading: 'Unleash your ideas, your way',
  siteHeadingWebApp: 'Unleash your ideas, your way.  Now on web.',
  siteHeroFootnote: 'Included in Notability Plus subscription.',
  siteHeroHeader: 'A simple, powerful toolset for every thought',
  siteHeroHeaderHighlightV2: 'A simple, <Highlight>powerful</Highlight> toolset',
  siteHeroTextV2: 'An intuitive, minimal interface with powerful AI tools to take your learning to the next level.',
  sketchWorkflowsDiagrams: 'Sketch workflows, diagrams, and decisions your team actually remembers',
  Skip: 'Skip',
  Skipped: 'Skipped',
  slashCommandMenu: 'Slash Command Menu',
  slashCommandPlaceholder: 'Type "/" for quick commands',
  slashCommandPlaceholderOnboardingTour: 'Paste content (e.g. docs, ChatGPT) to get started or type "/" for commands',
  slashCommandPlaceholderYouTubeHint: 'Paste a YouTube link to get started or type "/" for commands',
  slidePaginationAriaLabel: 'Go to slide',
  slideshowModal: 'Slideshow modal',
  smartNotes: 'Smart Notes',
  smartNotesShimmerAriaLabel: 'Smart Notes are transcribing',
  socialEditHint: 'Social media links also go here.',
  sortBy: 'Sort by',
  sortByAccess: 'Sort by Access',
  sortByMenuOption: 'Sort By ({{option}})',
  sortByName: 'Sort by Name',
  sortByRole: 'Sort by Role',
  sortMostViewed: 'Most Viewed',
  sortNotesMenuOption: 'Sort Notes',
  sortOptionCreatedDate: 'Created Date',
  sortOptionModifiedDate: 'Modified Date',
  sortOptionName: 'Name',
  sortTypeTitle: 'Sort Order',
  'space key character': 'space',
  spacedRepetitionResultCardsReviewed: '<numCards>{{count}}</numCards><cardsReviewed>cards reviewed</cardsReviewed>',
  spacedRepetitionSchedulingExplanation:
    'Cards you found hard or skipped will come up sooner. Come back later to keep making progress.',
  spam: 'Spam',
  speakerLabel: 'Speaker {{number}}',
  ssoRequiredError: 'Your organization requires sign in with {{provider}}.',
  ssoRequirementOwnerNotAuthenticatedError:
    'You need to sign in with {{provider}} at least once before requiring it for your organization.',
  start: 'Start',
  start30DayFreeTrial: 'Start 30-day free trial',
  startAGoal: 'Start a goal',
  startAGoalDescription:
    'The most effective approach involves time-blocking, setting realistic goals, and eliminating distractions.',
  startDiscussion: 'Start discussion',
  starter: 'Starter',
  startFreeTrial: 'Start free trial',
  startFreeTrialButton: 'Start your free trial',
  startingTranscripts: 'Starting Transcripts',
  startLearningThisContent: 'Start learning this content',
  startNoteWithRecording: 'Start note with recording',
  startOver: 'Start Over',
  startOverLowercase: 'Start over',
  startQuiz: 'Start quiz',
  startRecording: 'Transcribe',
  startStudying: 'Start studying',
  startStudyingDescription: 'Bring in a PDF, slides, or notes to study from.',
  startWithATemplate: 'Start with a template',
  Stationery: 'Stationery',
  stickersToolbox: 'Stickers',
  stickersToolboxEmptyHint: 'Select ink on the page and right-click "Save as sticker" to add it here.',
  stickersToolboxMyStickers: 'My Stickers',
  stickersToolboxNoStickers: 'No stickers yet',
  stickersToolboxSaveFailed: "Couldn't save sticker",
  stopRecording: 'Stop recording',
  stopRecordingTooltip: 'Stop recording',
  strikethrough: 'Strikethrough',
  stripeActivationPending: 'Activating subscription...',
  stripeConversionEmailFeedbackHeader: 'Send us your feedback',
  stripeConversionEmailFeedbackMessage:
    'Your feedback is invaluable in helping shape the future of Notability on web. Let us know what you like, don’t like, wish you could do or any other thoughts you’d like to share about the Notability web beta.',
  stripeConversionEmailMessage:
    'You now have access to everything Notability has to offer! Make the most of your subscription with the powerful Learn features that transform your notes into interactive study sessions.',
  stripeConversionEmailPreheader: 'Enjoy access to quizzes, summaries and audio transcription.',
  stripeConversionEmailSurveyHeader: 'Personalize your experience',
  stripeConversionEmailSurveyMessage:
    'Take the personalization survey to help us understand your goals and needs in using Notability. Your feedback will help guide our development efforts to deliver relevant features and updates.',
  stripeSessionExpired: 'Checkout session expired.',
  stroke: 'Stroke',
  structuredDataAppDescription:
    'Notability is a note-taking app for handwriting, audio recording and transcription, document annotation, and AI tools including summaries, flashcards, quizzes, and chat with your notes. Download Notability for free on iPad, iPhone, Android, Mac, Windows, and web.',
  structuredDataAppDescriptionBusiness:
    'Notability for Business is a note-taking and collaboration platform for teams. The app includes document markup, meeting recording and transcription, shared libraries of notes, AI-powered summaries, and centralized user administration and billing.',
  structuredDataAppDescriptionChina:
    'Notability is a note-taking app for handwriting, audio recording and transcription, and document annotation. Download Notability for free on iPad, iPhone, and Mac.',
  structuredDataAppDescriptionEducation:
    'Notability for Education is a free, MDM-configurable note-taking platform for schools, compatible with Jamf and Mosyle. It includes handwriting recognition and math-to-LaTeX conversion powered by MyScript®.',
  structuredDataOrgDescription:
    'Notability is the San Francisco-based software company behind the award-winning note-taking and document annotation app of the same name, used by millions of students, educators, and professionals worldwide. Founded in 2008, it operates legally as Ginger Labs, Inc.',
  students: 'students.',
  studentsCtaSeePricing: 'See Pricing',
  studentsCtaStartFree: 'Start for Free',
  studentsFaq1Answer: 'Yes. Starter is free — unlimited note-editing, PDFs, all tools. No credit card required.',
  studentsFaq1Question: 'Is Notability free to get started?',
  studentsFaq2Answer:
    'Yes. Notability works on iPad, iPhone, Mac, and via web browser — including Windows and Chromebook. Notes sync automatically across every device.',
  studentsFaq2Question: "I don't have an iPad. Does Notability work on my laptop?",
  studentsFaq3Answer:
    'Tap record at the start of class. Audio timestamps sync to every note you write. Tap any line to replay that exact moment. Transcription available on Plus and Pro.',
  studentsFaq3Question: 'How does lecture recording work?',
  studentsFaq4Answer:
    'Notability analyzes your notes and generates questions automatically — no setup. Choose session length (15, 20, or 25 minutes). Available on Plus and Pro.',
  studentsFaq4Question: 'How do quizzes and flashcards work?',
  studentsFaq5Answer:
    'Plus gives core AI features with monthly caps. Pro removes all limits and adds real-time Smart Notes transcription and Chat with Notes.',
  studentsFaq5Question: "What's the difference between Plus and Pro?",
  studentsFaq6Answer:
    'Apple Notes stores information. Notability is built to help you learn from it — recording, transcription, AI summaries, and quizzes are designed for how students actually study.',
  studentsFaq6Question: 'What makes Notability different from Apple Notes?',
  studentsFaqMoreQuestions: 'Have more questions? Visit our <HelpCenter>Help Center</HelpCenter>',
  studentsFaqTitle: 'FAQ',
  studentsFeatureQuizzesBody:
    'Notability generates quizzes directly from your notes — multiple choice, true/false, flashcards. Test yourself on the material your professor covered, not generic practice questions.',
  studentsFeatureQuizzesBullet1: 'Multiple choice, true/false, and flashcard formats — all auto-generated',
  studentsFeatureQuizzesBullet2: 'Built from your notes, not a generic question bank',
  studentsFeatureQuizzesBullet3: 'Works on every note — recordings, PDFs, YouTube imports',
  studentsFeatureQuizzesLabel: 'Quizzes',
  studentsFeatureQuizzesTitle: 'Study what you<br>actually covered.',
  studentsFeaturesEyebrow: 'Go deeper',
  studentsFeatureSmartNotesBody:
    'When class ends, Notability generates Smart Notes from everything you recorded — organized, readable, and ready to review. No rewriting needed.',
  studentsFeatureSmartNotesBullet1: 'Generated from your actual recording — not generic summaries',
  studentsFeatureSmartNotesBullet2: 'Formatted with key topics, definitions, and takeaways',
  studentsFeatureSmartNotesBullet3: 'Paste Smart Notes back into your note to highlight and annotate',
  studentsFeatureSmartNotesLabel: 'Smart Notes',
  studentsFeatureSmartNotesTitle: 'Your lecture,<br>already studied.',
  studentsFeaturesTitle: 'More than notes.<br>A complete study tool.',
  studentsFeatureYouTubeBody:
    'Drop in any YouTube URL — lecture, tutorial, explainer — and Notability turns the transcript into organized notes and a quiz. No listening required.',
  studentsFeatureYouTubeBullet1: 'Works with any public YouTube video — lectures, tutorials, office hour recordings',
  studentsFeatureYouTubeBullet2: 'Automatically generates Smart Notes & a quiz from the video transcript',
  studentsFeatureYouTubeBullet3: 'Skim the key points in minutes, not the full runtime',
  studentsFeatureYouTubeLabel: 'YouTube to Notes',
  studentsFeatureYouTubeTitle: 'Paste a link.<br>Get a study guide.',
  studentsFinalCtaTitle: 'Download Notability for free',
  studentsHeroEyebrow: 'Notability for Students',
  studentsHeroPillPdf: 'PDF annotation',
  studentsHeroPillQuizzes: 'Quizzes & flashcards',
  studentsHeroPillRecording: 'Lecture recording',
  studentsHeroPillSummaries: 'AI summaries',
  studentsHeroSubtitle:
    "Record class, get a clear summary, and turn your notes into quizzes and flashcards when it's time to study.",
  studentsHeroTitle: 'Study better.<br>Not longer.',
  studentsMidCtaSubtitle: 'Free to start. No credit card required.',
  studentsMidCtaTitle: 'Try it before your next lecture.',
  studentsPageTitle: 'Notability for Students — Study better. Not longer.',
  studentsTestimonial1Name: 'Shelby',
  studentsTestimonial1Quote:
    '“Notability has absolutely saved me time and reduced my stress, and improved my retention. 10,000%.”',
  studentsTestimonial1Role: 'Clinical Anesthesia Student · 2 years',
  studentsTestimonial2Name: 'Ruby',
  studentsTestimonial2Quote:
    "“Having notes generated so quickly with Smart Notes makes me feel like I've got a lot less work to do.”",
  studentsTestimonial2Role: 'Law Student · 1 year',
  studentsTestimonialsLabel: 'Student testimonials',
  studentsTrustFeatured: 'Featured by Apple',
  studentsTrustRating: '4.8 on the App Store',
  studentsTrustReach: '5M+ students worldwide',
  studentsWorkflowEyebrow: 'Built for how you actually learn',
  studentsWorkflowStep1Body:
    'Tap record. Notability transcribes every word, synced to your exact notes. Even when the professor moves fast.',
  studentsWorkflowStep1Label: 'During lecture',
  studentsWorkflowStep1Title: 'Record every word.<br>Miss nothing.',
  studentsWorkflowStep2Body:
    "Import lecture slides, syllabi, readings. Highlight and add notes directly on top — linked to every recording you've made.",
  studentsWorkflowStep2Label: 'Back at your desk',
  studentsWorkflowStep2Title: 'Annotate what matters.<br>Everything stays connected.',
  studentsWorkflowStep3Body:
    'Quizzes generated from your own notes — no setup needed. Test yourself on exactly what your professor covered.',
  studentsWorkflowStep3Label: 'Before the exam',
  studentsWorkflowStep3Title: 'Study smarter.<br>Walk in ready.',
  studentsWorkflowStepsLabel: 'Workflow steps',
  studentsWorkflowTitle: 'Your entire study workflow.<br>One app.',
  study: 'Study',
  'Study Materials': 'Study Materials',
  studyAYoutubeLecture: 'Study a YouTube lecture',
  studyAYoutubeLectureDescription: 'Paste a link to capture the video as a note you can study from.',
  studyMaterialChoiceHeader: 'Choose your study method',
  studyPreviewCardShimmerAriaLabel: 'Study preview card is generating',
  studyPreviousMaterials: 'Study previous materials',
  studyResultDescription: "We'll review your mistakes and tackle new ones.",
  studyTape: 'Study Tape',
  styles: 'Styles',
  subConfirmedBodyClassic:
    'You now have access to unlimited note-taking with your one-time purchase. Make the most of your plan with powerful handwriting, organization, and collaboration features.',
  subConfirmedBodyLite:
    'You now have access to unlimited note-taking. Make the most of your plan with powerful handwriting, organization, and collaboration features.',
  subConfirmedBodyPlus:
    "You've got access to note summaries, audio transcripts and powerful quizzes. Create some notes to get started.",
  subConfirmedBodyPro:
    'You have access to our most powerful features including real-time Smart Notes, live transcription, quizzes, flashcards and the ability to ask your note questions for deeper insights.',
  subConfirmedBodyV2:
    'Enjoy access to Notability\'s most powerful features including quizzes, summaries and transcripts, just tap "Learn" to begin!',
  subConfirmedHeader: 'Welcome to Plus',
  subConfirmedHeaderPro: 'Welcome to Pro',
  subConfirmedRenewalDate: 'Your subscription will auto-renew on {{date}}.',
  subConfirmedWelcomeClassic: 'Welcome to Classic',
  subConfirmedWelcomeLite: 'Welcome to Lite',
  subConfirmedWelcomePlus: 'Welcome to Plus',
  subConfirmedWelcomePro: 'Welcome to Pro',
  subject: 'Subject',
  subjectCountPluralSimple_one: '{{count}} subject',
  subjectCountPluralSimple_other: '{{count}} subjects',
  subjectDeletionModalBody: 'This subject and the {{count}} notes it contains will be deleted.',
  subjectDeletionModalBodySingular: 'This subject and the note it contains will be deleted.',
  subjectDeletionModalTitle: 'Delete this subject?',
  subjectName: 'Subject name',
  subjectsListTitle: 'Subjects',
  subjectTitle: 'Subject title',
  Submit: 'Submit',
  subscribeButton: 'Subscribe',
  subscribeCurrentPlanSubtitle: 'Choose a plan from below. You are currently on the {{planName}} plan.',
  subscribeNow: 'Subscribe now to regain access to quizzes, summaries and audio transcripts.',
  subscribePageTitle: 'Subscribe',
  subscribeToContinueUsing: 'Subscribe to continue using {{tierName}}',
  subscribeToPreviousBusinessTier: 'Subscribe to {{tierName}}',
  subscript: 'Subscript',
  subscriptionActivatingSubtitle: 'This’ll just take a moment.',
  subscriptionActivatingTitle: 'Activating your subscription',
  subscriptionEndDate: 'Your subscription will end on {{expirationDate}}',
  subscriptionExpiryDate: 'Your subscription will expire on {{date}}',
  subscriptionHeaderLink: 'Pricing',
  subscriptionInactive: 'Subscription inactive',
  subscriptionNotEligibleForResubscribe: 'This business subscription is not eligible for resubscribe',
  subscriptionsManagerSearchPlaceholder: 'Search for subscription info using an original transaction ID',
  subscriptionsManagerTitle: 'Subscription Manager',
  suggestedScreennamesTitle: 'Similar screennames',
  summarizingKeyTopics: 'Summarizing key topics...',
  Summary: 'Summary',
  superscript: 'Superscript',
  supportHome: 'Support Homepage',
  supportSyllabusImportSubject: 'Syllabus import problem',
  surveyButtonCompleteSurvey: 'Complete survey',
  surveyButtonDoesNotApply: 'Does not apply',
  surveyChangeAnswerModalBody: 'Are you sure you want to change your previous answer?',
  surveyChangeAnswerModalCancel: "Don't Change",
  surveyChangeAnswerModalConfirm: 'Yes',
  surveyChangeAnswerModalTitle: 'Change your answer?',
  surveyDesktopPersonaSubtitle:
    "We'll set up Notability for how you work, like study guides for your classes or summaries for your meetings.",
  surveyExit: 'Exit',
  surveyFinishedSubheading:
    'Your feedback is invaluable in helping us determine what features to build and improve to support you in your journey!',
  surveyFinishedTitle: 'Thanks for completing the survey!',
  surveyGeneralUserDescriptionQuestionSubtitle:
    'This information will help guide our development efforts to provide features and improvements that are relevant to you. <bold>Choose any that apply.</bold>',
  surveyGeneralUserDescriptionQuestionSubtitleUpdated:
    'This information will help guide our development efforts to provide features and improvements that are relevant to you. <bold>Choose the most relevant option.</bold>',
  surveyGeneralUserDescriptionQuestionTitle: 'How would you describe yourself?',
  surveyGeneralUserDescriptionQuestionTitleUpdated: 'What best describes you?',
  surveyNotSureNotabilityFeaturesQuestionTitle: 'Which feature of Notability interests you the most?',
  surveyNotSureTaskChoiceCreativeProjects: 'Creative projects',
  surveyNotSureTaskChoiceNoteTaking: 'Note-taking',
  surveyNotSureTaskChoiceOrganization: 'Organization',
  surveyNotSureTaskChoicePlanning: 'Planning',
  surveyNotSureTasksQuestionSubtitle: 'Select all that apply.',
  surveyNotSureTasksQuestionTitle: 'What types of tasks do you generally need help with in your daily life?',
  surveyNotSureToolChoicePersonal: 'Personal use',
  surveyNotSureToolChoicePersonalAndProfessional: 'Both personal and professional use',
  surveyNotSureToolChoiceProfessional: 'Professional use',
  surveyNotSureToolQuestionTitle: 'Are you looking for a tool primarly for',
  surveyOtherHowDidYouHearChoiceAppStoreRecommendation: 'App Store recommendation',
  surveyOtherHowDidYouHearChoiceFriendOrColleague: 'Friend or colleague',
  surveyOtherHowDidYouHearChoiceOnlineReview: 'Online review',
  surveyOtherHowDidYouHearChoiceSocialMedia: 'Social media',
  surveyOtherHowDidyYouHearQuestionTitle: 'How did you hear about Notability?',
  surveyOtherNotabilityFeaturesChoiceAudioRecording: 'Audio recording',
  surveyOtherNotabilityFeaturesChoiceCrossDeviceSyncing: 'Cross-device syncing',
  surveyOtherNotabilityFeaturesChoiceHandwritingCapabilities: 'Handwriting capabilities',
  surveyOtherNotabilityFeaturesChoiceOrganizationTools: 'Organization tools',
  surveyOtherNotabilityFeaturesChoicePdfAnnotation: 'PDF annotation',
  surveyOtherNotabilityFeaturesChoiceStudyTools: 'Study tools',
  surveyOtherNotabilityFeaturesChoiceTranscriptions: 'Transcriptions',
  surveyOtherNotabilityFeaturesChoiceTypedNotes: 'Typed notes',
  surveyOtherNotabilityFeaturesQuestionTitle: 'Which feature of Notability interests you the most?',
  surveyOtherPlanToUseQuestionInputLabel: 'Type your answer below',
  surveyOtherPlanToUseQuestionInputPlaceholder: 'How do you plan on using Notability?',
  surveyOtherPlanToUseQuestionTitle: 'Could you briefly describe how you plan to use Notability?',
  surveyPersonalActivityChoiceCreativeWriting: 'Creative writing',
  surveyPersonalActivityChoiceHobbyDocumentation: 'Hobby documentation',
  surveyPersonalActivityChoiceJournaling: 'Journaling',
  surveyPersonalActivityChoiceToDoLists: 'To-do lists',
  surveyPersonalActivityChoiceTravelPlanning: 'Travel planning',
  surveyPersonalActivityQuestionTitle: 'What personal activities do you plan to use Notability for?',
  surveyPersonalAudioUseChoiceNo: 'No, I don’t plan to use it',
  surveyPersonalAudioUseQuestionTitle: 'Do you plan to use Notability’s audio recording feature for personal use?',
  surveyPersonalSyncingChoiceNotImportant: 'Not important',
  surveyPersonalSyncingChoiceSomewhatImportant: 'Somewhat important',
  surveyPersonalSyncingChoiceVeryImportant: 'Very important',
  surveyPersonalSyncingQuestionTitle: 'How important is syncing across devices for your personal use?',
  surveySelectPlaceholder: 'Please select an option...',
  surveySelectTheMostRelevantOption: 'Select the most relevant option.',
  surveyStartNotabilityButton: 'Start Notability',
  surveyStepProgress: 'Survey step progress',
  surveyStudentEducationStageChoiceContinuingEducation: 'Continuing education',
  surveyStudentEducationStageChoiceContinuingVocational: 'Vocational',
  surveyStudentEducationStageChoiceK12: 'K-12',
  surveyStudentEducationStageChoicePostGraduate: 'Post-graduate',
  surveyStudentEducationStageChoiceUndergraduate: 'Undergraduate',
  surveyStudentEducationStageQuestionTitle: 'What stage of your education are you in?',
  surveyStudentEducationStageQuestionTitleUpdated: 'What stage of education are you currently in?',
  surveyStudentLearningStyleChoiceAuditory: 'Auditory',
  surveyStudentLearningStyleChoiceKinesthetic: 'Kinesthetic',
  surveyStudentLearningStyleChoiceLogical: 'Logical',
  surveyStudentLearningStyleChoiceMultiModal: 'Multi-modal',
  surveyStudentLearningStyleChoiceNotSure: 'Not sure',
  surveyStudentLearningStyleChoiceReading: 'Reading',
  surveyStudentLearningStyleChoiceSocial: 'Social',
  surveyStudentLearningStyleChoiceVisual: 'Visual',
  surveyStudentLearningStyleQuestionTitle: 'How would you describe your learning style?',
  surveyStudentLearningStyleTooltipAuditory: 'Lectures, podcasts, discussions.',
  surveyStudentLearningStyleTooltipKinesthetic: 'Hands on approach',
  surveyStudentLearningStyleTooltipLogical: 'Problem solving and patterns',
  surveyStudentLearningStyleTooltipMultiModal: 'Combination of methods',
  surveyStudentLearningStyleTooltipReading: 'Books, articles, detailed notes',
  surveyStudentLearningStyleTooltipSocial: 'Group discussions, collaboration',
  surveyStudentLearningStyleTooltipVisual: 'Diagrams, images, videos',
  surveyStudentStudyTopicChoiceBiology: 'Biology',
  surveyStudentStudyTopicChoiceBusiness: 'Business',
  surveyStudentStudyTopicChoiceChemistry: 'Chemistry',
  surveyStudentStudyTopicChoiceComputerScience: 'Computer science',
  surveyStudentStudyTopicChoiceEarthScience: 'Earth science',
  surveyStudentStudyTopicChoiceEconomicsAndFinance: 'Economics and finance',
  surveyStudentStudyTopicChoiceEngineeringAndTechnology: 'Engineering and technology',
  surveyStudentStudyTopicChoiceKinesiology: 'Kinesiology',
  surveyStudentStudyTopicChoiceLanguagesAndLiterature: 'Languages and literature',
  surveyStudentStudyTopicChoiceLaw: 'Law',
  surveyStudentStudyTopicChoiceMathematics: 'Mathematics',
  surveyStudentStudyTopicChoiceMedicineAndHealth: 'Medicine and health',
  surveyStudentStudyTopicChoicePerformingArts: 'Performing arts',
  surveyStudentStudyTopicChoicePharmacy: 'Pharmacy',
  surveyStudentStudyTopicChoicePhilosophy: 'Philosophy',
  surveyStudentStudyTopicChoicePhysics: 'Physics',
  surveyStudentStudyTopicChoicePolitcalScience: 'Politcal science',
  surveyStudentStudyTopicChoicePoliticalScience: 'Political science',
  surveyStudentStudyTopicChoicePsychology: 'Psychology',
  surveyStudentStudyTopicChoiceSocialWork: 'Social work',
  surveyStudentStudyTopicChoiceSociology: 'Sociology',
  surveyStudentStudyTopicChoiceSpaceScience: 'Space science',
  surveyStudentStudyTopicChoiceTechnology: 'Technology',
  surveyStudentStudyTopicChoiceVisualArts: 'Visual arts',
  surveyStudentStudyTopicQuestionTitle: 'What are you studying?',
  surveyTeacheGradeLevelChoiceElementary: 'Elementary',
  surveyTeacheGradeLevelChoiceHigherEducation: 'Higher education',
  surveyTeacheGradeLevelChoiceHighSchool: 'High school',
  surveyTeacheGradeLevelChoiceMiddleSchool: 'Middle school',
  surveyTeacheGradeLevelChoiceProfessionalTraining: 'Professional training',
  surveyTeacheGradeLevelQuestionTitle: 'What level do you teach?',
  surveyTeacheNotabilityFeaturesQuestionSubtitle: 'Select any that apply.',
  surveyTeacheNotabilityFeaturesQuestionTitle: 'Which features of Notability are most important for your teaching?',
  surveyTeacherNotabilityFeatureChoiceAudioRecording: 'Audio recording',
  surveyTeacherNotabilityFeatureChoiceHandwritingRecognition: 'Handwriting recognition',
  surveyTeacherNotabilityFeatureChoiceOrganizationTools: 'Organization tools',
  surveyTeacherNotabilityFeatureChoicePdfAnnotation: 'PDF annotation',
  surveyTeacherNotabilityFeatureChoiceSharingCapabilities: 'Sharing capabilities',
  surveyTeacherNotabilityIntegrationChoiceGradingAndFeedback: 'Grading and feedback',
  surveyTeacherNotabilityIntegrationChoiceInClassDemonstrations: 'In-class demonstrations',
  surveyTeacherNotabilityIntegrationChoiceLessonPlanning: 'Lesson planning',
  surveyTeacherNotabilityIntegrationChoiceStudentAssignments: 'Student assignments',
  surveyTeacherNotabilityIntegrationQuestionTitle: 'How do you plan to integrate Notability into your teaching?',
  surveyUserDescriptionChoiceNotSureYet: 'Not sure yet',
  surveyUserDescriptionChoicePersonal: 'Personal',
  surveyUserDescriptionChoiceStudent: 'Student',
  surveyUserDescriptionChoiceTeacher: 'Teacher',
  surveyUserDescriptionChoiceTeacherEducator: 'Educator',
  surveyUserDescriptionChoiceWorkingProfessional: 'Working professional',
  surveyUserDescriptionChoiceWorkingProfessionalUpdated: 'Professional',
  surveyWelcomeTitle: 'Welcome to Notability!',
  surveyWorkingProfessionalCollaborationChoiceIndividually: 'No, I’ll use it individually',
  surveyWorkingProfessionalCollaborationQuestionTitle: 'Will you be collaborating with team members using Notability?',
  surveyWorkingProfessionalNotabilityUseChoiceBrainstorming: 'Brainstorming',
  surveyWorkingProfessionalNotabilityUseChoiceClientPresentations: 'Client presentations',
  surveyWorkingProfessionalNotabilityUseChoiceMeetingNotes: 'Meeting notes',
  surveyWorkingProfessionalNotabilityUseChoicePersonalTaskManagement: 'Personal task management',
  surveyWorkingProfessionalNotabilityUseChoiceProjectPlanning: 'Project planning',
  surveyWorkingProfessionalNotabilityUsesQuestionSubtitle: 'Select any that apply',
  surveyWorkingProfessionalNotabilityUsesQuestionTitle: 'How do you plan to use Notability in your work?',
  surveyWorkingProfessionalPrimaryIndustryChoiceEducation: 'Education',
  surveyWorkingProfessionalPrimaryIndustryChoiceFinance: 'Finance',
  surveyWorkingProfessionalPrimaryIndustryChoiceHealthcare: 'Healthcare',
  surveyWorkingProfessionalPrimaryIndustryChoiceManufacturing: 'Manufacturing',
  surveyWorkingProfessionalPrimaryIndustryChoiceRetail: 'Retail',
  surveyWorkingProfessionalPrimaryIndustryChoiceTechnology: 'Technology',
  surveyWorkingProfessionalPrimaryIndustryQuestionTitle: 'What is your primary industry?',
  surveyYesFrequently: 'Yes, frequently',
  surveyYesOccasionally: 'Yes, occasionally',
  switchToPagedLayoutDescription:
    'Paged content adheres to the boundaries and margins of pages. Existing content outside these boundaries will be hidden but will still be available if you return to a pageless layout.',
  switchToPagedLayoutTitle: 'Switch to paged layout?',
  switchToPageless: 'Switch to pageless',
  switchToPagelessLayoutDescription:
    'Pageless content has no page boundaries and can flow in any direction. Changing layouts may slightly alter your content but will not result in a loss of information.',
  switchToPagelessLayoutTitle: 'Switch to pageless layout?',
  syllabusAddClassLabel: 'Add class',
  syllabusAddCourseButton: 'Add course',
  syllabusAddCoursesToGoogleAdd: 'Add',
  syllabusAddCoursesToGoogleNotNow: 'Not now',
  syllabusAddCoursesToGooglePrompt_one: 'Add your imported course to Google Calendar?',
  syllabusAddCoursesToGooglePrompt_other: 'Add your {{count}} imported courses to Google Calendar?',
  syllabusAddDateLabel: 'Add important date',
  syllabusAnalyzingBody: 'Extracting key dates and assignments',
  syllabusAnalyzingTitle: 'Analyzing your syllabus…',
  syllabusCalendarDatesNotAdded_one: "{{count}} date couldn't be added to your calendar",
  syllabusCalendarDatesNotAdded_other: "{{count}} dates couldn't be added to your calendar",
  syllabusCalendarWriteLandingBody: 'Google will ask you to allow this on the next screen.',
  syllabusCalendarWriteLandingBodyAccount: 'Google will ask you to allow this for {{email}}.',
  syllabusCalendarWriteLandingTitle: 'Add your class dates to Google Calendar',
  syllabusClassesAllPast: 'These classes have already ended',
  syllabusClassesSectionTitle: 'Classes',
  syllabusClassNameLabel: 'Class name',
  syllabusClassNamePlaceholder: 'Enter class name',
  syllabusCourseDetailsSectionTitle: 'Course details',
  syllabusCourseNameLabel: 'Course name',
  syllabusCoursesNotAddedToGoogle_one: "{{course}} wasn't added to Google Calendar",
  syllabusCoursesNotAddedToGoogle_other: "{{count}} courses weren't added to Google Calendar",
  syllabusCoursesNotAddedTryAgain: 'Try again',
  syllabusDatesAllPast: 'All dates in this syllabus have passed',
  syllabusEditClassLabel: 'Edit class',
  syllabusEditDateLabel: 'Edit important date',
  syllabusEndTimeBeforeStart: 'End time must be after the start time.',
  syllabusEndTimeLabel: 'End time',
  syllabusEventNamePlaceholder: 'Enter event name',
  syllabusFallbackCourseName: 'New course',
  syllabusFormSaveHint: 'Fill in the required fields to save.',
  syllabusImportantDatesSectionTitle: 'Important dates',
  syllabusImportAnywayButton: 'Import document anyway',
  syllabusInvalidPdfBody: "This file didn't open as a PDF. Try exporting it again, or pick a different file.",
  syllabusInvalidPdfTitle: "We couldn't read this file",
  syllabusModalTitle: 'Syllabus',
  syllabusNetworkBlockedBody:
    'Your network may be blocking this import. Try again on a different Wi-Fi or cellular network.',
  syllabusNoClassesFound: 'No classes found',
  syllabusNotASyllabusBody:
    'Try a document that lays out the schedule, such as class times, exams, and due dates. A syllabus, course outline, or term calendar all work.',
  syllabusNotASyllabusTitle: "This doesn't look like a syllabus",
  syllabusNotAvailableBody: "Syllabus import isn't available on this account right now.",
  syllabusNotAvailableTitle: 'Not available',
  syllabusNoUpcomingDates: 'No upcoming dates found in this syllabus',
  syllabusPdfTooLargeBody: 'Syllabuses up to {{limit}} can be read. Try a smaller file.',
  syllabusPdfTooLargeTitle: 'File too large',
  syllabusPreviewUnavailable: "Preview isn't available for this file.",
  syllabusRateLimitedBody: "You've reached your hourly limit for syllabus imports.",
  syllabusRateLimitedRetryAt: 'Try again after {{time}}.',
  syllabusRateLimitedTitle: 'Hourly limit reached',
  syllabusReportProblemButton: 'Report a problem',
  syllabusReviewBanner:
    'Review the class details and deadlines. Class schedule and important dates are added to your calendar.',
  syllabusReviewBannerAllPast:
    "The classes and dates in this syllabus have already passed, so they won't be added to your calendar.",
  syllabusReviewBannerNoDates: 'Review the course name below.',
  syllabusScheduleLabel: 'Schedule',
  syllabusServerBusyBody: 'Lots of syllabuses are being read right now. Try again in a moment.',
  syllabusServerBusyTitle: 'Servers are busy',
  syllabusSomethingWentWrongBody: 'Something went wrong. Please try again.',
  syllabusStartTimeLabel: 'Start time',
  syllabusUploadButton: 'Upload syllabus',
  tabBrowse: 'Browse',
  tableOfContents: 'Table of contents',
  tagNotAllowedError: 'The tag "{{tag}}" is not allowed',
  tagRemaining: '{{tags}} tag remaining',
  'Tags (optional)': 'Tags (optional)',
  tagsRemaining: '{{tags}} tags remaining',
  takeAComprehensiveAssessment: 'Take a comprehensive assessment',
  takeNotes: 'Take notes',
  takeNotesDescription: 'Just start typing',
  takingSmartNotes: 'Taking Smart Notes...',
  Tape: 'Tape',
  teachers: 'teachers.',
  tellUsAboutYourBusiness: 'Tell us about your organization - you can change these later in Settings.',
  tellUsAboutYourOrganization: 'Tell us about your organization',
  tellUsALittleBit: 'Tell us a little bit about your issue.',
  templateAppliedToast: '{{templateName}} template applied',
  Templates: 'Templates',
  templatesMenuItem: 'Templates',
  templateTooltip: "Templates have a repeating format, so you don't have to recreate any work on each page.",
  termsOfUse: 'Terms of Use',
  test: 'Test',
  testAnswered: '<bold>{{count}}</bold> of <bold>{{total}}</bold> answered',
  testCorrect: '<bold>{{count}}</bold> of <bold>{{total}}</bold> correct',
  testIntroDescription_one:
    '<bold>{{count}} question.</bold> Aim for about 15 minutes for this test. Your score will only be shown at the end of the test.',
  testIntroDescription_other:
    '<bold>{{count}} questions.</bold> Aim for about 15 minutes for this test. Your score will only be shown at the end of the test.',
  testIntroSubtitle: 'Test for:',
  testResultKeepLearning: 'Keep learning to reach mastery of this note.',
  testResultMasteredAll: "You've mastered this note.",
  testResultRetakePromptCompleteV2: 'Take a new test to continue testing your knowledge.',
  testResultRetakePromptV2: 'Take a new test to try and reach your ideal score.',
  testWhatYouveLearned: "Test what you've learned",
  testYourKnowledge: 'Test your knowledge',
  testYourKnowledgeDescription: 'Turn any note into flashcards and quizzes in seconds.',
  testYourself: 'Test yourself',
  Text: 'Text',
  textBox: 'Text Box',
  textColor: 'Text',
  textContainsProfanity: 'Your submission contains words that are not permitted.',
  textLinkPlaceholder: 'Type or paste URL',
  textOnlyView: 'Text only',
  textOnlyViewNotice: 'Drawings and attachments are hidden in Text only',
  'The password reset link has expired, or has already been used.':
    'The password reset link has expired, or has already been used.',
  theFollowingContentCouldNotBeProcessed: 'The following content could not be processed:',
  theFollowingUsersInvitationEmailsFailed: "These users were added, but we couldn't send their invitation email:",
  theFollowingUsersInvitationEmailsFailedDetail: 'Use Resend invite in the Users table to try again.',
  theFollowingUsersWereAdded: 'The following users were added:',
  theFollowingUsersWereInvited: 'The following users were invited to {{organizationName}}:',
  themeSetting: 'Color Scheme',
  'There was an error creating your account': 'There was an error creating your account',
  thinkingAboutYourNotes: 'Thinking about your notes...',
  'This version of Notability is out of date. Please install the latest version to create an account.':
    'This version of Notability is out of date. Please install the latest version to create an account.',
  thisActionCannotBeUndone: 'This action cannot be undone',
  thisActionWillRemoveUserEmailFromOrganization:
    'This action will remove <name>{{email}}</name> from {{organizationName}}. Any active invites will be revoked.',
  thisActionWillRemoveUserNameEmailFromOrganization:
    'This action will remove <name>{{name}}</name> ({{email}}) from {{organizationName}}. Any active invites will be revoked.',
  thisFieldIsRequired: 'This field is required.',
  thisMessageWillBeSent:
    'This message will be sent with diagnostic information that will help us troubleshoot your issue. By selecting Send to Support, you consent to sharing the information provided here and this diagnostic information with Ginger Labs and agree to our <termsConditions>Terms and Conditions</termsConditions> and <privacyPolicy>Privacy Policy</privacyPolicy>.',
  thisQuizWasLastUpdatedAt: '<0>This quiz was last updated </0><1>{{lastUpdatedDate}}.</1>',
  thisSubjectAndNotesWillBeDeleted_one: 'This subject and the note it contains will be deleted.',
  thisSubjectAndNotesWillBeDeleted_other: 'This subject and the {{count}} notes it contains will be deleted.',
  threadsFooterAlt: 'Notability Threads Link',
  thumbnailImageDescription: 'Preview of note "{{title}}"',
  thumbnailImageDescriptionNoTitle: 'Preview of note with unknown title',
  tikTokFooterAlt: 'Notability TikTok link',
  tikTokHandleLengthError: 'TikTok username must be between {{minLength}} and {{maxLength}} characters long.',
  tikTokServiceName: 'TikTok',
  tikTokUsername: 'TikTok',
  timeframeDaysAgo: '{{numDays}} days ago',
  timeframeHoursAgo: '{{numHours}} hours ago',
  timeframeMinutesAgo: '{{numMinutes}} minutes ago',
  timeframeMonthsAgo: '{{numMonths}} months ago',
  timeframeOneHourAgo: '1 hour ago',
  timeframeOneMinuteAgo: '1 minute ago',
  timeframeOneMonthAgo: '1 month ago',
  timeframeOneWeekAgo: '1 week ago',
  timeframeOneYearAgo: '1 year ago',
  timeframeSecondsAgo: 'seconds ago',
  timeframeToday: 'today',
  timeframeWeeksAgo: '{{numWeeks}} weeks ago',
  timeframeYearsAgo: '{{numYears}} years ago',
  timeframeYesterday: 'yesterday',
  timeGoal: 'Time',
  Title: 'Title',
  title1: 'Title 1',
  title2: 'Title 2',
  title3: 'Title 3',
  toChangeToAnIndividualPlan:
    'To change to an individual plan, you must remove all other users and shared libraries from your organization.',
  tooManyAttemptsError: 'Too many attempts. Please wait a moment and try again.',
  tooManySeats: 'Attempted to create license with too many seats: {{seatCount}}',
  tooManyTags: 'A note cannot have more than {{tagCount}} tags.',
  tooMuchContentSelected: 'Too much content selected',
  Topic: 'Topic',
  Topics: 'Topics',
  topToolbarTitle: 'Top toolbar note title input',
  totalActiveUsers: 'Total active users',
  transciptionInProgress: 'Transcribing audio...',
  transciptionInProgressSubtitle: 'Check back once the transcription is complete.',
  transcript: 'Transcript',
  transcription: 'Transcription',
  transcriptionFailed: 'Transcription failed',
  transcriptionUnavailableAiUsageLimit: 'Transcription isn’t available because you’ve reached your AI usage limit.',
  transcripts: 'Transcripts',
  transcriptSearchPlaceholder: 'Search transcripts',
  transformYourNotes:
    'Transform your notes into interactive study sessions with real-time Smart Notes, live transcripts, powerful quizzes and flashcards.',
  trendingContent: 'Trending',
  triage: 'Triage',
  triageApprove: 'Approve',
  triageAuthor: 'Author',
  triageBack: 'Back',
  triageClearFlag: 'Clear Flag',
  triageExitFullscreen: 'Exit',
  triageFlagReason: 'Flagged Reason(s)',
  triageInstructions: 'Select a note to begin the triage process.',
  triageLoadingMore: 'Loading more notes...',
  triageNext: 'View Note',
  triageNoNotes: 'All notes have been triaged.  Please check back later.',
  triageQuarantine: 'Quarantine',
  triageQuarantineReason: 'Quarantine Reason',
  triageQuarantineReasonPlaceholder: 'Describe your reason for quarantining this note...',
  triageQuarantineTitle: 'Why quarantine this note?',
  triageReject: 'Reject',
  triageReviewer: 'Triaged by Admin',
  triageStateFlagged: 'Flagged',
  triageStateNoLanguage: 'No Language',
  triageStatusAwaiting: 'Awaiting Triage',
  triageStatusQuarantined: 'Quarantined',
  triageStatusRecentlyTriaged: 'Recently Triaged',
  triageTitle: 'Note Triage',
  trialEndedHeader: 'Your Notability trial has ended',
  trialEndedMessage:
    'You no longer have access to the exclusive features included with Notability Plus. Upgrade at any time time to regain access to audio transcripts, note summaries and quizzes!',
  trialEndsMessage:
    'Today is the last day to use Plus features for free. To ensure you don’t lose access to these powerful features or any of the transcripts, summaries and quizzes you’ve already made, be sure to upgrade to Notability Plus today!',
  trialEndsToday: 'Your Notability trial ends today!',
  trialEndsTodayEmailHeader: 'Your free trial ends today!',
  trialHalfwayHeader: 'Your trial is halfway over',
  trialHalfwayLearnHeader: 'Learn smarter, increase retention',
  trialHalfwayLearnMessage:
    'If you haven’t already, be sure to try out audio transcripts, note summaries and quizzes. These incredible features make capturing, studying and learning any topic easier than ever.',
  trialHalfwayMessage:
    'You have %s days left in your Notability Plus trial. Upgrade to Plus before your trial ends to ensure you don’t lose access to premium features.',
  trialHalfwayOver: 'Your Notability trial is halfway over!',
  trialHalfwayPreheader: 'Make the most of your trial by putting our premium features to the test.',
  trialHasEnded: 'Trial has ended',
  true: 'True',
  trueOrFalse: 'True or False',
  trueOrFalsePressKeysInstruction: 'Press <box>1</box> or <box>2</box> keys to select False or True',
  'Try again': 'Try again',
  tryForFree: 'Try for free',
  tryNotabilityForFree: 'Try Notability for free',
  tryNotabilityToday: 'Try Notability today',
  tryNow: 'Try now',
  tryWebApp: 'Try web app',
  tweakPopularSort: 'tweak popular sort',
  twitterFooterAlt: 'Notability Twitter link',
  twitterHandleLengthError: 'Twitter username must be between {{minLength}} and {{maxLength}} characters long.',
  twitterServiceName: 'Twitter',
  twitterUsername: 'Twitter',
  typeYourAnswerHere: 'Type your answer here',
  unauthorizedProfileUpdateError: 'Must be logged in to update profile',
  underageUser: 'Underage User',
  underline: 'Underline',
  undo: 'Undo',
  unfavorite: 'Unfavorite',
  unfiled: 'Unfiled',
  unfiledNotes: 'Unfiled notes',
  unfollow: 'Unfollow',
  ungroupEntitesAction: 'Ungroup',
  'Unknown Error': 'Unknown Error',
  unknownServerError: 'Unknown Server Error',
  unlock: 'Unlock',
  unlockButton: 'Unlock',
  unlockRealTimeCollaborationDescription:
    'Unlock real time collaboration with Shared Libraries, admin controls, and more.',
  unpublishConfirm: 'Unpublish',
  unpublishGalleryNoteNotFoundError: 'Published note not found on server',
  unpublishHeader: 'Are you sure you want to unpublish this note?',
  unpublishText1: 'Unpublishing removes this note from the Notability Gallery.',
  unpublishText2: 'You can publish it again at any time.',
  unsubscribeEmailGroup: 'Unsubscribe',
  unsubscribeEmailGroupManagePreferences: 'Manage Email Preferences',
  untitledFolder: 'Untitled Folder',
  untitledNote: 'Untitled Note',
  unverifiedBannerError: '❌ An error occurred while trying to resend.',
  unverifiedBannerInitial: '⚠️ For full access, please verify your email or <1>click here to send the link again.</1>',
  unverifiedBannerSending: 'Sending...',
  unverifiedBannerSent: '📥 Email sent! Please check your inbox and spam folder.',
  unverifiedEmailGenericError: 'You must verify your email address before performing this action.',
  unverifiedEmailNoteLikeError: 'You must verify your email address before liking a note',
  unverifiedEmailNoteReportError: 'You must verify your email address before reporting a note',
  updateClientError: 'This version of Notability is outdated and needs to be updated.',
  updateNameError: 'We cannot update your name. Please try again or contact Support',
  updatePaymentMethod: 'Update payment method',
  updateProfileAuthError: 'Must be logged in to update profile',
  updateUserBusinessRoleError: "There was an error updating this user's role. Please try again or contact Support",
  updateYourBillingInformation: '<Link>Update your billing information</Link> to continue using {{tierName}}.',
  updateYourBillingInformationOrContact:
    'Update your billing information or contact sales@notability.com to continue using {{tierName}}.',
  upgrade: 'Upgrade',
  upgradeActionButton: 'Upgrade to Plus',
  upgradeForFullAccess: 'Upgrade for full access',
  upgradeToAccessProFeatures: 'Upgrade to access Pro features.',
  upgradeToBusinessPro: 'Upgrade to Business Pro',
  upgradeToGetAccess: 'Upgrade to get access to:',
  upgradeToGetUnlimitedAccess: 'Upgrade to get unlimited access to:',
  upgradeToKeepAccess: 'Upgrade to keep access to:',
  upgradeToNotabilityPro: 'Upgrade to Notability Pro',
  upgradeToPlan: 'Upgrade to {{plan}}',
  upgradeToPlus: 'Upgrade to Plus',
  upgradeToPlusToUnlock: 'Upgrade to Notability Plus to unlock:',
  upgradeToPro: 'Upgrade to Pro',
  upgradeToProToUnlock: 'Upgrade to Notability Pro to unlock:',
  upgradeYourNotesWithNotability: 'Upgrade your notes with Notability',
  Upload: 'Upload',
  uploadActiveDescription: 'Please do not close your browser tab.',
  uploadActiveTitle: 'Uploading...',
  uploadCompleteTitle: 'Upload Complete',
  uploadCsv: 'Upload CSV',
  uploadError: 'Error Uploading Content',
  uploadOfficeDocument: 'Upload DOC, PPT',
  upsellCaptureDescription: "Record your lectures and we'll transcribe them for you!",
  upsellCaptureHeader: 'Capture',
  upsellReviewDescription: 'Get a detailed overview of entire lectures via summaries.',
  upsellReviewHeader: 'Review',
  upsellStudyDescription: 'Ace that exam with flashcards and quizzes.',
  upsellStudyHeader: 'Study',
  URL: 'URL',
  useDeviceSettings: 'Use Device Settings',
  useNotabilityCoreFeatures: "Use Notability's core note-taking features.",
  'User email is not verified': 'User email is not verified',
  'User not found': 'User not found',
  userAlreadyHasPermission: 'User already has this permission',
  userAlreadyInBusinessError: 'User already belongs to a business',
  userAlreadyLoggedInError: 'This user is already logged in',
  userCanceledConsumerSubscriptionEmail_bodyCopy: 'Thanks again for using Notability.',
  userCanceledConsumerSubscriptionEmail_ctaButton: 'Take the survey',
  userCanceledConsumerSubscriptionEmail_ctaLink: 'https://form.typeform.com/to/tM0CfUSQ',
  userCanceledConsumerSubscriptionEmail_heroBody:
    'Would you mind taking 30 seconds to tell us why? Your input helps us understand how we can improve and what features to build in the future.',
  userCanceledConsumerSubscriptionEmail_heroHeading: "We're sorry to see you go",
  userCanceledConsumerSubscriptionEmail_heroSubheading:
    "Hi there, we noticed that you recently canceled your Notability subscription, and we'd really appreciate your feedback.",
  userCanceledConsumerSubscriptionEmail_subject: "We're Sorry to See You Go",
  userCanceledConsumerSubscriptionEmail_teamName: '— The Notability Team',
  userCount: 'User count',
  userDoesNotHaveStripeSubscription: 'This user does not have a stripe subscription',
  userDoesNotHaveTrial: 'This user does not have a trial',
  userExampleJoshBio: 'Student, founder of EduCare',
  userExampleJoshCaption: "Josh's Notes",
  userExampleJoshName: 'Joshua Kim',
  userExampleJoshOrg: 'University of Pennsylvania',
  userExampleJoshQuote:
    'I use Notability for my classes every day. I  record lectures using Note Replay and annotate textbook PDFs. I’ve never seen a program load such large PDFs so quickly.\nI also founded an organization called EduCare that brings medical info to disadvantaged communities. My team works remotely, so we use Notability to mark up each other’s documents during meetings.',
  userExampleLisaBio: '11th Grade Teacher',
  userExampleLisaCaption: "Lisa's Notes",
  userExampleLisaName: 'Lisa Queeno',
  userExampleLisaOrg: 'Springside Chestnut Hill Academy',
  userExampleLisaQuote:
    'I draw diagrams for study guides and create test questions using Notability. I love being able to mix my own drawings with other imported images.\nWhiteboards aren’t easy to read, especially for students with learning disabilities. Rather than sending out a blurry picture of a whiteboard, I can present my Notability notes in class and send out the same PDF to my kids later. ',
  userExampleMayaBio: 'Proud  mom of two kiddos',
  userExampleMayaCaption: "Maya's Notes",
  userExampleMayaName: 'Maya Muranaka',
  userExampleMayaOrg: 'Designer here at Notability!',
  userExampleMayaQuote:
    'I have two girls. We create drawings together using Notability, and I love that there’s no mess to clean up after. With iCloud sync, I know I can look back on the art later.\nThe interface is so intuitive that my kids don’t need my help to figure out how to use the tools! ',
  userExampleRobBio: 'Storyboard artist',
  userExampleRobCaption: "Rob's Notes",
  userExampleRobName: 'Rob McCallum',
  userExampleRobOrg: 'CBS, Disney, and more!',
  userExampleRobQuote:
    "I use Notability for drawing rough storyboards that I share with directors and for concept art. The ink feels real and smooth. This is the perfect program for quick idea scribbles you want to get down before they're gone.",
  userExampleStudentCaption: 'Public health concept maps note',
  userExampleTeacherCaption: 'Basic Circulatory note',
  userExampleVinceBio: 'Music composer & conductor',
  userExampleVinceCaption: "Vince's Notes",
  userExampleVinceName: 'Vince Gassi',
  userExampleVinceOrg: 'Toronto, CA',
  userExampleVinceQuote:
    'We had almost 132 auditions. I have to decide the best voice for the role. Note Replay allows me to record every audition and take notes. When I tap on any person’s name in my notes later, I can listen to that specific audition. I save hours not having to sort through audition audio.\nI even use Notability to capture quick composition ideas!',
  Username: 'Username',
  'Username already in use': 'Username already in use: %s',
  'Username contains invalid characters': 'Username contains invalid characters: {{invalidCharacters}}',
  'Username must be at least n characters': 'Username must be at least {{minLength}} characters',
  usernameAlreadyInUseError: 'Username already in use: {{username}}',
  usernamePlaceholder: 'notablenoter123',
  usernameRequirements:
    'Usernames can only contain lowercase letters, numbers, and the characters - and _. They cannot be changed once created.',
  usernameUsageHint: 'This will appear on your profile and beneath your published posts.',
  usernameWillLoseAccessToNote: '{{username}} will lose access to "{{noteTitle}}" unless it is shared with them again.',
  userNotAdminError: 'You must be an admin to perform the requested action.',
  userNoteInNFT: 'This family tree has your note in it.',
  userNotFoundError: 'User not found',
  userNotFoundInBusinessError: 'User is not a part of this business',
  userNotFoundInOrgError: 'User is not a part of this organization',
  userNotSubscribedError: 'This functionality is limited to subscribers.',
  userProfileAdminAlreadyCreatedError: 'Profile with screenname of {{screenname}} already exists.',
  userProfileAdminDoesNotExistError: 'Profile with screenname of {{screenname}} does not yet exist!',
  userProfileAlreadyCreatedError: 'You cannot change your profile once you have made it!',
  userProfileAlreadyDoesNotExistError: 'Your user profile does not exist yet. Please create a username first.',
  userProfileDoesNotExistError: 'User does not have an associated profile',
  userReactivatedBanner: 'User reactivated',
  users: 'Users',
  userSettings: 'Settings',
  userWillBePermanentlyDeletedOn: 'User will be permanently deleted on <deleteDate>{{deleteDate}}</deleteDate>',
  userWithEmailNotFoundError: 'User with email address {{email}} not found',
  validate: 'Validate',
  validating: 'Validating...',
  validReasonNotSpecifiedError: 'You must specify a valid reason to flag a note',
  verifyEmailActionButton: 'Verify Email',
  verifyEmailMessage:
    'Hi %s, <br /><br /> Welcome to Notability’s note sharing platform! <br /><br /> Please confirm that you want to use this email address by clicking the link below. <br /><br /> If you have questions or need help, check out the <a href="https://support.gingerlabs.com">Notability support site</a> for articles about note sharing.',
  verifyEmailSubject: 'Verify your email address',
  versionHistory: 'Version history',
  versionHistoryCurrentVersion: 'Current version',
  versionHistoryEmptyBody: 'We store versions for up to 90 days. New versions will appear as you edit.',
  versionHistoryEmptyTitle: 'No available versions',
  versionHistoryError: "Couldn't load version history.",
  versionHistoryRecordingInProgressBody:
    'Version history cannot be viewed while recording. Continuing will end and save the recording before proceeding.',
  versionHistoryRestoreAsCopy: 'Restore as copy',
  versionHistoryRestoredBanner: 'Restored from {{timestamp}}',
  versionHistoryRestoredBannerOpenOriginal: 'Open original',
  versionHistoryRestoredNoteTitle: '{{noteTitle}} (Restored from {{date, datetime}} • {{time, datetime}})',
  versionHistoryStorageLimitNote: "Versions older than 90 days aren't stored.",
  versionHistoryUpsellBodyBusinessPro: 'Upgrade to Business Pro to access 90 days of version history.',
  versionHistoryUpsellBodyPro: 'Upgrade to Pro to access up to 90 days of version history.',
  versionHistoryUpsellTitle: '{{days}} days of version history',
  viaSharedLibrary: 'Via shared library',
  videoBannerSubtitle: 'See more stories on our <1>YouTube channel</1>',
  videoBannerTitle: "Get inspired by other students' stories.",
  viewAll: 'View All',
  viewer: 'Viewer',
  viewingHistoricalVersion: 'Viewing {{timestamp}}',
  viewMenuOption: 'View ({{option}})',
  viewOnly: 'View only',
  viewRemixes: 'View Remixes',
  viewSettings: 'View settings',
  viewTemplate: 'View Template',
  viewTopics: 'View topics',
  viewVersionHistory: 'View version history',
  'We believe in recycling. Check out notes below to download and repurpose!':
    'We believe in recycling. Check out notes below to download and repurpose!',
  web: 'Web',
  webCtaAppStoreAlt: 'Download on the App Store',
  webCtaHeadline: 'Get Notability for free',
  webCtaSubtext: 'Discover new ways to learn.',
  webFeature1Description:
    'Like paper, but better. Take notes, annotate, record & transcribe audio. All the powerful tools you need, in one, simple interface.',
  webFeature1Headline: 'Capture any idea without bounds.',
  webFeature2Description:
    'One tap transforms your notes, PDFs, and recordings into custom, AI-powered review materials. Instant flashcards, quizzes, summaries and more',
  webFeature2Headline: 'Smarter notes. Quicker learning.',
  webFeature3Description:
    "Just hit record. We'll transcribe everything that was said so you can review it later. We'll capture the details, so you can focus on what matters.",
  webFeature3Headline: "We'll take notes for you.",
  webFeatureHighlighterBody: 'See your highlights snap magically to your text, allowing for easy annotations.',
  webFeatureHighlighterHeader: 'Annotate effortlessly',
  webFeatureImportBody: 'Drag and drop images and PDFs to create depth and color to your notes.',
  webFeatureImportHeader: 'Create visually rich notes',
  webFeatureRecordingBody: 'Simply hit record, and we’ll do rest of the work.',
  webFeatureRecordingHeader: 'Never miss a beat',
  webFeedbackHeader: 'Send us your feedback',
  webFeedbackMessage:
    'Your feedback is invaluable in helping shape the future of Notability on web. Let us know what you like, don’t like, wish you could do or any other thoughts you’d like to share about the Notability web beta.',
  webFinalCTAHeader: 'Experience Notability on web today',
  webHeroHeadline: 'Success starts when you do.',
  webHeroSubtext: 'Take notes your way. Get personalized, AI-powered summaries, quizzes, flashcards, and more.',
  webMarketingFeatureQuizzesDescription: 'One tap turns your notes into personalized quizzes to test what you know.',
  webMarketingFeatureQuizzesTitle: 'Quizzes from your notes',
  webMarketingFeatureSmartNotesDescription: 'Hit record and Smart Notes will take notes and summarize in real time.',
  webMarketingFeatureSmartNotesTitle: "We'll take notes for you",
  webMarketingFeatureYouTubeDescription:
    'Paste a YouTube link into a note and instantly get transcripts, summaries and quizzes.',
  webMarketingFeatureYouTubeTitle: 'Turn YouTube into notes',
  webMarketingHero: 'Learn anything, the <Highlight>smart</Highlight> way.',
  webMarketingHeroBody: 'Transform recordings, imported PDFs and notes into digestible summaries and study materials.',
  webNewUserEmailMessage:
    'Thanks for trying out the Notability Web Beta! We’re excited to hear your feedback as you try out the new web application.',
  webNewUserEmailSubject: 'Welcome to Notability!',
  webNewUserGetStartedPreheader: 'Get started with your free %s-day trial!',
  webNewUserPremiumHeader: 'Enjoy premium features, free for %s days',
  webNewUserPremiumMessage:
    'Try out audio transcription, note summaries and intelligent quizzes that are all automatically created from the content you add to your notes, just tap “Learn” to begin!',
  webNewUserPremiumMessageSmartNotes:
    'Try out live transcription and get Smart Notes in real time. Study with unlimited quizzes and flashcards that are all automatically created from the content you add to your notes, just tap “Learn” to begin!',
  webPlusFeaturesList: 'Automatic audio transcription\nComprehensive notes summaries\nIntelligent, progressive quizzes',
  webRenderer: 'Web Renderer',
  webSubscriptionAutoRenew: 'Your subscription will auto-renew on {{date}}',
  webSurvey: 'Take the survey',
  webSurveyHeader: 'Personalize your experience',
  webSurveyMessage:
    'Take the personalization survey to help us understand your goals and needs in using Notability. Your feedback will help guide our development efforts to deliver relevant features and updates.',
  webTrialEndedDate: 'Your free trial ended {{date}}',
  weCouldNotRedirectCancelSubscription:
    'We could not redirect you to cancel your subscription. Please refresh the page and try again, or contact Support.',
  weCouldNotRedirectChangeSubscription:
    'We could not redirect you to change your subscription. Please refresh the page and try again, or contact Support.',
  weCouldNotRedirectResubscribe:
    'We could not redirect you to resubscribe. Please refresh the page and try again, or contact Support.',
  weCouldNotRedirectUpdatePaymentMethod:
    'We could not redirect you to update your payment method. Please refresh the page and try again, or contact Support.',
  weeklyPlannerText:
    'Take inspiration from this weekly planner on ways you can keep track of your time and boost your productivity!',
  weeklyPlannerTitle: 'Weekly Planner',
  welcomeBack: 'Welcome back',
  welcomeCardHeader: 'Get inspired. Inspire others.',
  welcomeCardSubtext: 'Great ideas are meant for sharing. Browse, search and publish amazing content, created by you.',
  welcomeExclamation: 'Welcome!',
  welcomeHeader: 'Great ideas are meant for sharing.',
  welcomeSubcopy: 'Start with either one',
  welcomeSubtext: 'Browse and save study materials, project ideas, journaling prompts, and more—find your inspiration!',
  welcomeToClassicEmailSubject: 'Welcome to Classic',
  welcomeToClassicEmailWelcomeMessage:
    'You now have access to unlimited note-taking with your one-time purchase! Make the most of your plan with powerful handwriting and collaboration features.',
  welcomeToLiteEmailSubject: 'Welcome to Lite',
  welcomeToLiteEmailWelcomeMessage:
    'You now have access to unlimited note-taking with your Lite purchase! Make the most of your plan with powerful handwriting and collaboration features.',
  welcomeToNotability: "Let's get you studying",
  welcomeToNotabilityBusinessEmailCtaButton1: 'Open Notability',
  welcomeToNotabilityBusinessEmailHeader: 'Download the Notability App',
  welcomeToNotabilityBusinessEmailHeroHeading: 'Welcome to Notability for Business',
  welcomeToNotabilityBusinessEmailIOSApp: 'iOS App',
  welcomeToNotabilityBusinessEmailMessage:
    'You now have access to everything Notability has to offer for you and your team! Collaborate with your team to take notes your way, share across devices, and record meetings to get instant summaries.',
  welcomeToNotabilityBusinessEmailSubject: 'Welcome to Notability for Business!',
  welcomeToNotabilityEmailBodyCopy:
    "If you ever need tips, inspiration, or a helping hand, we've got you. Follow us on social for tips and inspiration, or contact our support team if you have questions. We can't wait to see what you create.",
  welcomeToNotabilityEmailCtaButton1: 'Create my first note',
  welcomeToNotabilityEmailCtaButton2: 'Start Exploring',
  welcomeToNotabilityEmailCtaHeading: 'Ready to get started?',
  welcomeToNotabilityEmailFeature1Desc:
    'Start fresh with a blank page and make it yours with handwriting, typing, highlights, or doodles.',
  welcomeToNotabilityEmailFeature1Title: 'Create your first note',
  welcomeToNotabilityEmailFeature2Desc: 'Bring in a PDF, slides, or worksheet and annotate it like a pro.',
  welcomeToNotabilityEmailFeature2Title: 'Upload a document',
  welcomeToNotabilityEmailFeature3Desc:
    'Sync audio with your notes, then Notability transcribes and summarizes the key points for you.',
  welcomeToNotabilityEmailFeature3Title: 'Record a lecture or a meeting',
  welcomeToNotabilityEmailFeature4Desc:
    'Turn notes into study tools with summaries, quiz questions, and more. Your future self will thank you.',
  welcomeToNotabilityEmailFeature4Title: 'Try Notability Learn',
  welcomeToNotabilityEmailFeature5Desc: "Jump in on your iPad, iPhone, or laptop. We'll keep everything in sync.",
  welcomeToNotabilityEmailFeature5Title: 'Use Notability anywhere',
  welcomeToNotabilityEmailHeroBody:
    "Whether you're taking notes in class, prepping for a meeting, or organizing your life brain-dump-style, Notability is here to make it all feel effortless (and maybe even a little fun).",
  welcomeToNotabilityEmailHeroHeading: 'Welcome to Notability',
  welcomeToNotabilityEmailHeroSubheading: "We're so glad you're here.",
  welcomeToNotabilityEmailPs: 'P.S. Your best notes are the ones you actually start. Go make one!',
  welcomeToNotabilityEmailSignOff: 'Happy note-taking,',
  welcomeToNotabilityEmailSubject: 'Welcome to Notability!',
  welcomeToNotabilityEmailTeamName: '— The Notability Team 💙',
  welcomeToNotabilityEmailTestimonial1:
    '"Everything I need in one place. Easy to learn, easy to customize, and I finally am able to keep all my thoughts, ideas, plans, aspirations, notes, recipes"',
  welcomeToNotabilityEmailTestimonial2:
    '"I tried a few different note apps for the iPad and this one is by far the best. Adding a paper like screen protector and I never feel the need to use a regular notebook again."',
  whatDoYouNeedHelpWithToday: 'What do you need help with today?',
  whatIsNotabilityCloud: 'What is Notability Cloud?',
  whatIsNotabilityCloudAnswer:
    "Notability Cloud keeps your notes synced and available across supported devices when you're signed in to the same Notability account. It's separate from third-party backups (like iCloud or Google Drive).<br/><br/><Bold>On your iPad/iPhone:</Bold><br/><br/>• Go to Settings → Account.<br/>• Look for Notability Cloud.<br/><br/>If you see an option for Notability Cloud, your device isn't synced yet. Notes backed up only with a third-party service (like iCloud, Google Drive, Dropbox, OneDrive, Box, or WebDAV) won't appear on Notability Web.",
  whichAccountAmISignedInWith: 'Which account am I signed in with?',
  whichAccountAmISignedInWithAnswer:
    "<Bold>You can check the email you're using on each platform:</Bold><br/><br/><Bold>On Notability Web</Bold><br/>• Go to Settings → Account.<br/>• Check the email shown at the top.<br/><br/><Bold>On iPad/iPhone</Bold><br/>• Open Notability and go to Settings → Account.<br/>• Check the email shown there.<br/><br/>If the emails don't match, sign out on the device using the wrong email, then sign in with the matching one. If you see \"Sign in to Notability\" on iPad/iPhone, you're signed out. Sign in using the same email you use on Notability Web. Your notes on the device will stay on your device.",
  whichOfTheseIssuesAppliesToYou: 'Which of these issues applies to you?',
  whiteboardPrintUnavailable: "Whiteboards can't be printed. Export as PDF instead.",
  whiteboardUnsupportedOnDeviceBody: 'Open this whiteboard on iPad to view and edit it.',
  whiteboardUnsupportedOnDeviceTitle: "Whiteboards aren't available on this device yet",
  wholeEraser: 'Whole',
  windows: 'Windows',
  workspaceInviteEmailAccept: 'Open Notability',
  workspaceInviteEmailMessage:
    '{{referrer}} has added you to the the shared library <b>{{workspaceName}}</b>. You can now access all the notes within the library. <br><br> Happy Collaborating!',
  workspaceInviteEmailSubject: '{{referrer}} has shared a library with you: {{workspaceName}}',
  workspaceNameIsInvalidError: 'Invalid Shared Library name. Modify Shared Library name and try again.',
  workspaceNotFoundError: 'Workspace not found.',
  Yearly: 'Yearly',
  yes: 'Yes',
  yesterday: 'Yesterday',
  'You are not the owner of this shared note': 'You are not the owner of this shared note',
  'You cannot add the same tag or a topic in the tags field.':
    'You cannot add the same tag or a topic in the tags field.',
  'You have uploaded the maximum number of notes for your account':
    'You have uploaded the maximum number of notes for your account',
  'You must verify your email address before creating a note link':
    'You must verify your email address before creating a note link',
  youAreSubscribedToNotability: 'You are subscribed to Notability.',
  youCanJumpBetweenAndRevisitFormats: 'You can jump between and revisit formats at any time as you learn.',
  youCanStillViewYourNotes: 'You can still view your notes. Contact us if you have questions.',
  youDidIt: 'You did it!',
  youLearnedAllQuestions: 'You learned all {{count}} questions',
  'Your email has been successfully verified.': 'Your email has been successfully verified.',
  'Your password has been changed successfully.': 'Your password has been changed successfully.',
  yourBusinessSubscriptionIsInactive: 'Your business subscription is inactive',
  yourEmailAddress: 'Your email address',
  yourEmailAddressIsRequired: 'Your email address is required.',
  yourIssueWas: 'Your issue was successfully submitted.',
  yourLimitWillRestDate: 'Your limit will reset on {{date}}',
  yourNameIsRequired: 'Your name is required.',
  yourNameOptional: 'Your name (optional)',
  yourNameWasSuccessfullyUpdated: 'Your name was successfully updated.',
  yourNotabilityPlusTrialExpired: 'Your Notability Plus trial has expired',
  yourOrganizationsName: "Your organization's name",
  yourSubscriptionIsInactive:
    'Your subscription is inactive. Update your billing information to continue using {{tierName}}.',
  yourSubscriptionWillEndOn: 'Your subscription will end on {{date}}.',
  youTubeFooterAlt: 'Notability YouTube link',
  youtubeHomeImportPlaceholder: 'Paste your YouTube video to create a summary and quiz',
  youtubeImportActiveDescription: 'Creating note with transcript',
  youtubeImportActiveTitle: 'Importing from YouTube...',
  youtubeImportCompleteTitle: 'YouTube Import Complete',
  youtubeImportDescription: 'YouTube video',
  youtubeImportError: 'Error Importing from YouTube',
  youtubeImportPlaceholder: 'Paste video URL',
  youtubePlayer: 'YouTube video player',
  youtubeServiceName: 'YouTube',
  youtubeTranscriptImport: 'Paste transcript to note',
  youtubeTranscriptsUpsellDescription:
    'Import YouTube transcripts and turn them into a study guide with summaries and quizzes. Use chat to ask specific questions.',
  youtubeTranscriptsUpsellHeader: 'Upgrade to Pro and learn with YouTube',
  youtubeURL: 'YouTube URL',
  youtubeUrlHandleLengthError: 'Youtube URL must be fewer than {{maxLength}} characters long.',
  youtubeUrlPrefixError: 'Please enter a valid YouTube URL',
  youtubeVideo: 'Youtube video',
  youtubeVideoNotFound: 'YouTube video not found. Please check the URL and try again.',
  youtubeVideoNoTranscript: 'This video has no available transcript',
  youveAnsweredNumQuestions_one: "<baseFormat>You've answered </baseFormat><boldFormat>1 question.</boldFormat>",
  youveAnsweredNumQuestions_other:
    "<baseFormat>You've answered </baseFormat><boldFormat>{{count}} questions.</boldFormat>",
  youveCanceledYourSubscription:
    "You've canceled your subscription. You'll be able to re-subscribe when your subscription ends.",
  youveStudiedForTimeHours_one:
    "<baseFormat>You've studied this note for </baseFormat><boldFormat>1 hour.</boldFormat>",
  youveStudiedForTimeHours_other:
    "<baseFormat>You've studied this note for </baseFormat><boldFormat>{{count}} hours.</boldFormat>",
  youveStudiedForTimeMinutes_one:
    "<baseFormat>You've studied this note for </baseFormat><boldFormat>1 minute.</boldFormat>",
  youveStudiedForTimeMinutes_other:
    "<baseFormat>You've studied this note for </baseFormat><boldFormat>{{count}} minutes.</boldFormat>",
  zoom: 'Zoom',
  zoomIn: 'Zoom in',
  zoomLevel: 'Zoom level',
  zoomOut: 'Zoom out',
  zoomTo100: 'Zoom to 100%',
  zoomToast: 'Zoom: {{percent}}%'
} as const
